/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useRef, useCallback } from "react";
import styles from "./SelfAssesment.module.css";
import { URL, URLPlan, HOME_VIDEO, LOGO, ZONES, SKELETON, SKELETON_PLACEHOLDER, CPG_OPTIONS, BACK_CPG_OPTIONS, testMap, negativeTestMap, activityLevels, testSpecificIntroVideos, DEFAULT_INTRO_VIDEO, messaging, BETA_URL, floorOptions, balanceOptions, scheduleTimeOptions, sessionOptions, scheduleDaysOptions, goalOptions, SeatedTrunkRotation, CLINICAL_PATHS, HOME_VIDEO_2 } from "./CONSTANTS";
import { useProgress } from "./progressContext";
import { useHistory } from "react-router-dom";
import { useAssessment } from "./AssessmentContext"; // Assuming AssessmentProvider is exported
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { GoalsMultiSelect, ProgressChecklist } from "./AssesmentGoals";
import { modalState } from "../voice-agent/InactivityModalState";
import VoiceService from "../voice-agent/VH-Myra-FrontEnd";

import RecoveryService from "../../services/CrashRecoveryService";

var subDomain = "api";
if (window.location.host !== "www.startfreept.com" && window.location.host !== "startfreept.com") {
  subDomain = "uatapi";
}

// ANALYTICS: Define the base URL for the new analytics API endpoint.
const ANALYTICS_API_URL = "https://" + subDomain + ".virdiohealth.com/api/v1/assessment";

window.trSessionId = localStorage.getItem("trSessionId") || "";

// ANALYTICS: Create a helper service to manage all analytics API calls.
const AnalyticsService = {
  /**
   * Starts a new analytics session when the user first lands on the page.
   * @returns {Promise<string|null>} The unique session ID from the backend, or null on failure.
   */
  startSession: async () => {
    if (window.trSessionId || localStorage.getItem("trSessionId")) {
      return window.trSessionId || localStorage.getItem("trSessionId");
    }
    try {
      function getDeviceType() {
        const ua = navigator.userAgent;
        if (/iPad|Tablet|Nexus 7|Nexus 10|SM-T|Tab/i.test(ua)) {
          return "tablet";
        }
        if (/Mobi|Android|iPhone|iPod|Phone/i.test(ua)) {
          return "mobile";
        }
        return "desktop";
      }
      const payload = {
        event: "session_start",
        device_info: navigator.userAgent,
        session_start_time: new Date().toISOString(),
        front_ip: window.backupIP || "",
        device_type: getDeviceType(),
      };
      // In a real implementation, you might also get location data here.

      const response = await fetch(`${ANALYTICS_API_URL}/session`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!response.ok) throw new Error("Failed to start session");

      const data = await response.json();
      console.log("Analytics session started:", data.session_id);
      localStorage.setItem("trSessionId", data.session_id);
      window.trSessionId = data.session_id;

      return data.session_id; // The backend should return the new session ID.
    } catch (error) {
      console.error("AnalyticsService.startSession Error:", error);
      return null;
    }
  },

  /**
   * Tracks a specific step in the user's journey.
   * @param {object} assessmentData - The complete, current state of the user's assessment answers.
   */
  trackStep: async (assessmentData, callback) => {
    window.trSessionId = window.trSessionId || localStorage.getItem("trSessionId") || "";

    assessmentData.analyticsId = window.trSessionId;

    if (!window.trSessionId) {
      console.warn("AnalyticsService.trackStep: No session ID provided.");
      return;
    }
    try {
      let enhancedData = { ...assessmentData };
      if (window.timeTracker) {
        const currentGSADuration = window.timeTracker.getGSADuration();
        if (currentGSADuration !== null) {
          enhancedData.gsaDurationSec = currentGSADuration;
          console.log(`Current GSA duration: ${currentGSADuration} seconds`);
        }
      }
      const payload = {
        session_id: window.trSessionId,
        assessment_data: enhancedData,
        session_last_update: new Date().toISOString(),
        front_ip: window.backupIP || "",
      };

      // This is a "fire-and-forget" call. We don't need to wait for the response.
      fetch(`${ANALYTICS_API_URL}/track`, {
        method: "POST", // Use PUT or PATCH to update the existing session record.
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      }).then((resp) => {
        console.log(`Analytics event tracked for session ${window.trSessionId}:`, assessmentData);
        if (callback) {
          callback();
        }
      });
    } catch (error) {
      console.error("AnalyticsService.trackStep Error:", error);
    }
  },
  saveFullData: async (fullData) => {
    window.trSessionId = window.trSessionId || localStorage.getItem("trSessionId") || "";

    if (!window.trSessionId) {
      console.warn("AnalyticsService.saveFullData: No session ID found.");
      return;
    }

    try {
      const payload = {
        session_id: window.trSessionId,
        fullData,
      };

      const response = await fetch(`${ANALYTICS_API_URL}/fulldata`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      console.log("Full data saved:", data);
      return data;
    } catch (error) {
      console.error("AnalyticsService.saveFullData Error:", error);
    }
  },
};
// Add this utility at the top of your homescreen.jsx or create a separate file
class TimeTracker {
  constructor() {
    this.landingStartTime = null;
    this.gsaStartTime = null;
  }

  // Call this when landing page loads
  startLandingTimer() {
    this.landingStartTime = Date.now();
    console.log("Landing timer started");
  }

  // Call this when user clicks "Start GSA"
  startGSATimer() {
    this.gsaStartTime = Date.now();
    console.log("GSA timer started");

    // Also calculate time spent on landing
    if (this.landingStartTime) {
      const landingDurationSec = Math.round((this.gsaStartTime - this.landingStartTime) / 1000);
      return {
        gsaStartedAt: new Date().toISOString(),
        timeOnLandingSec: landingDurationSec,
      };
    }

    return {
      gsaStartedAt: new Date().toISOString(),
      timeOnLandingSec: null,
    };
  }

  // Call this on each screen to get updated GSA duration
  getGSADuration() {
    if (!this.gsaStartTime) return null;
    return Math.round((Date.now() - this.gsaStartTime) / 1000);
  }

  // Reset all timers (when user restarts)
  reset() {
    this.landingStartTime = null;
    this.gsaStartTime = null;
  }
}

// Create global instance
window.timeTracker = new TimeTracker();

// Add this to your homescreen.jsx or utilities
class ScreenFlowTracker {
  constructor() {
    this.screenFlow = [];
  }

  // Call when entering a screen
  enterScreen(screenName) {
    const entry = {
      screen: screenName,
      enteredAt: new Date().toISOString(),
      completed: false,
    };
    this.screenFlow.push(entry);
    console.log(`Entered screen: ${screenName}`);
    return entry;
  }

  // Call when completing/exiting a screen
  exitScreen(screenName, options = {}) {
    const screen = this.screenFlow.find((s) => s.screen === screenName && !s.completed);
    if (screen) {
      screen.completed = options.completed || true;
      screen.exitedAt = new Date().toISOString();

      // Add optional exit reason
      if (options.exitReason) {
        screen.exitReason = options.exitReason;
      }

      console.log(`Exited screen: ${screenName}`, options);
    }
    return screen;
  }

  // Get current screen flow data
  getScreenFlow() {
    return [...this.screenFlow];
  }

  // Reset for new session
  reset() {
    this.screenFlow = [];
  }
}

// Create global instance
window.screenTracker = new ScreenFlowTracker();

// custom hook which will scroll to top when component mounts
const useScrollToTop = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
};

export const InactivityModalManager = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Subscribe to modal state changes
    const unsubscribe = modalState.subscribe((visible) => {
      setIsVisible(visible);
    });

    // Listen for VoiceService events
    const handleShowModal = () => {
      modalState.show();
    };

    document.addEventListener("showInactivityModal", handleShowModal);

    return () => {
      unsubscribe();
      document.removeEventListener("showInactivityModal", handleShowModal);
    };
  }, []);

  const handleClose = () => {
    modalState.hide();

    // Dispatch resume event for other components
    document.dispatchEvent(
      new CustomEvent("inactivityModalResume", {
        detail: { timestamp: Date.now() },
      }),
    );
  };

  return <InactivityModal isVisible={isVisible} onClose={handleClose} />;
};

export const InactivityModal = ({ isVisible, onClose }) => {
  // Handle ESC key
  useEffect(() => {
    if (!isVisible) return;

    const handleEsc = (e) => {
      if (e.key === "Escape") onClose();
    };

    document.addEventListener("keydown", handleEsc);
    // Prevent background scrolling
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", handleEsc);
      document.body.style.overflow = "";
    };
  }, [isVisible, onClose]);

  // Don't render if not visible
  if (!isVisible) return null;

  // Handle overlay click (click outside modal)
  const handleOverlayClick = (e) => {
    const inactivityData = {
      type: "RESET_INACTIVITY",
      data: { action: "RESET_INACTIVITY" },
    };

    if (window.mayraCode && VoiceService._ws && VoiceService._ws.readyState === WebSocket.OPEN) {
      VoiceService._ws.send(JSON.stringify(inactivityData));
    }
    if (window.mayraCode) {
      window.mayraCode.doSay("Great! We'll pick up right where we left off.", () => {
        if (e.target === e.currentTarget) {
          VoiceService.resumeCompletely();
          onClose();
        }
      });
    }
  };

  return (
    <div className={styles.InactivityModalOverlay} onClick={handleOverlayClick}>
      <div className={styles.InactivityModalModal}>
        <h2 className={styles.InactivityModalHeading}>I have paused...</h2>
        <button className={styles.InactivityModalButton} onClick={onClose}>
          Resume
        </button>
      </div>
    </div>
  );
};

export const usePreventNavigation = (redirectPath) => {
  const history = useHistory();
  useEffect(() => {
    const handlePopState = (e) => {
      window.location.replace("/");
    };

    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [history, redirectPath]);
};

export const RestartPopup = () => {
  const [visible, setVisible] = useState(false);
  let userName = localStorage.getItem("self_name") || "";

  useEffect(() => {
    const popup = document.getElementById("restartPopup");
    if (!popup) return;

    // Observe style changes
    const observer = new MutationObserver(() => {
      const isVisible = popup.style.display !== "none";
      setVisible(isVisible);
    });

    observer.observe(popup, { attributes: true, attributeFilter: ["style"] });

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (visible && window.mayraCode) {
      window.mayraCode.doSay(`${userName}, I noticed you weren't able to complete all 10 reps of that test. That's completely okay — it just means this program may not be the right fit right now. For your safety, the best next step is to check in with a licensed provider who can guide you in person.`);
    }
  }, [visible, userName]);

  return (
    <div
      id="restartPopup"
      style={{
        display: "none",
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.5)",
        zIndex: 9999,
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          background: "#fff",
          padding: "20px",
          borderRadius: "8px",
          textAlign: "center",
          width: "300px",
        }}
      >
        <h3
          style={{
            marginBottom: "15px",
            fontSize: "18px",
            fontWeight: 600,
          }}
        >
          Assessment Ended
        </h3>
        <p style={{ marginBottom: "20px" }}>{userName}, I noticed you weren't able to complete all 10 reps of that test. That's completely okay — it just means this program may not be the right fit right now. For your safety, the best next step is to check in with a licensed provider who can guide you in person.</p>
        <button
          id="restartOkBtn"
          style={{
            padding: "10px 20px",
            background: "#0d9488",
            border: "none",
            borderRadius: "6px",
            color: "white",
            cursor: "pointer",
          }}
        >
          OK
        </button>
      </div>
    </div>
  );
};
const LandingPageModal = ({ message, onCancel, onGrant, setIsMicModalActive, access = true, setAccess, setMicModalMsg }) => {
  const handleOk = () => {
    setIsMicModalActive(false);
    setMicModalMsg("To chat with Myra, please grant microphone access. Your audio is processed in real-time and never stored or recorded.");
    setAccess(true);
  };
  return (
    <div id="myra-alert-overlay" className={styles.myraAlertOverlay}>
      <div className={styles.myraAlertModal}>
        <div className={styles.myraAlertIcon}>
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="32" height="32">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z" />
          </svg>
        </div>

        <p id="myra-alert-message" className={styles.myraAlertMessage}>
          {message}
        </p>

        <div id="myra-alert-buttons" className={styles.myraAlertButtons}>
          {access && (
            <button id="myra-alert-secondary" className={styles.myraAlertBtnSecondary} onClick={onCancel}>
              Cancel
            </button>
          )}

          {access ? (
            <button id="myra-alert-primary" className={styles.myraAlertBtnPrimary} onClick={onGrant}>
              Grant Access
            </button>
          ) : (
            <button id="myra-alert-primary" className={styles.myraAlertBtnPrimary} onClick={handleOk}>
              Ok
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
// home header component
const CustomHeader = ({ isStartedLandingFlow }) => {
  const history = useHistory();

  const isUAT = typeof window !== "undefined" && window.location.hostname === "virdio-ar.weborik.com";

  // TEMPORARY: stress test state
  const [isStressTesting, setIsStressTesting] = useState(false);

  // TEMPORARY: Toggle stress test function
  const toggleStressTest = () => {
    if (isStressTesting) {
      RecoveryService.stopStressTest();
      setIsStressTesting(false);
      console.log("Header: Stress test stopped manually.");
    } else {
      const confirmStart = window.confirm("Warning: This will consume high RAM and GPU to simulate a crash. Proceed?");
      if (confirmStart) {
        RecoveryService.startStressTest();
        setIsStressTesting(true);
        console.log("Header: Stress test started manually.");
      }
    }
  };

  const handleButtonClick = () => {
    if (isStartedLandingFlow) {
      if (window.mayraCode) {
        window.mayraCode.setIsVisible(false);
        window.mayraCode.forceStop();

        // Completely destroy the VoiceService instance
        VoiceService.destroyMyraCompletely(false);
        // Clear global references
        window.mayraCode = null;
        window.startFlow = null;
        window.currentCommandsAudio = {};
      }
      sessionStorage.removeItem("voiceService_wasListening");
      sessionStorage.removeItem("voiceService_currentFlow");
    }

    if (window.preloadAllAudios) {
      window.preloadAllAudios();
    }
    if (window.videoUnlockPlay) {
      window.videoUnlockPlay();
    }

    window.isThisFromHomeScreen = false;

    setTimeout(() => {
      if (!window.isFlutterLoaded) {
        const loader = document.getElementById("flutter-loader");
        if (loader) loader.style.display = "flex";
        const loaderText = loader.querySelector("#loader-text");
        if (loaderText) loaderText.textContent = "Loading application...";
      }
      const flutterRoot = document.getElementById("OnDemandPlayingRoot");
      if (flutterRoot) flutterRoot.style.display = "block";

      const currentAssessmentRoot = document.getElementById("assesmentDiv");
      if (currentAssessmentRoot) currentAssessmentRoot.style.display = "none";

      localStorage.removeItem("loadSelf");
      localStorage.removeItem("startedSelf");

      window.doNextLocation = history;
      document.querySelector("html").classList = [];

      setTimeout(() => {
        window.setHideElementsElm(true);
      }, 2000);
    }, 100);
  };
  return (
    <header className={styles.customHeader}>
      <div className={styles.customContainer}>
        <div className={styles.logoContainer}>
          <a href="https://www.virdiohealth.com" target="_blank" rel="noopener noreferrer" title="Virdio Health">
            <img
              className={styles.logoImage}
              src="https://virdiodev.s3.us-east-2.amazonaws.com/sampleVideo/LogoPNG.png"
              alt="Virdio Health Logo"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "https://placehold.co/128x32/e2e8f0/475569?text=Logo";
              }}
            />
          </a>
        </div>

        <nav className={styles.navLinks}>
          <button className={styles.navLink} onClick={() => document.getElementById("why-us")?.scrollIntoView({ behavior: "smooth" })}>
            Why Try This
          </button>

          <button className={styles.navLink} onClick={() => document.getElementById("how-it-works")?.scrollIntoView({ behavior: "smooth" })}>
            How It Works
          </button>

          {/* TEMPORARY: Stress Test Button */}
          {isUAT && (
            <>
              {/* TEMPORARY: Stress Test Button */}
              <button
                className={`${styles.navLink} ${isStressTesting ? styles.activeTest : ""}`}
                onClick={toggleStressTest}
                style={{
                  color: isStressTesting ? "red" : "inherit",
                  fontWeight: isStressTesting ? "bold" : "normal",
                }}
              >
                {isStressTesting ? "Stop Stress Test" : "Start Stress Test"}
              </button>
            </>
          )}
        </nav>

        <div className={styles.loginButtonContainer}>
          <button className={styles.loginButton} onClick={handleButtonClick}>
            Member Login
          </button>
        </div>
      </div>
    </header>
  );
};

// home hero heading text component
const HomeHeroComponent = () => {
  return (
    <section id="assessment-section" className={styles.homeHCHeroSection}>
      <div className={styles.homeHCHeroContainer}>
        <div className={styles.homeHCTextContainer}>
          {/* <h1 className={styles.homeHCHeroHeading}>
            Your Path to Relief Starts with <span className={styles.homeHCHighlightText}>Understanding Your Pain.</span>
          </h1> */}
          <div className={styles.heroTopHeading}>
            <h1>
              Start your recovery in minutes — <span className={styles.heroHighlight}>free, personalized, and simple.</span>
            </h1>
            <p className={styles.heroSubheadingText}>In about 10 minutes, Myra, your AI-powered recovery coach from Virdio Health, walks you through a simple, gentle self-assessment to help you understand your movement, uncover what's holding you back, and create a personalized recovery plan.</p>
          </div>
          {/* <p className={styles.homeHCHeroSubheading}>
            Start now, wherever you are, with Myra, your AI-powered assistant to guide you right on your device, for free.
            <div id="topstartstep"></div>
          </p> */}
        </div>
      </div>
    </section>
  );
};
const TalkToMyraHomeSection = ({ handleMyraClick }) => {
  const talkMyraRef = useRef(null);
  const myraFloatRef = useRef(null);
  const { resetAssessmentData, isMyRAIsActive, setIsMyRAIsActive } = useAssessment();

  // Scroll logic: show floating Myra button when main button leaves viewport
  useEffect(() => {
    const handleScroll = () => {
      if (!talkMyraRef.current || !myraFloatRef.current) return;

      const rect = talkMyraRef.current.getBoundingClientRect();

      if (rect.bottom < 0) {
        myraFloatRef.current.classList.add(styles.visible);
      } else {
        myraFloatRef.current.classList.remove(styles.visible);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return (
    <>
      <section id="talk-to-myra" className={styles.talkMyraSection}>
        <div className={styles.talkMyraContainer}>
          <div className={styles.talkMyraContent}>
            <div className={styles.talkMyraIcon}>
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="32" height="32">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"></path>
              </svg>
            </div>
            <div className={styles.talkMyraText}>
              <h2 className={styles.talkMyraHeading}>Talk to Myra, your AI-powered recovery coach, before you begin.</h2>
              <p className={styles.talkMyraDesc}>Not sure what to expect? Myra is here to answer your questions, ease your concerns, and help you feel confident about taking the first step.</p>
            </div>
          </div>
          <div className={styles.talkMyraQuestions}>
            <p className={styles.talkMyraQLabel}>You can ask her things like:</p>
            <ul className={styles.talkMyraQList}>
              <li>What happens during the assessment</li>
              <li>How the movements feel</li>
              <li>How the camera works</li>
              <li>Any other questions on your mind</li>
            </ul>
          </div>
          <div className={styles.talkMyraAction}>
            <button onClick={handleMyraClick} id="talk-myra-btn" className={styles.talkMyraButton} ref={talkMyraRef}>
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="20" height="20">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z"></path>
              </svg>
              Talk to Myra
            </button>
            <p className={styles.talkMyraReassure}>Tap the mic to talk to Myra. She's here to make sure everything feels simple, safe, and manageable.</p>
          </div>
        </div>
      </section>
      {/* FLOATING MYRA BUTTON  */}
      <button id="myra-float" onClick={handleMyraClick} ref={myraFloatRef} className={styles.myraFloatButton}>
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="24" height="24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"></path>
        </svg>
        <span>Ask Myra</span>
      </button>
    </>
  );
};

const HomeBottomContent = ({ doShowStep, handleMyraClick }) => {
  return (
    <>
      <section id="how-it-works" className={styles.HomeBtmConHowWorks}>
        <div className={styles.HomeBtmConContainer}>
          <div className={styles.HomeBtmConCenterText}>
            <h2 className={styles.HomeBtmConSubHeading}>How It Works</h2>
            <p className={styles.HomeBtmConTitle}>Your recovery starts in three simple steps.</p>
          </div>
          <div className={styles.HomeBtmConStepsGrid}>
            <div className={styles.HomeBtmConStep}>
              <div className={styles.stepCardExpanded}>
                <div className={styles.stepCardHeader}>
                  <div>
                    <span className={styles.HomeBtmConStepNumber}>1</span>
                  </div>
                  <h3 className={styles.HomeBtmConStepTitle}>Take your guided self-assessment.</h3>
                  <p className={styles.HomeBtmConStepDesc}>Myra will walk you through a few questions and two short movement tests using your device's camera.</p>
                </div>
                <ul className={styles.stepDetails}>
                  <li>There's no special setup or equipment, just follow her voice.</li>
                  <li>These movements are simple and gentle.</li>
                </ul>
              </div>
            </div>
            <div className={styles.HomeBtmConStep}>
              <div className={styles.stepCardExpanded}>
                <div className={styles.stepCardHeader}>
                  <div>
                    <span className={styles.HomeBtmConStepNumber}>2</span>
                  </div>
                  <h3 className={styles.HomeBtmConStepTitle}>Get your personalized recovery plan.</h3>
                  <p className={styles.HomeBtmConStepDesc}>Your plan is based on how you move and how things feel.</p>
                </div>
                <ul className={styles.stepDetails}>
                  <li>Myra will explain why each activity was chosen and how it helps.</li>
                </ul>
              </div>
            </div>
            <div className={styles.HomeBtmConStep}>
              <div className={styles.stepCardExpanded}>
                <div className={styles.stepCardHeader}>
                  <div>
                    <span className={styles.HomeBtmConStepNumber}>3</span>
                  </div>
                  <h3 className={styles.HomeBtmConStepTitle}>Start your first free week.</h3>
                  <p className={styles.HomeBtmConStepDesc}>Follow short, guided sessions where Myra talks you through each step, and Augmented Reality targets show you exactly where to move.</p>
                </div>
                <ul className={styles.stepDetails}>
                  <li>Your Recovery Compass Score updates automatically after every session, helping you track your progress and stay motivated.</li>
                </ul>
              </div>
            </div>
          </div>
          <div className={styles.howWorksReassurance}>
            <p className={styles.reassuranceLine}>Myra stays with you from your first question to your last rep, so you're never alone in your recovery.</p>
            <button onClick={handleMyraClick} className={styles.askMyraLink}>
              Want to know more about why StartFreePT works? Ask Myra.
            </button>
          </div>
        </div>
      </section>
      {/* Why Try This Section */}
      <section id="why-us" className={styles.whyWorksSection}>
        <div className={styles.HomeBtmConContainer}>
          <div className={styles.HomeBtmConCenterText}>
            <h2 className={styles.HomeBtmConSubHeading}>Why StartFreePT Works</h2>
            <p className={styles.HomeBtmConTitle}>Guided, adaptive, and built around how you move.</p>
          </div>
          <div className={styles.whyWorksGrid}>
            {/* <!-- Feature 1: AR Targets --> */}
            <div className={styles.whyWorksCard}>
              <div className={styles.whyWorksIconWrap}>
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="28" height="28">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z"></path>
                </svg>
              </div>
              <h3 className={styles.whyWorksTitle}>Augmented Reality targets that guide your motion.</h3>
              <p className={styles.whyWorksDesc}>See clear visual targets on your screen that show you where to move, how far, and when to return. They turn each repetition into an interactive experience, with light sound and animation that help you stay engaged and on track.</p>
            </div>
            {/* <!-- Feature 2: Audio Guidance --> */}
            <div className={styles.whyWorksCard}>
              <div className={styles.whyWorksIconWrap}>
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="28" height="28">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.536 8.464a5 5 0 010 7.072m2.828-9.9a9 9 0 010 12.728M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z"></path>
                </svg>
              </div>
              <h3 className={styles.whyWorksTitle}>Clear audio guidance and pacing from Myra.</h3>
              <p className={styles.whyWorksDesc}>Myra tells you how to set up, when to start, and when to hold or return. She counts each rep out loud and keeps the session flowing, so you don't have to watch a timer or keep track of anything.</p>
            </div>
            {/* <!-- Feature 3: Adaptive Plan --> */}
            <div className={styles.whyWorksCard}>
              <div className={styles.whyWorksIconWrap}>
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="28" height="28">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
                </svg>
              </div>
              <h3 className={styles.whyWorksTitle}>An adaptive plan that changes as you do.</h3>
              <p className={styles.whyWorksDesc}>If something feels too hard, too easy, or uncomfortable, the plan adjusts to keep you safe and progressing steadily.</p>
            </div>
            {/* <!-- Feature 4: Daily Rhythm --> */}
            <div className={styles.whyWorksCard}>
              <div className={styles.whyWorksIconWrap}>
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="28" height="28">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
              </div>
              <h3 className={styles.whyWorksTitle}>A simple daily rhythm.</h3>
              <p className={styles.whyWorksDesc}>Short sessions. Clear goals. Encouraging feedback. Designed to fit real life — even on tough days.</p>
            </div>
          </div>
        </div>
      </section>
      {/*free week section  */}
      <section id="free-week" className={styles.freeWeekSection}>
        <div className={styles.freeWeekContainer}>
          <div className={styles.freeWeekBadge}>Free Trial</div>
          <h2 className={styles.freeWeekHeading}>Try the full experience for a week — completely free.</h2>
          <p className={styles.freeWeekDesc}>You'll get guided sessions, Augmented Reality cues, a personalized plan, and your Recovery Compass Score.</p>
          <p className={styles.freeWeekNoCreditCard}>No credit card required.</p>
          <div className={styles.freeWeekTagline}>
            <p>Start free. See how it feels. Continue only if it helps.</p>
          </div>
          <button className={styles.askMyraLink} onClick={handleMyraClick}>
            Want to know more? Ask Myra.
          </button>
        </div>
      </section>
      {/* Final CTA Section */}
      <section className={styles.HomeBtmConCTASection}>
        <div className={styles.HomeBtmConCTAWrap}>
          <h2 className={styles.HomeBtmConCTATitle}>
            <span>Ready to feel better? Start your free assessment.</span>
          </h2>
          <p className={styles.HomeBtmConCTADesc}>Myra will guide you every step of the way. You're always in control.</p>
          <p className={styles.ctaReassurance}>No commitment. No download. No stress.</p>
          <button
            className={styles.HomeBtmConCTAButton}
            onClick={() => {
              doShowStep();
            }}
          >
            Start My Free Assessment
          </button>
        </div>
      </section>
    </>
  );
};

// custom Button Component
const CommonButton = ({ onClick, disabled, title, className }) => {
  return (
    <button onClick={onClick} disabled={disabled} className={`${className} ${styles.commonButton} ${disabled ? styles.disabledButton : ""}`}>
      {title}
    </button>
  );
};

// Custom Header Component

const Header = ({ showIcon = true, showProgress = true }) => {
  const history = useHistory();
  const [showExitModal, setShowExitModal] = useState(false);
  const { resetAssessmentData } = useAssessment();
  const { progress } = useProgress();
  const handleExitModel = () => {
    localStorage.removeItem("assessmentData");
    resetAssessmentData();
    if (window.movementTestPayload) {
      window.movementTestPayload = null;
    }
    if (window.mayraCode) {
      window.mayraCode.setIsVisible(false);
      window.mayraCode.forceStop();
    }
    if (window.mayraCode) {
      window.mayraCode.handleMicClick(true);
    }

    if (window.destroyOwnedResources) {
      window.destroyOwnedResources();
    }
    if (window.destroyFlutterResources) {
      window.destroyFlutterResources();
    }

    localStorage.setItem("loadAfterReloadAutoHome", "1");
    window.location.replace(window.location.origin);
  };
  return (
    <div className={styles.header}>
      <img src={LOGO} alt="Virdio Health Logo" className={styles.headerImage} />

      <div className={styles.progressWrapper}>
        {showProgress && (
          <>
            <div className={styles.progressContainer}>
              <div className={styles.progressBar} style={{ width: `${progress}%` }} />
            </div>
            <p>{progress}%</p>
          </>
        )}

        {showIcon && (
          <i className={styles.headerCloseIcon} onClick={() => setShowExitModal(!showExitModal)}>
            {/* <IoCloseOutline size={25} color="#0D9488" /> */}
            &times;
          </i>
        )}
      </div>
      <ExitModal isOpen={showExitModal} onClose={() => setShowExitModal(false)} onExit={handleExitModel} />
    </div>
  );
};

// custom Exit Modal Component
const ExitModal = ({ isOpen, onClose, onExit }) => {
  if (!isOpen) return null;

  return (
    <div id="exit-modal-overlay" className={styles.Overlay}>
      <div className={styles.Backdrop}></div>

      <div className={styles.Modal}>
        <h3 className={styles.ModalTitle}>Exit Assessment?</h3>
        <p className={styles.ModalText}>Your progress will not be saved. Are you sure you want to exit?</p>
        <div className={styles.ButtonGroup}>
          <button onClick={onClose} className={styles.CancelButton}>
            Continue Assessment
          </button>
          <button onClick={onExit} className={styles.ConfirmButton}>
            Yes, Exit
          </button>
        </div>
      </div>
    </div>
  );
};

// Custom Heading Component
const Heading = React.memo(({ heading, styles = { textAlign: "center" } }) => {
  return (
    <h2 className={styles.customHeading} style={{ ...styles }}>
      {heading}
    </h2>
  );
});

// Custom Sub-Heading Component
const SubHeading = React.memo(({ subheading, styles = { textAlign: "center" } }) => {
  return (
    <p className={styles.customSubHeading} style={{ ...styles }}>
      {subheading}
    </p>
  );
});

// Custom Video Component
const VideoComp = React.memo(({ videoSrc }) => {
  return (
    <div className={styles.HomeScreenVideoWrapper}>
      <video className={styles.HomeScreenVideo} controls autoPlay muted loop playsInline>
        <source src={videoSrc} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
});

// Exit button component
const ExitButton = ({ onClick, title }) => {
  return (
    <button onClick={onClick} className={styles.ExitButton}>
      {title}
    </button>
  );
};

// Hard Stop Screen

export const HardStopScreen = () => {
  const history = useHistory();
  const { resetAssessmentData } = useAssessment();

  const handleClick = () => {
    localStorage.removeItem("assessmentData");
    resetAssessmentData();
    history.replace("/");
  };

  return (
    <div className={styles.ScreenWrapper}>
      <div className={styles.ModalContainer}>
        <div id="screen-hard-stop" className={styles.ScreenContent}>
          <svg className={styles.WarningIcon} fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
          </svg>
          <h2 className={styles.Heading}>Important Safety Notice</h2>
          <p className={styles.Text}>Thank you for your honesty. Based on your answer, your symptoms may require a direct medical evaluation.</p>
          <p className={styles.Text}>For your safety, we cannot proceed with the self-assessment at this time. Please consult a licensed medical provider.</p>

          <button onClick={handleClick} className={styles.ExitButtonHardStop}>
            Exit Assessment
          </button>
        </div>
      </div>
    </div>
  );
};

export const HomeScreen = () => {
  usePreventNavigation("/");
  useScrollToTop();
  const [homeAgeConfirm, setHomeAgeConfirm] = useState(false);
  const [showInfoModal, setShowInfoModal] = useState(false);
  const { resetAssessmentData, assessmentData, updateAssessmentData, isMyRAIsActive, setIsMyRAIsActive } = useAssessment();
  const [isMicModalActive, setIsMicModalActive] = useState(false);
  const [micModalMsg, setMicModalMsg] = useState("To chat with Myra, please grant microphone access. Your audio is processed in real-time and never stored or recorded.");
  const [access, setAccess] = useState(true);
  const [isStartedLandingFlow, setIsStartedLandingFlow] = useState(false);
  const [isUserChatWithMyra, setIsUserChatWithMyra] = useState(false);

  const [onlyStep, setOnlyStep] = useState(false);

  const videoRef = useRef(null);

  const history = useHistory();

  localStorage.removeItem("startedSelf");

  // Modified on Aug 7th - for user tracking
  useEffect(() => {
    window.screenTracker.enterScreen("landing");
    const initializeSession = async () => {
      const newSessionId = await AnalyticsService.startSession();
    };
    if (window.timeTracker) {
      window.timeTracker.startLandingTimer();
    }
    // We remove the try/catch wrapper because it doesn't help with fetch.
    // Instead, we attach handlers directly to the fetch chain.

    fetch("https://api64.ipify.org?format=json")
      .then((response) => {
        if (!response.ok) throw new Error("IP Service Error");
        return response.json();
      })
      .then((data) => {
        window.backupIP = data.ip;
        // NOT calling initializeSession here  to avoid duplication
      })
      .catch((error) => {
        // This runs if Incognito/AdBlock blocks the request
        console.warn("IP fetch blocked or failed (common in Incognito). Proceeding anyway.", error);
        window.backupIP = null;
      })
      .finally(() => {
        // .finally() runs whether the fetch SUCCEEDED or FAILED.
        // the session is always created.
        initializeSession();
      });
  }, []);
  useEffect(() => {
    window.isThisFromHomeScreen = true;
    return () => {
      window.isThisFromHomeScreen = false;
    };
  }, []);
  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const stopIfAudioOn = () => {
      // VoiceService.stopAgentSpeech();
    };

    video.addEventListener("play", stopIfAudioOn);
    video.addEventListener("volumechange", stopIfAudioOn);

    return () => {
      video.removeEventListener("play", stopIfAudioOn);
      video.removeEventListener("volumechange", stopIfAudioOn);
    };
  }, []);

  const handleChange = (e) => {
    setHomeAgeConfirm(e.target.checked);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      setHomeAgeConfirm((prev) => !prev);
    }
  };
  const handleMyraClick = async () => {
    setIsStartedLandingFlow(true);
    setIsUserChatWithMyra(true);
    if (window.mayraCode && window.mayraCode.handleHomeScreenMyraClick) {
      // setting video volume to 0 to avoid overlapping audios
      if (videoRef.current) {
        videoRef.current.pause();
        videoRef.current.muted = true;
        videoRef.current.volume = 0;
      }
      // Set these BEFORE calling handleHomeScreenMyraClick
      window.setIsMicModalActive = setIsMicModalActive;
      window.updateMyRAIsActive = setIsMyRAIsActive;

      if (window.preloadAllAudios) {
        window.preloadAllAudios();
      }
      if (window.videoUnlockPlay) {
        window.videoUnlockPlay();
      }
      if (window.mayraCode) {
        window.mayraCode.setOnMicEnabled(null);
      }

      // ONE-TIME CALLBACK - will be cleared after execution
      window.mayraCode.setOnMicEnabled((enabledBefore) => {
        console.log("HomeScreen: Microphone enabled callback triggered, enabledBefore:", enabledBefore);

        // CLEAR THE CALLBACK IMMEDIATELY to prevent next screen from using it
        window.mayraCode.setOnMicEnabled(null);

        const handleFlowStart = () => {
          window.mayraCode.setIsVisible(true);
          window.mayraCode.setIsFlowStarted(true);

          const checkAndStartFlow = () => {
            const isAudioReady = window.audioPlayer?.unlocked && window.audioPlayer?.ctx?.state === "running";
            if (isAudioReady) {
              window.mayraCode.startFlow("flow_landing_page");
            } else {
              console.log("HomeScreen: Audio not ready (ctx state:", window.audioPlayer?.ctx?.state, ")");
              if (window.audioPlayer?.ctx?.state === "suspended") {
                window.audioPlayer.initFromUserGesture();
              }
              setTimeout(checkAndStartFlow, 200);
            }
          };

          checkAndStartFlow();
        };

        setTimeout(handleFlowStart, 300);
      });

      // Call the handler
      await window.mayraCode.handleHomeScreenMyraClick(true);
    } else {
      // Fallback logic
      console.log("handleHomeScreenMyraClick not available, using fallback");

      let micPermissionState = "prompt";
      try {
        if (navigator.permissions && navigator.permissions.query) {
          const status = await navigator.permissions.query({ name: "microphone" });
          micPermissionState = status.state;
        }
      } catch (e) {
        console.log("Permission query failed");
      }

      if (micPermissionState === "granted") {
        setIsMyRAIsActive(true);
        if (window.mayraCode) {
          window.mayraCode.setOnMicEnabled((enabledBefore) => {
            // CLEAR THE CALLBACK IMMEDIATELY
            window.mayraCode.setOnMicEnabled(null);

            window.mayraCode.setIsVisible(true);
            if (window.preloadAllAudios) window.preloadAllAudios();
            if (window.videoUnlockPlay) window.videoUnlockPlay();

            const checkAndStart = () => {
              if (window.audioPlayer?.unlocked) {
                window.mayraCode.startFlow("flow_landing_page");
              } else {
                setTimeout(checkAndStart, 500);
              }
            };
            checkAndStart();
          });
          window.mayraCode.handleMicClick(true);
        }
      } else {
        setIsMicModalActive(!isMicModalActive);
        setIsMyRAIsActive(true);

        if (window.mayraCode) {
          window.setIsMicModalActive = setIsMicModalActive;
          window.updateMyRAIsActive = setIsMyRAIsActive;

          window.mayraCode.setOnMicEnabled((enabledBefore) => {
            // CLEAR THE CALLBACK IMMEDIATELY
            window.mayraCode.setOnMicEnabled(null);

            window.mayraCode.setIsVisible(true);

            const checkAndStart = () => {
              if (window.audioPlayer?.unlocked) {
                window.mayraCode.startFlow("flow_landing_page");
              } else {
                setTimeout(checkAndStart, 500);
              }
            };
            checkAndStart();
          });
          window.mayraCode.handleMicClick();
        }
      }
    }
  };

  // Updated permission handlers remain the same
  const onGrant = () => {
    setIsMicModalActive(false);
    if (window._myraPermissionCallbacks?.onGrant) {
      window._myraPermissionCallbacks.onGrant();
    }
  };

  const oncancel = () => {
    setIsStartedLandingFlow(false);
    setIsUserChatWithMyra(false);
    setAccess(false);
    setIsMyRAIsActive(false);
    setMicModalMsg("Mic access is needed to chat with Myra. You can still start the Guided Self-Assessment anytime—the button is just below the video. Text chat is coming soon!");
    if (window._myraPermissionCallbacks?.onCancel) {
      window._myraPermissionCallbacks.onCancel();
    }
  };
  const handleHomeButtonCLicked = () => {
    // if (isStartedLandingFlow) {
    //   if (window.mayraCode) {
    //     window.mayraCode.setIsVisible(false);
    //     window.mayraCode.forceStop();

    //     // Completely destroy the VoiceService instance
    //     VoiceService.destroyMyraCompletely(false);
    //     // Clear global references
    //     window.mayraCode = null;
    //     window.startFlow = null;
    //     window.currentCommandsAudio = {};
    //   }
    //   sessionStorage.removeItem("voiceService_wasListening");
    //   sessionStorage.removeItem("voiceService_currentFlow");
    // }

    window.screenTracker.exitScreen("landing", {
      exitReason: "started_gsa",
      completed: true,
    });

    // 2. Get the screen flow array (not nested object)
    const finalScreenFlow = window.screenTracker.getScreenFlow();

    // 3. Get timing data
    const timingData = window.timeTracker.startGSATimer();
    let landingDurationSec = null;
    if (finalScreenFlow.length > 0) {
      const landingScreen = finalScreenFlow.find((s) => s.screen === "landing");
      if (landingScreen && landingScreen.enteredAt && landingScreen.exitedAt) {
        const start = new Date(landingScreen.enteredAt);
        const end = new Date(landingScreen.exitedAt);
        landingDurationSec = Math.round((end - start) / 1000);
      }
    }

    // 4. Prepare data - send INDIVIDUAL fields
    const updatedData = {
      ...assessmentData,
      started_assessment: true,
      myraEngagedLanding: isUserChatWithMyra ? true : false,
      ...timingData,
      screenFlow: finalScreenFlow,
      gsaStartedAt: timingData,
      timeOnLandingSec: landingDurationSec,
      analyticsId: window.trSessionId || localStorage.getItem("trSessionId"),
      session_last_update: new Date().toISOString(),
      EngagedOnLanding: isStartedLandingFlow ? true : false,
    };

    // Cleanup
    localStorage.removeItem("assessmentData");
    resetAssessmentData();
    localStorage.removeItem("dataAfterInfo");

    // Update and track
    updateAssessmentData(updatedData);
    localStorage.setItem("assessmentData", JSON.stringify(updatedData));
    AnalyticsService.trackStep(updatedData);

    if (!window.trSessionId) {
      AnalyticsService.startSession();
    }

    history.replace("/red-flags");
  };
  const handleInfoClicked = () => {
    setShowInfoModal(true);
  };

  const handleButtonClick = async () => {
    const flutterRoot = document.getElementById("OnDemandPlayingRoot");
    if (flutterRoot) flutterRoot.style.display = "block";

    const currentAssessmentRoot = document.getElementById("assesmentDiv");
    if (currentAssessmentRoot) currentAssessmentRoot.style.display = "none";

    localStorage.removeItem("loadSelf");

    window.doNextLocation = history;
    document.querySelector("html").classList = [];
  };
  return (
    <div className={styles.landingHomeCon}>
      {isMicModalActive && <LandingPageModal message={micModalMsg} onGrant={onGrant} onCancel={oncancel} isMicModalActive={isMicModalActive} setIsMicModalActive={setIsMicModalActive} access={access} setAccess={setAccess} setMicModalMsg={setMicModalMsg} />}
      <div className={styles.ScreenWrapper}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
          }}
        >
          {onlyStep === false && <HomeHeroComponent />}
          {onlyStep === false && <CustomHeader isStartedLandingFlow={isStartedLandingFlow} />}

          <div style={{ position: "relative", padding: "2rem 0" }}>
            {/* RIGHT MAIN CONTENT */}
            <div className={styles.heroMainContent}>
              {!onlyStep && (
                <div className={styles.heroAccentsColumn}>
                  <div className={`${styles.heroAccent} ${styles.heroAccentTop}`}>
                    <p>All on your device. No downloads. No clinics. No pressure.</p>
                  </div>

                  <div className={`${styles.heroAccent} ${styles.heroAccentBottom}`}>
                    <p>Understand your pain. Take the first step toward relief.</p>
                  </div>
                </div>
              )}
              <div className={styles.homeMyraBtnCon}>
                <button className={styles.heroAskMyraButton} onClick={handleMyraClick}>
                  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="40" height="40">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"></path>
                  </svg>
                  Ask Myra
                </button>
              </div>
              <div className={styles.ScreenModal}>
                {onlyStep === true && (
                  <div>
                    <i className={styles.headerCloseIcon} onClick={() => setOnlyStep(false)}>
                      &times;
                    </i>
                  </div>
                )}
                <div>
                  <Heading heading={"Start by Taking the Guided Self-Assessment"} />

                  {/* Video Section */}
                  {/* <VideoComp videoSrc={HOME_VIDEO_2}  */}
                  <div className={styles.HomeScreenVideoWrapper}>
                    <video className={styles.HomeScreenVideo} controls autoPlay muted loop playsInline ref={videoRef}>
                      <source src={HOME_VIDEO_2} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  </div>

                  <ul className={styles.HomeScreenList}>
                    <li className={styles.HomeScreenListItem}>
                      <svg className={styles.HomeScreenIcon} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      Answer a few easy questions.
                    </li>
                    <li className={styles.HomeScreenListItem}>
                      <svg className={styles.HomeScreenIcon} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      Follow a couple of simple guided movements.
                    </li>
                    <li className={styles.HomeScreenListItem}>
                      <svg className={styles.HomeScreenIcon} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      Walk away with a plan tailored to your needs.
                    </li>
                  </ul>

                  <div className={styles.HomeScreenConsentWrapper}>
                    <p className={styles.HomeScreenConsentText}>By clicking 'Start My Free Assessment', you agree to allow Virdio Health to process your anonymous health responses to provide you with actionable guidance tailored to your experience</p>

                    <p className={styles.HomeScreenConsentTextIcon} onClick={handleInfoClicked}>
                      What is StartFreePT?<div className={styles.HomeScreenConsentTextIcon}>i</div>
                    </p>

                    <div className={styles.HomeScreenCheckboxWrapper}>
                      <input autoComplete="off" type="checkbox" id="age-confirm" className={styles.HomeScreenCheckboxInput} checked={homeAgeConfirm} onChange={handleChange} onKeyDown={handleKeyDown} />
                      <label htmlFor="age-confirm" className={styles.HomeScreenCheckboxLabel} tabIndex={0}>
                        I confirm I am 18 years of age or older.
                      </label>
                    </div>
                  </div>

                  <CommonButton onClick={handleHomeButtonCLicked} title={"Start My Free Assessment"} disabled={!homeAgeConfirm} />
                </div>
              </div>
              {/* Disclaimer */}
              <div className={styles.homeDisDisclaimerContainer}>
                <p className={styles.homeDisDisclaimerText}>StartFreePT and Virdio Health offer educational guidance based on your input. It's not a substitute for medical advice, diagnosis, or treatment. If your symptoms worsen or you're unsure what's right for you, talk to a healthcare provider.</p>
              </div>
            </div>
          </div>
          {onlyStep === false && (
            <div style={{ width: "100%" }}>
              <TalkToMyraHomeSection handleMyraClick={handleMyraClick} />
            </div>
          )}

          {onlyStep === false && (
            <>
              <HomeBottomContent
                doShowStep={() => {
                  setOnlyStep(true);
                }}
                handleMyraClick={handleMyraClick}
              />
              <footer className={styles.HomeBtmConFooter}>
                <div className={styles.HomeBtmConFooterWrap}>
                  <p className={styles.HomeBtmConFooterText}>
                    © 2025 Virdio Health. All rights reserved. <span>v3.1.2</span>
                  </p>
                </div>
              </footer>
            </>
          )}
        </div>
        {showInfoModal && <InfoModal onClose={() => setShowInfoModal(false)} />}
      </div>
    </div>
  );
};
export const generatePayloadForScreen = (screenName, assessmentData, currentTest = "") => {
  const userName = window.localStorage.getItem("self_name") || "User";
  // current understanding
  const getPainLocations = () => {
    return assessmentData?.selectedZones || [];
  };
  let aggregativeFactor = assessmentData?.subtypeQuestions?.value || null;
  const getAggregativeFactors = () => {
    const q1ToAggravating = {
      a: ["sitting", "slouching", "bending forward"],
      b: ["standing for a long time", "walking for a long time"],
      c: ["staying in one position too long"],
      d: ["unpredictable movements"],
      e: ["twisting", "turning", "getting in/out of a car"],
    };

    return {
      aggravating: q1ToAggravating[aggregativeFactor] || [],
    };
  };

  let perceived_subtype = assessmentData?.probableSubtype;
  const getPatternDescription = () => {
    const diagnosis = messaging.diagnosis?.[perceived_subtype];
    return diagnosis?.implications || "";
  };
  const baseline_pain = assessmentData?.painLevel ?? 5;
  let symptom_duration = assessmentData?.symptomDuration;
  let current_understanding = {
    pain_locations: getPainLocations() || [],
    aggravating_factors: getAggregativeFactors(),
    relief_factors: messaging.diagnosis?.[perceived_subtype]?.relief,
    perceived_subtype: perceived_subtype,
    pattern_description: getPatternDescription(),
    baseline_pain: baseline_pain,
    symptom_duration: symptom_duration,
  };
  //  current understanding ends
  // Helper function to get current test
  const getTest1Details = () => {
    let testName = currentTest;
    return {
      name: testName || "",
      repHelp: "",
      orientation: "",
      reps: 10,
      holdTime: null,
      why_selected: messaging.diagnosis?.[perceived_subtype]?.headline,
    };
  };
  const getTest2Details = () => {
    let testName = currentTest;
    return {
      name: testName || "",
      repHelp: "",
      orientation: "",
      reps: 4,
      holdTime: null,
      why_selected: messaging.diagnosis?.[perceived_subtype]?.headline,
    };
  };
  //  test results:
  let test_results = {
    movement_test_1: { completed: true, test_name: assessmentData?.rom_test1_name, symptom_response: assessmentData.symptomResponse1, observation: "User completed all reps" },
    movement_test_2: { completed: true, test_name: assessmentData?.testName2, symptom_response: assessmentData.symptomResponseConfirm, observation: "User completed all reps" },
  };

  // payload for recovery-plan last screen
  const userProfile = {
    // Pain and assessment data
    cpgClassification: assessmentData.finalCpgClassification || "",
    subjectiveResponses: assessmentData.subtypeQuestions || {},
    symptomDuration: assessmentData.symptomDuration || "",
    preTestNPRS: assessmentData.painLevel || 0,
    probableSubtype: assessmentData.probableSubtype || "",
    finalPainSubtype: assessmentData.finalPainSubtype || "",
    recoveryScore: assessmentData.finalScore || 0,
    level: assessmentData.finalComplexityLevel || 3,

    // Biometrics
    biometrics: assessmentData.biometrics || {},

    // Additional calculated fields
    rcsCalculated: assessmentData.rcsCalculated || 0,
    totalAdjustment: assessmentData.totalAdjustment || 0,
    adjustmentDetails: assessmentData.adjustmentDetails || {},
  };

  // Build currentPlan
  const currentPlan = {
    exercises: assessmentData?.recoveryPlan?.exercises || [],
    estimatedTime: assessmentData?.recoveryPlan?.estimatedTime || "",
    rationale: assessmentData?.recoveryPlan?.rationale || "",
  };

  // Screen-specific payload generators
  const payloadGenerators = {
    safety_screen: () => ({
      gsa_step: screenName,
      user_name: userName,
    }),
    pain_location: () => ({
      gsa_step: screenName,
      user_name: userName,
    }),
    cpg_questions: () => ({
      gsa_step: screenName,
      user_name: userName,
      current_understanding: {
        pain_locations: getPainLocations() || [],
      },
    }),
    subtype_questioning: () => ({
      gsa_step: screenName,
      user_name: userName,
      current_understanding: {
        pain_locations: getPainLocations() || [],
        relief_factors: messaging.diagnosis?.[perceived_subtype]?.relief,
        perceived_subtype: perceived_subtype,
        pattern_description: getPatternDescription(),
      },
    }),
    self_assessment: () => ({
      gsa_step: screenName,
      user_name: userName,
      current_understanding: {
        pain_locations: getPainLocations() || [],
        relief_factors: messaging.diagnosis?.[perceived_subtype]?.relief,
        perceived_subtype: perceived_subtype,
        pattern_description: getPatternDescription(),
      },
    }),
    nprs_symptoms: () => ({
      gsa_step: screenName,
      user_name: userName,
      current_understanding: {
        pain_locations: getPainLocations() || [],
        relief_factors: messaging.diagnosis?.[perceived_subtype]?.relief,
        perceived_subtype: perceived_subtype,
        pattern_description: getPatternDescription(),
      },
    }),
    test1_demo: () => ({
      gsa_step: screenName,
      user_name: userName,
      ...current_understanding,
      current_test: [getTest1Details()],
    }),

    camera_permission: () => ({
      gsa_step: screenName,
      user_name: userName,
      ...current_understanding,
      current_test: [getTest1Details()],
    }),
    movement_test_1: () => ({
      gsa_step: screenName,
      user_name: userName,
      ...current_understanding,
      current_test: [getTest1Details()],
    }),

    test1_rpe: () => ({
      gsa_step: screenName,
      user_name: userName,
      ...current_understanding,
      current_test: [getTest1Details()],
    }),

    test1_symptoms: () => ({
      gsa_step: screenName,
      user_name: userName,
      ...current_understanding,
      current_test: [getTest1Details()],
      test_results: test_results.movement_test_1,
    }),
    test2_demo: () => ({
      gsa_step: screenName,
      user_name: userName,
      ...current_understanding,
      current_test: [getTest2Details()],
      test_results: test_results.movement_test_1,
    }),
    movement_test_2: () => ({
      gsa_step: screenName,
      user_name: userName,
      ...current_understanding,
      current_test: [getTest2Details()],
      test_results: test_results.movement_test_1,
    }),
    symptom2: () => ({
      gsa_step: screenName,
      user_name: userName,
      ...current_understanding,
      current_test: [getTest1Details(), getTest2Details()],
      test_results: test_results,
    }),
    personalize: () => ({
      gsa_step: screenName,
      user_name: userName,
      ...current_understanding,
      current_test: [getTest1Details(), getTest2Details()],
      test_results: test_results,
    }),

    recovery_score: () => ({
      gsa_step: screenName,
      user_name: userName,
      ...current_understanding,
      ...userProfile,
      current_test: [getTest1Details(), getTest2Details()],
      test_results: test_results,
    }),

    plan_screen: () => ({
      gsa_step: screenName,
      user_name: userName,
      ...current_understanding,
      current_test: [getTest1Details(), getTest2Details()],
      test_results: test_results,
      ...userProfile,
      ...currentPlan,
    }),
  };

  // Get the payload generator for the requested screen
  const generator = payloadGenerators[screenName];

  if (!generator) {
    console.warn(`No payload generator found for screen: ${screenName}`);
    return {
      gsa_step: screenName,
      error: `Payload generator not configured for ${screenName}`,
    };
  }

  return generator();
};

const getBrowserDeviceData = () => ({
  browser_device: navigator.userAgent,
  timestamp_utc: new Date().toISOString(),
});

// accessgatescreen => accesscode : Dev-B0720252
export const AccessGateScreen = () => {
  usePreventNavigation("/");
  const [accessOption, setAccessOption] = useState("");
  const [betaCode, setBetaCode] = useState("");
  // const [firstName, setFirstName] = useState("");
  // const [email, setEmail] = useState("");
  // const [emailError, setEmailError] = useState("");
  const history = useHistory();
  // Modified on Aug 7th - for user tracking
  const { assessmentData, updateAssessmentData } = useAssessment();

  const isCodeProceedDisabled = betaCode.trim() === "";

  // const isRequestProceedDisabled = (() => {
  //   const isNameValid = firstName.trim() !== "";
  //   const emailValue = email.trim();
  //   const isEmailFormatValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailValue);
  //   return !(isNameValid && emailValue && isEmailFormatValid);
  // })();

  // useEffect(() => {
  //   if (email.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) {
  //     setEmailError("Please enter a valid email format.");
  //   } else {
  //     setEmailError("");
  //   }
  // }, [email]);
  useEffect(() => {
    const savedCode = localStorage.getItem("beta_access_code");
    if (savedCode) {
      setBetaCode(savedCode);
      setAccessOption("code");
    }
  }, []);

  // functions
  const submitAccessCode = async (code) => {
    console.log("--- Calling API: submitAccessCode ---");
    const payload = {
      front_ip: window.backupIP || "",
      access_code: code,
      ...getBrowserDeviceData(),
    };

    try {
      const response = await fetch(BETA_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) throw new Error("Request failed");

      const result = await response.json();
      console.log("Backend response:", result);

      if (result?.success === true) {
        localStorage.setItem("beta_access_code", code);
      }

      return result?.success === true;
    } catch (error) {
      console.error("submitAccessCode failed:", error);
      return false;
    }
  };

  // const submitBetaRequest = async (firstName, email) => {
  //   console.log("--- Calling API Stub: submitBetaRequest ---");
  //   const payload = {
  //     first_name: firstName,
  //     email,
  //     ...getBrowserDeviceData(),
  //   };
  //   try {
  //     const response = await fetch(BETA_URL, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify(payload),
  //     });

  //     if (!response.ok) throw new Error("Request failed");

  //     console.log("Payload to send:", payload);
  //     await new Promise((r) => setTimeout(r, 500));
  //     console.log("Request submitted successfully.");
  //     console.log("---------------------------------------");
  //     return true;
  //   } catch (error) {
  //     console.error("submitBetaRequest failed:", error);
  //     return false;
  //   }
  // };

  const handleProceed = async (type, data) => {
    // Modified on Aug 7th - for user tracking
    const currentData = { ...assessmentData, started_assessment: true, beta_access_type: type, ...data };
    updateAssessmentData(currentData);
    // Modified on Aug 7th - for user tracking
    AnalyticsService.trackStep(currentData);

    if (type === "code") {
      const isValid = await submitAccessCode(data.code);
      if (isValid) {
        history.replace("/red-flags");
      } else {
        history.replace("/invalid-code");
      }
    }
    // else if (type === "request") {
    //   const success = await submitBetaRequest(data.firstName, data.email);
    //   if (success) history.replace("/red-flags");
    // }
  };

  return (
    <div className={styles.ScreenWrapper}>
      <div className={styles.ScreenModal}>
        <Header showProgress={false} />
        <h2 className={styles.AGHeading}>Beta Program Access</h2>
        <p className={styles.AGSubheading}>This guided self-assessment is part of a limited beta program. Please choose how you'd like to proceed.</p>

        <div className={styles.AGOptionsWrapper}>
          {/* Option 1: Have a code */}
          <div>
            <input type="radio" name="access-option" id="option-have-code" value="code" checked={accessOption === "code"} onChange={(e) => setAccessOption(e.target.value)} className={styles.AGHiddenRadio} />
            <label htmlFor="option-have-code" className={`${styles.AGOptionCard} ${accessOption === "code" ? styles.AGOptionCardSelected : ""}`} onClick={() => {}}>
              <h4 className={styles.AGOptionTitle}>I have an access code</h4>
            </label>

            {accessOption === "code" && (
              <div className={styles.AGOptionContent}>
                <label htmlFor="beta-code" className={styles.AGLabel}>
                  Enter your access code below
                </label>
                <input type="text" id="beta-code" value={betaCode} onChange={(e) => setBetaCode(e.target.value)} placeholder="e.g., BETA-12345" className={styles.AGInputField} autoComplete="off" />
                <button onClick={() => handleProceed("code", { code: betaCode })} className={styles.AGButton} disabled={isCodeProceedDisabled}>
                  Proceed
                </button>
              </div>
            )}
          </div>

          {/* Option 2: Request access */}
          {/* <div>
            <input
              type="radio"
              name="access-option"
              id="option-request-access"
              value="request"
              checked={accessOption === "request"}
              onChange={(e) => setAccessOption(e.target.value)}
              className={styles.AGHiddenRadio}
            />
            <label
              htmlFor="option-request-access"
              className={`${styles.AGOptionCard} ${
                accessOption === "request" ? styles.AGOptionCardSelected : ""
              }`}
              onClick={() => {}}
            >
              <h4 className={styles.AGOptionTitle}>
                I don't have a code, but I'd like to join the beta
              </h4>
            </label>

            {accessOption === "request" && (
              <div className={styles.AGOptionContent}>
                <div>
                  <label htmlFor="first-name" className={styles.AGLabel}>
                    Enter your first name
                  </label>
                  <input
                    type="text"
                    id="first-name"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    className={styles.AGInputField}
                    autoComplete="off"
                  />
                </div>
                <div>
                  <label htmlFor="email" className={styles.AGLabel}>
                    Enter your email address
                  </label>
                  <input
                    type="email"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className={styles.AGInputField}
                    autoComplete="off"
                  />
                  <p className={styles.AGErrorText}>{emailError}</p>
                </div>
                <button
                  onClick={() => handleProceed("request", { firstName, email })}
                  className={styles.AGButton}
                  disabled={isRequestProceedDisabled}
                >
                  Proceed
                </button>
              </div>
            )}
          </div> */}
        </div>
      </div>
    </div>
  );
};

// invalid code screen
export const InvalidCodeScreen = () => {
  usePreventNavigation("/");
  const histroy = useHistory();
  return (
    <div className={styles.ScreenWrapper}>
      <div className={styles.ScreenModal} style={{ textAlign: "center" }}>
        <Header showProgress={false} />
        <div className={styles.invalidScreenIconWrapper}>
          <svg className={styles.invalidScreenIcon} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
        </div>
        <h2 className={styles.invalidScreenHeading}>Invalid Access Code</h2>
        <p className={styles.invalidScreenMessage}>The code you entered is not valid. Please check the code and try again.</p>
        <CommonButton title={"Try Again"} onClick={() => histroy.push("/access-gate")} />
      </div>
    </div>
  );
};

// safety or red flags screen
export const SafetyScreen = () => {
  useScrollToTop();

  usePreventNavigation("/");

  localStorage.setItem("startedSelf", "1");

  const { setProgress } = useProgress();
  // Modified on Aug 7th - for user tracking
  const { assessmentData, updateAssessmentData } = useAssessment();
  let safetyScreenPayload = generatePayloadForScreen("safety_screen", assessmentData);
  console.log("safetyScreenPayload data is : ", safetyScreenPayload);
  const [isVoiceReady, setIsVoiceReady] = useState(false);
  const [myraTurnedOnCount, setMyraTurnedOnCount] = useState(0);
  useEffect(() => {
    let prevIsListening = VoiceService._isListening;
    const checkInterval = setInterval(() => {
      const currentIsListening = VoiceService._isListening;
      if (!prevIsListening && currentIsListening) {
        setMyraTurnedOnCount((prev) => prev + 1);
      }

      if (prevIsListening && !currentIsListening) {
        console.log("[Myra] Turned OFF");
        setIsVoiceReady(false);
      }
      prevIsListening = currentIsListening;
    }, 500);

    return () => clearInterval(checkInterval);
  }, []);

  useEffect(() => {
    window.initFromUserGesture();
    const initializeVoice = () => {
      if (window.mayraCode && typeof window.mayraCode.setIsVisible === "function") {
        if (VoiceService._ws?.readyState === WebSocket.OPEN) {
          VoiceService.sendMidJourneyData(safetyScreenPayload);
          setIsVoiceReady(true);
        }
      }
    };
    initializeVoice();
    const checkConnectionInterval = setInterval(() => {
      if (VoiceService._ws?.readyState === WebSocket.OPEN && !isVoiceReady) {
        initializeVoice();
      }
    }, 1000);
    const originalOnConnected = VoiceService._callbacks?.onConnected;
    VoiceService._callbacks.onConnected = () => {
      initializeVoice();
      if (originalOnConnected) originalOnConnected();
    };
    return () => {
      clearInterval(checkConnectionInterval);
      if (originalOnConnected) {
        VoiceService._callbacks.onConnected = originalOnConnected;
      }
    };
  }, [safetyScreenPayload, isVoiceReady, myraTurnedOnCount]);

  const history = useHistory();
  useEffect(() => {
    if (!window.trSessionId) {
      AnalyticsService.startSession();
    }

    window.screenTracker.enterScreen("safety_screen");
    setProgress(5);
  }, []);

  useEffect(() => {
    window.initFromUserGesture();
    window.currentCommandsAudio = {
      ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent) => {
        if (intent === "continue_command") {
          handleClick();
        }
      },
      MOVE_ON: (value, speech, intent) => {
        handleClick();
      },
    };

    if (assessmentData?.EngagedOnLanding) {
      let announcementName;
      const userName = localStorage.getItem("self_name") || "";
      const hasDoneGsaBefore = localStorage.getItem("didGsaFlowBefore") === "true";
      if (hasDoneGsaBefore) {
        announcementName = "flow_gsa_welcome_back";
      } else {
        announcementName = "flow_gsa_first_time";
      }
      if (window.mayraCode && typeof window.mayraCode.setIsVisible === "function") {
        window.mayraCode.setIsVisible(true);
        window.mayraForwardCode = {
          midjourneyData: safetyScreenPayload,
        };
        window.currentFlow = "flow_gsa";
        VoiceService._currentFlow = "flow_gsa";
        setTimeout(() => {
          window.mayraCode.startFlow("flow_gsa", announcementName, () => {
            localStorage.setItem("didGsaFlowBefore", "true");
            console.log("User has completed GSA flow, flag set");
          });
        }, 500);
      }
    } else {
      VoiceService._currentFlow = "flow_gsa";
      window.currentFlow = "flow_gsa";
      window.mayraCode.setIsVisible(true);
      setTimeout(() => {
        window.mayraForwardCode = {
          midjourneyData: safetyScreenPayload,
        };
      }, 1000);
    }
  }, []);
  const handleClick = () => {
    window.screenTracker.exitScreen("safety_screen", {
      exitReason: "completed_safety",
      completed: true,
    });
    const screenFlow = window.screenTracker.getScreenFlow();

    const updatedData = {
      ...assessmentData,
      red_flag_exit: true,
      completed_safety_screen: true,
      selected_problem_area: true,
      problemArea: "LBP",
      screenFlow: screenFlow,
      session_last_update: new Date().toISOString(),
    };
    updateAssessmentData(updatedData);
    localStorage.setItem("assessmentData", JSON.stringify(updatedData));

    if (!window.trSessionId) {
      AnalyticsService.startSession();
    }

    // Modified on Aug 7th - for user tracking
    AnalyticsService.trackStep(updatedData);

    // history.replace("/problem-area");
    history.replace("/pain-location");
  };

  const hardStopScreen = () => {
    const updatedData = { ...assessmentData, red_flag_exit: true };
    updateAssessmentData(updatedData);
    localStorage.setItem("assessmentData", JSON.stringify(updatedData));

    // Modified on Aug 7th - for user tracking
    AnalyticsService.trackStep(updatedData);

    history.replace("/hard-stop");
  };

  return (
    <div className={styles.ScreenWrapper}>
      <div className={styles.ScreenModal}>
        <Header />
        <Heading heading="Quick Safety Check" />
        <SubHeading subheading="Before we move forward, let us know if you're experiencing any of these symptoms:" />
        <ul className={styles.SymptomList}>
          <li>Sharp or shooting pain down your legs?</li>
          <li>Numbness or tingling in your legs or feet?</li>
          <li>Leg weakness, instability, or "giving out"?</li>
          <li>Changes in bowel or bladder control?</li>
        </ul>

        <CommonButton title="I do NOT have these symptoms" onClick={handleClick} />
        <ExitButton title={"I have one or more symptoms"} onClick={hardStopScreen} />
      </div>
    </div>
  );
};

export const ProblemAreaScreen = () => {
  useScrollToTop();
  usePreventNavigation("/");
  const { setProgress } = useProgress();
  const { assessmentData, updateAssessmentData } = useAssessment();
  const history = useHistory();
  const [selectedArea, setSelectedArea] = useState(null);

  useEffect(() => {
    setProgress(10);
  }, [setProgress]);

  const problemAreas = Object.keys(CLINICAL_PATHS).map((key) => ({
    id: key,
    label: CLINICAL_PATHS[key].name,
  }));

  const handleSelect = (areaId) => {
    setSelectedArea(areaId);
  };

  const handleContinue = () => {
    const updatedData = {
      ...assessmentData,
      problemArea: selectedArea,
    };
    updateAssessmentData(updatedData);
    localStorage.setItem("assessmentData", JSON.stringify(updatedData));
    AnalyticsService.trackStep(updatedData);
    history.replace("/pain-location");
  };

  return (
    <div className={styles.ScreenWrapper}>
      <div className={styles.ScreenModal}>
        <Header />
        <div>
          <Heading heading="Where is your primary concern?" />
          <SubHeading subheading="Please select the area that bothers you the most." />
          <div className={styles.OptionList} style={{ marginTop: "1.5rem" }}>
            {problemAreas.map((area) => {
              const isSelected = selectedArea === area.id;
              return (
                <div className={styles.OptionWrapper} key={area.id}>
                  <input type="radio" autoComplete="off" name="problem-area" id={`area-${area.id}`} value={area.id} checked={isSelected} onChange={() => handleSelect(area.id)} className={styles.HiddenRadio} />
                  <label htmlFor={`area-${area.id}`} tabIndex={0} onKeyDown={(e) => e.key === "Enter" && handleSelect(area.id)} className={`${styles.OptionLabel} ${isSelected ? styles.OptionSelected : styles.OptionUnselected}`}>
                    <h4 className={styles.OptionLabelText}>{area.label}</h4>
                  </label>
                </div>
              );
            })}
          </div>
        </div>
        <CommonButton title={"Continue"} disabled={!selectedArea} onClick={handleContinue} />
      </div>
    </div>
  );
};

export const PainLocationScreen = () => {
  usePreventNavigation("/");
  useScrollToTop();
  const { setProgress } = useProgress();
  const [selectedZones, setSelectedZones] = useState([]);
  // Modified on Aug 7th - for user tracking
  const { updateAssessmentData, assessmentData } = useAssessment();
  let painLocationScreenPayload = generatePayloadForScreen("pain_location", assessmentData);
  console.log("painLocationScreenPayload data is : ", painLocationScreenPayload);
  const [isVoiceReady, setIsVoiceReady] = useState(false);
  const history = useHistory();
  const [myraTurnedOnCount, setMyraTurnedOnCount] = useState(0);
  useEffect(() => {
    let prevIsListening = VoiceService._isListening;
    const checkInterval = setInterval(() => {
      const currentIsListening = VoiceService._isListening;
      if (!prevIsListening && currentIsListening) {
        setMyraTurnedOnCount((prev) => prev + 1);
      }

      if (prevIsListening && !currentIsListening) {
        console.log("[Myra] Turned OFF");
        setIsVoiceReady(false);
      }
      prevIsListening = currentIsListening;
    }, 500);

    return () => clearInterval(checkInterval);
  }, []);

  useEffect(() => {
    window.screenTracker.enterScreen("pain_location");
    setProgress(15);
  }, []);
  useEffect(() => {
    if (!assessmentData.problemArea) {
      history.replace("/red-flags");
    }
  }, [assessmentData.problemArea, history]);

  useEffect(() => {
    window.initFromUserGesture();

    // Set up command handler immediately
    window.currentCommandsAudio = {
      ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent) => {
        if (intent === "continue_command") {
          if (selectedZones.length <= 0) {
            // handleContinue();
            if (window.mayraCode) {
              window.mayraCode.doSay("Please make your selection before we can move to the next screen");
            }
          } else {
            handleContinue();
          }
        }
      },
      MOVE_ON: (value, speech, intent) => {
        if (selectedZones.length <= 0) {
          // handleContinue();
          if (window.mayraCode) {
            window.mayraCode.doSay("Please make your selection before we can move to the next screen");
          }
        } else {
          handleContinue();
        }
      },
    };

    // Function to initialize voice when ready
    const initializeVoice = () => {
      if (window.mayraCode && typeof window.mayraCode.setIsVisible === "function") {
        VoiceService._currentFlow = "flow_gsa";
        window.currentFlow = "flow_gsa";
        window.mayraCode.setIsVisible(true);

        // Try to send data if WebSocket is ready
        if (VoiceService._ws?.readyState === WebSocket.OPEN) {
          VoiceService.sendMidJourneyData(painLocationScreenPayload);
          setIsVoiceReady(true);
          console.log("Successfully sent midjourney data");
        }
      }
    };

    // Check immediately
    initializeVoice();

    // Set up interval to check WebSocket connection
    const checkConnectionInterval = setInterval(() => {
      if (VoiceService._ws?.readyState === WebSocket.OPEN && !isVoiceReady) {
        initializeVoice();
      }
    }, 1000);

    // Set up listener for WebSocket connection
    const originalOnConnected = VoiceService._callbacks?.onConnected;
    VoiceService._callbacks.onConnected = () => {
      console.log("VoiceService connected, sending midjourney data");
      initializeVoice();
      if (originalOnConnected) originalOnConnected();
    };

    // Cleanup
    return () => {
      clearInterval(checkConnectionInterval);
      // Restore original callback if it exists
      if (originalOnConnected) {
        VoiceService._callbacks.onConnected = originalOnConnected;
      }
    };
  }, [painLocationScreenPayload, isVoiceReady, myraTurnedOnCount]);

  const activeZones = CLINICAL_PATHS[assessmentData.problemArea]?.zones || [];

  const toggleZone = (zoneName) => {
    setSelectedZones((prev) => (prev.includes(zoneName) ? prev.filter((z) => z !== zoneName) : [...prev, zoneName]));
  };
  const handleContinue = () => {
    window.screenTracker.exitScreen("pain_location", {
      exitReason: "zones_selected",
      completed: true,
    });
    const screenFlow = window.screenTracker.getScreenFlow();
    const updatedData = {
      ...assessmentData,
      selected_pain_location: true,
      selectedZones,
      screenFlow: screenFlow,
      session_last_update: new Date().toISOString(),
    };

    updateAssessmentData({ selectedZones });
    localStorage.setItem("assessmentData", JSON.stringify(updatedData));

    // Modified on Aug 7th - for user tracking
    AnalyticsService.trackStep(updatedData);

    history.replace("/cpg-questions");
  };
  return (
    <div className={styles.ScreenWrapper}>
      <div className={styles.ScreenModal}>
        <Header />
        <Heading heading="Pinpoint Your Symptoms" />
        <SubHeading subheading="Please tap on the body diagram exactly where you feel your symptoms the most." />
        <div className={styles.BodyContainer}>
          <img
            src={SKELETON}
            alt="Human body outline"
            className={styles.BodyImage}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = SKELETON_PLACEHOLDER;
            }}
          />
          <div className={styles.ZoneLayer}>
            {activeZones.map((zone) => (
              <div role="button" tabIndex={0} aria-pressed={selectedZones.includes(zone.name)} onKeyDown={(e) => e.key === "Enter" && toggleZone(zone.name)} key={zone.id} id={zone.id} data-name={zone.name} onClick={() => toggleZone(zone.name)} className={`${styles.BodyZone} ${selectedZones.includes(zone.name) ? styles.ActiveZone : ""}`} style={zone.style}>
                {zone.label}
              </div>
            ))}
          </div>
        </div>
        <div className={styles.SelectedAreaWrapper}>
          <h3 className={styles.SelectedAreaTitle}>Selected Areas:</h3>
          <div className={styles.SelectedAreaListWrapper}>
            {selectedZones.length > 0 ? (
              <div id="selected-areas-list" className={styles.SelectedAreaList}>
                {selectedZones.map((zone, index) => (
                  <span className={styles.SelectedAreaItem} key={index}>
                    {zone}
                    {index < selectedZones.length - 1 && ", "}
                  </span>
                ))}
              </div>
            ) : (
              <span className={styles.SelectedAreaItem}>None selected</span>
            )}
          </div>
        </div>

        <CommonButton title={"Continue"} onClick={handleContinue} disabled={selectedZones.length === 0} />
      </div>
    </div>
  );
};

// has leg pain function
const hasLegPain = (selectedZoneNames = []) => {
  const legZoneIds = ["THIGH_LEFT", "THIGH_RIGHT", "LEG_LEFT", "LEG_RIGHT"];

  const legZoneNames = ZONES.filter((zone) => legZoneIds.includes(zone.id)).map((zone) => zone.name);

  return selectedZoneNames.some((name) => legZoneNames.includes(name));
};

// cpg to subtype mapping
const cpgToSubtype = (cpgValue) => {
  // switch (cpgValue) {
  //   case "LBP with Mobility Deficits":
  //     return "LIMITED_LUMBAR_MOBILITY";
  //   case "LBP with Movement Coordination Impairments":
  //     return "NEUTRAL_SENSITIVE";
  //   default:
  //     return null;
  // }
  if (!cpgValue) return null;
  if (cpgValue.includes("Mobility Deficits")) {
    return "LIMITED_LUMBAR_MOBILITY";
  }
  if (cpgValue.includes("Movement Coordination") || cpgValue.includes("Both / Not Sure")) {
    return "NEUTRAL_SENSITIVE";
  }
  return null;
};

// cpq question screen
export const CPGQuestionScreen = () => {
  usePreventNavigation("/");
  useScrollToTop();
  const { setProgress } = useProgress();
  // Modified on Aug 7th - for user tracking
  const { assessmentData, updateAssessmentData } = useAssessment();
  let cpgQuestionScreenPayload = generatePayloadForScreen("cpg_questions", assessmentData);
  console.log("cpgQuestionScreenPayload data is : ", cpgQuestionScreenPayload);
  const history = useHistory();
  const selectedZones = assessmentData.selectedZones || [];
  const isLegPain = hasLegPain(selectedZones);
  const [selectedOption, setSelectedOption] = useState(null);
  const options = isLegPain ? CPG_OPTIONS : BACK_CPG_OPTIONS;
  const [isVoiceReady, setIsVoiceReady] = useState(false);
  const [myraTurnedOnCount, setMyraTurnedOnCount] = useState(0);
  useEffect(() => {
    window.screenTracker.enterScreen("cpg_questions");
    setProgress(25);
  }, []);
  useEffect(() => {
    let prevIsListening = VoiceService._isListening;
    const checkInterval = setInterval(() => {
      const currentIsListening = VoiceService._isListening;
      if (!prevIsListening && currentIsListening) {
        setMyraTurnedOnCount((prev) => prev + 1);
      }

      if (prevIsListening && !currentIsListening) {
        console.log("[Myra] Turned OFF");
        setIsVoiceReady(false);
      }
      prevIsListening = currentIsListening;
    }, 500);

    return () => clearInterval(checkInterval);
  }, []);

  useEffect(() => {
    window.initFromUserGesture();

    // Set up command handler immediately
    window.currentCommandsAudio = {
      ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent) => {
        if (intent === "continue_command") {
          if (!selectedOption || selectedOption === null) {
            if (window.mayraCode) {
              window.mayraCode.doSay("Please make your selection before we can move to the next screen");
            }
          } else {
            handleContinue();
          }
        }
      },
      MOVE_ON: (value, speech, intent) => {
        if (!selectedOption || selectedOption === null) {
          if (window.mayraCode) {
            window.mayraCode.doSay("Please make your selection before we can move to the next screen");
          }
        } else {
          handleContinue();
        }
      },
    };

    // Function to initialize voice when ready
    const initializeVoice = () => {
      if (window.mayraCode && typeof window.mayraCode.setIsVisible === "function") {
        VoiceService._currentFlow = "flow_gsa";
        window.currentFlow = "flow_gsa";
        window.mayraCode.setIsVisible(true);

        // Try to send data if WebSocket is ready
        if (VoiceService._ws?.readyState === WebSocket.OPEN) {
          VoiceService.sendMidJourneyData(cpgQuestionScreenPayload);
          setIsVoiceReady(true);
          console.log("Successfully sent midjourney data");
        }
      }
    };

    // Check immediately
    initializeVoice();

    // Set up interval to check WebSocket connection
    const checkConnectionInterval = setInterval(() => {
      if (VoiceService._ws?.readyState === WebSocket.OPEN && !isVoiceReady) {
        initializeVoice();
      }
    }, 1000);

    // Set up listener for WebSocket connection
    const originalOnConnected = VoiceService._callbacks?.onConnected;
    VoiceService._callbacks.onConnected = () => {
      console.log("VoiceService connected, sending midjourney data");
      initializeVoice();
      if (originalOnConnected) originalOnConnected();
    };

    // Cleanup
    return () => {
      clearInterval(checkConnectionInterval);
      // Restore original callback if it exists
      if (originalOnConnected) {
        VoiceService._callbacks.onConnected = originalOnConnected;
      }
    };
  }, [cpgQuestionScreenPayload, isVoiceReady, myraTurnedOnCount]);
  const handleContinue = () => {
    const probableSubtype = cpgToSubtype(selectedOption?.value);
    console.log("Probable Subtype:", probableSubtype);
    window.screenTracker.exitScreen("cpg_questions", {
      exitReason: "cpg_selected",
      completed: true,
    });
    const screenFlow = window.screenTracker.getScreenFlow();

    const updatedData = {
      ...assessmentData,
      cpgValue: selectedOption,
      ...(isLegPain ? {} : { probableSubtype }),
      screenFlow: screenFlow,
      session_last_update: new Date().toISOString(),
    };

    updateAssessmentData(updatedData);
    localStorage.setItem("assessmentData", JSON.stringify(updatedData));

    // Modified on Aug 7th - for user tracking
    AnalyticsService.trackStep(updatedData);

    if (isLegPain) {
      history.replace("/subtype-questioning");
    } else {
      history.replace("/pre-npr");
    }
  };
  const handleChange = (e) => {
    const selected = options.find((opt) => opt.id === e.target.id);
    setSelectedOption(selected);
    console.log("Selected Option:", selectedOption);
  };

  const handleKeyDown = (e, option) => {
    if (e.key === "Enter") {
      setSelectedOption(option);
      console.log("Selected Option:", selectedOption);
    }
  };

  return (
    <div className={styles.ScreenWrapper}>
      <div className={styles.ScreenModal}>
        <Header />
        <div>
          <h3 className={styles.CPGQuestionHeading}>{isLegPain ? "Which of these best describes the feeling in your leg?" : "Which of these best describes your main complaint?"}</h3>
          <div className={styles.OptionList}>
            {options.map((option) => {
              const isSelected = selectedOption?.id === option.id;

              return (
                <div className={styles.OptionWrapper} key={option.id}>
                  <input type="radio" autoComplete="off" name="cpg" id={option.id} value={option.value} checked={isSelected} onChange={handleChange} className={styles.HiddenRadio} />
                  <label htmlFor={option.id} tabIndex={0} onKeyDown={(e) => handleKeyDown(e, option)} className={`${styles.OptionLabel} ${isSelected ? styles.OptionSelected : styles.OptionUnselected}`}>
                    <h4 className={styles.OptionLabelText}>{option.label}</h4>
                  </label>
                </div>
              );
            })}
          </div>
        </div>
        <CommonButton title={"Continue"} disabled={!selectedOption} onClick={handleContinue} />
      </div>
    </div>
  );
};

// SubtypeQuestioningScreen

export const SubtypeQuestioningScreen = () => {
  usePreventNavigation("/");
  useScrollToTop();
  const { setProgress } = useProgress();
  // Modified on Aug 7th - for user tracking
  const { updateAssessmentData, assessmentData } = useAssessment();
  let subTypeQuestionScreenPayload = generatePayloadForScreen("subtype_questioning", assessmentData);
  console.log("subTypeQuestionScreenPayload data is : ", subTypeQuestionScreenPayload);
  const [selectedQ1Option, setSelectedQ1Option] = useState(null);
  const [isVoiceReady, setIsVoiceReady] = useState(false);
  const [myraTurnedOnCount, setMyraTurnedOnCount] = useState(0);

  const Q1_OPTIONS = [
    {
      id: "q1a",
      value: "a",
      label: "Feels worse when sitting, slouching, or bending forward.",
    },
    {
      id: "q1b",
      value: "b",
      label: "Feels worse when standing or walking for a long time.",
    },
    {
      id: "q1e", // New ID
      value: "e", // New Value
      label: "Feels worse with twisting, turning, or getting in/out of a car.",
    },
    {
      id: "q1c",
      value: "c",
      label: "Feels worse if I stay in one position too long.",
    },
    {
      id: "q1d",
      value: "d",
      label: "Hard to say—it seems to be unpredictable.", // Modified wording for clarity
    },
  ];
  const history = useHistory();
  useEffect(() => {
    setProgress(35);
    window.screenTracker.enterScreen("subtype_questioning");
  }, []);
  useEffect(() => {
    let prevIsListening = VoiceService._isListening;
    const checkInterval = setInterval(() => {
      const currentIsListening = VoiceService._isListening;
      if (!prevIsListening && currentIsListening) {
        setMyraTurnedOnCount((prev) => prev + 1);
      }

      if (prevIsListening && !currentIsListening) {
        console.log("[Myra] Turned OFF");
        setIsVoiceReady(false);
      }
      prevIsListening = currentIsListening;
    }, 500);

    return () => clearInterval(checkInterval);
  }, []);
  useEffect(() => {
    window.initFromUserGesture();

    // Set up command handler immediately
    window.currentCommandsAudio = {
      ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent) => {
        if (intent === "continue_command") {
          if (!selectedQ1Option || selectedQ1Option === null) {
            if (window.mayraCode) {
              window.mayraCode.doSay("Please make your selection before we can move to the next screen");
            }
          } else {
            handleContinue();
          }
        }
      },
      MOVE_ON: (value, speech, intent) => {
        if (!selectedQ1Option || selectedQ1Option === null) {
          if (window.mayraCode) {
            window.mayraCode.doSay("Please make your selection before we can move to the next screen");
          }
        } else {
          handleContinue();
        }
      },
    };

    // Function to initialize voice when ready
    const initializeVoice = () => {
      if (window.mayraCode && typeof window.mayraCode.setIsVisible === "function") {
        VoiceService._currentFlow = "flow_gsa";
        window.currentFlow = "flow_gsa";
        window.mayraCode.setIsVisible(true);

        // Try to send data if WebSocket is ready
        if (VoiceService._ws?.readyState === WebSocket.OPEN) {
          VoiceService.sendMidJourneyData(subTypeQuestionScreenPayload);
          setIsVoiceReady(true);
          console.log("Successfully sent midjourney data");
        }
      }
    };

    // Check immediately
    initializeVoice();

    // Set up interval to check WebSocket connection
    const checkConnectionInterval = setInterval(() => {
      if (VoiceService._ws?.readyState === WebSocket.OPEN && !isVoiceReady) {
        initializeVoice();
      }
    }, 1000);

    // Set up listener for WebSocket connection
    const originalOnConnected = VoiceService._callbacks?.onConnected;
    VoiceService._callbacks.onConnected = () => {
      console.log("VoiceService connected, sending midjourney data");
      initializeVoice();
      if (originalOnConnected) originalOnConnected();
    };

    // Cleanup
    return () => {
      clearInterval(checkConnectionInterval);
      // Restore original callback if it exists
      if (originalOnConnected) {
        VoiceService._callbacks.onConnected = originalOnConnected;
      }
    };
  }, [subTypeQuestionScreenPayload, isVoiceReady, myraTurnedOnCount]);
  const handleContinue = () => {
    window.screenTracker.exitScreen("subtype_questioning", {
      exitReason: "subtype_selected",
      completed: true,
    });
    const screenFlow = window.screenTracker.getScreenFlow();
    const updatedData = {
      ...assessmentData,
      subtypeQuestions: selectedQ1Option,
      screenFlow: screenFlow,
      session_last_update: new Date().toISOString(),
    };

    updateAssessmentData(updatedData);
    localStorage.setItem("assessmentData", JSON.stringify(updatedData));

    // Modified on Aug 7th - for user tracking
    AnalyticsService.trackStep(updatedData);

    history.replace("/self-assesment");
  };

  const handleChange = (e) => {
    const selected = Q1_OPTIONS.find((option) => option.value === e.target.value);
    setSelectedQ1Option(selected);
  };

  const handleKeyDown = (e, option) => {
    if (e.key === "Enter") {
      setSelectedQ1Option(option);
    }
  };

  return (
    <div className={styles.ScreenWrapper}>
      <div className={styles.ScreenModal}>
        <Header />
        <div>
          <h3 className={styles.CPGQuestionHeading}>Which best describes your lower back pain?</h3>
          <div id="q1-options" className={styles.Q1OptionList}>
            {Q1_OPTIONS.map((option) => {
              const isSelected = selectedQ1Option?.value === option.value;

              return (
                <div className={styles.Q1OptionWrapper} key={option.id}>
                  <input type="radio" autoComplete="off" name="q1" id={option.id} value={option.value} checked={isSelected} onChange={handleChange} className={styles.HiddenRadio} />
                  <label
                    htmlFor={option.id}
                    tabIndex={0}
                    onKeyDown={(e) => handleKeyDown(e, option)}
                    className={`${styles.OptionLabel} ${isSelected ? styles.OptionSelected : styles.OptionUnselected}`}
                    style={{
                      borderWidth: isSelected ? "5px" : "2px",
                      borderStyle: "solid",
                    }}
                  >
                    <h4 className={styles.OptionLabelText}>{option.label}</h4>
                  </label>
                </div>
              );
            })}
          </div>

          <CommonButton title="Continue" onClick={handleContinue} disabled={!selectedQ1Option} />
        </div>
      </div>
    </div>
  );
};

// Function to determine subtype based on answers
function getSubtypeFromAnswers(q1, q2) {
  if (q1 === "a") {
    return q2 === "yes" ? "FLEXION_INTOLERANT" : "NEUTRAL_SENSITIVE"; // => before
    // return q2 === "yes" ? "EXTENSION_INTOLERANT" : "NEUTRAL_SENSITIVE"; // => after
  }
  if (q1 === "b") {
    return q2 === "yes" ? "EXTENSION_INTOLERANT" : "NEUTRAL_SENSITIVE"; // => before
    // return q2 === "yes" ? "FLEXION_INTOLERANT" : "NEUTRAL_SENSITIVE"; // => after
  }
  // START ADDITION
  if (q1 === "e") {
    return q2 === "yes" ? "ROTATIONAL_INTOLERANT" : "NEUTRAL_SENSITIVE";
  }
  // END ADDITION
  return "NEUTRAL_SENSITIVE"; // q1 === c or d
}

// self assessment screen
export const SelfAssessmentScreen = () => {
  usePreventNavigation("/");
  useScrollToTop();
  // Modified on Aug 7th - for user tracking
  const { assessmentData, updateAssessmentData } = useAssessment();
  let selfAssesmentScreenPayload = generatePayloadForScreen("self_assessment", assessmentData);
  console.log("selfAssesmentScreenPayload data is : ", selfAssesmentScreenPayload);
  const { subtypeQuestions } = assessmentData;
  const [selectedAnswer, setSelectedAnswer] = useState("");
  const [isVoiceReady, setIsVoiceReady] = useState(false);
  const { setProgress } = useProgress();
  const [myraTurnedOnCount, setMyraTurnedOnCount] = useState(0);
  const history = useHistory();
  useEffect(() => {
    let prevIsListening = VoiceService._isListening;
    const checkInterval = setInterval(() => {
      const currentIsListening = VoiceService._isListening;
      if (!prevIsListening && currentIsListening) {
        setMyraTurnedOnCount((prev) => prev + 1);
      }

      if (prevIsListening && !currentIsListening) {
        console.log("[Myra] Turned OFF");
        setIsVoiceReady(false);
      }
      prevIsListening = currentIsListening;
    }, 500);

    return () => clearInterval(checkInterval);
  }, []);
  useEffect(() => {
    setProgress(45);
    window.screenTracker.enterScreen("self_assessment");
  }, []);
  useEffect(() => {
    // Optional safety: redirect if no subtype question
    if (!subtypeQuestions?.value) {
      history.replace("/subtype-questioning");
    }
  }, [subtypeQuestions]);
  useEffect(() => {
    window.initFromUserGesture();

    // Set up command handler immediately
    window.currentCommandsAudio = {
      ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent) => {
        if (intent === "continue_command") {
          if (!selectedAnswer || selectedAnswer === "") {
            if (window.mayraCode) {
              window.mayraCode.doSay("Please make your selection before we can move to the next screen");
            }
          } else {
            handleContinue();
          }
        }
      },
      MOVE_ON: (value, speech, intent) => {
        if (!selectedAnswer || selectedAnswer === "") {
          if (window.mayraCode) {
            window.mayraCode.doSay("Please make your selection before we can move to the next screen");
          }
        } else {
          handleContinue();
        }
      },
    };

    // Function to initialize voice when ready
    const initializeVoice = () => {
      if (window.mayraCode && typeof window.mayraCode.setIsVisible === "function") {
        VoiceService._currentFlow = "flow_gsa";
        window.currentFlow = "flow_gsa";
        window.mayraCode.setIsVisible(true);

        // Try to send data if WebSocket is ready
        if (VoiceService._ws?.readyState === WebSocket.OPEN) {
          VoiceService.sendMidJourneyData(selfAssesmentScreenPayload);
          setIsVoiceReady(true);
          console.log("Successfully sent midjourney data");
        }
      }
    };

    // Check immediately
    initializeVoice();

    // Set up interval to check WebSocket connection
    const checkConnectionInterval = setInterval(() => {
      if (VoiceService._ws?.readyState === WebSocket.OPEN && !isVoiceReady) {
        initializeVoice();
      }
    }, 1000);

    // Set up listener for WebSocket connection
    const originalOnConnected = VoiceService._callbacks?.onConnected;
    VoiceService._callbacks.onConnected = () => {
      console.log("VoiceService connected, sending midjourney data");
      initializeVoice();
      if (originalOnConnected) originalOnConnected();
    };

    // Cleanup
    return () => {
      clearInterval(checkConnectionInterval);
      // Restore original callback if it exists
      if (originalOnConnected) {
        VoiceService._callbacks.onConnected = originalOnConnected;
      }
    };
  }, [selfAssesmentScreenPayload, isVoiceReady, myraTurnedOnCount]);

  if (!subtypeQuestions) {
    return <p className="text-center mt-6">Invalid question flow.</p>;
  }

  const question = (() => {
    switch (subtypeQuestions.value) {
      case "a":
        return {
          id: "screen-q2a",
          name: "q2a",
          title: "Does gently arching your back or standing up straight help ease the pain?",
        };
      case "b":
        return {
          id: "screen-q2b",
          name: "q2b",
          title: "Does sitting down or slouching help ease the pain?",
        };
      case "e": // New case for rotation
        return {
          id: "screen-q2e",
          name: "q2e",
          title: "Does it feel better when you avoid twisting motions?",
        };
      case "c":
      case "d":
        return {
          id: "screen-q3",
          name: "q3",
          title: "Is changing positions the best way to find relief?",
        };
      default:
        return null;
    }
  })();

  const handleContinue = () => {
    window.screenTracker.exitScreen("self_assessment", {
      exitReason: "self_assessment_completed",
      completed: true,
    });
    const screenFlow = window.screenTracker.getScreenFlow();

    const probableSubtype = getSubtypeFromAnswers(subtypeQuestions.value, selectedAnswer);

    const updatedData = {
      ...assessmentData,
      selfAssessmentAnswer: selectedAnswer,
      probableSubtype,
      screenFlow: screenFlow,
      subtypeQuestions: subtypeQuestions,
      session_last_update: new Date().toISOString(),
    };

    updateAssessmentData(updatedData);
    localStorage.setItem("assessmentData", JSON.stringify(updatedData));

    // Modified on Aug 7th - for user tracking
    AnalyticsService.trackStep(updatedData);

    history.replace("/pre-npr");
  };
  const handleKeyDown = (e, value) => {
    if (e.key === "Enter") {
      onChange({ target: { name: question.name, value } });
    }
  };

  const onChange = (e) => {
    setSelectedAnswer(e.target.value);
  };

  return (
    <div className={styles.ScreenWrapper}>
      <div className={styles.ScreenModal}>
        <Header />
        <div>
          <div id={question.id} className={styles.ScreenSection}>
            <h3 className={styles.SectionTitle}>{question.title}</h3>
            <div className={styles.OptionRow}>
              {/* YES */}
              <input type="radio" autoComplete="off" name={question.name} id={`${question.name}_yes`} value="yes" className={styles.HiddenRadio} checked={selectedAnswer === "yes"} onChange={onChange} />
              <label htmlFor={`${question.name}_yes`} tabIndex={0} onKeyDown={(e) => handleKeyDown(e, "yes")} className={`${styles.OptionButton} ${selectedAnswer === "yes" ? styles.OptionSelected : styles.OptionUnselected}`}>
                <h4 className={styles.OptionText}>Yes</h4>
              </label>

              {/* NO / UNSURE */}
              <input type="radio" autoComplete="off" name={question.name} id={`${question.name}_no`} value="no" className={styles.HiddenRadio} checked={selectedAnswer === "no"} onChange={onChange} />
              <label htmlFor={`${question.name}_no`} tabIndex={0} onKeyDown={(e) => handleKeyDown(e, "no")} className={`${styles.OptionButton} ${selectedAnswer === "no" ? styles.OptionSelected : styles.OptionUnselected}`}>
                <h4 className={styles.OptionText}>No / Unsure</h4>
              </label>
            </div>
          </div>

          <CommonButton title="Continue" onClick={handleContinue} disabled={!selectedAnswer} />
        </div>
      </div>
    </div>
  );
};

// get pain colors component

const getInlinePainStyle = (value, isSelected) => {
  let color = "#10B981";
  let textColor = "#15803D";

  if (value > 3 && value <= 7) {
    color = "#F59E0B";
    textColor = "#CA8A04";
  } else if (value > 7) {
    color = "#EF4444";
    textColor = "#B91C1C";
  }

  return {
    borderColor: color,
    color: isSelected ? "white" : textColor,
    backgroundColor: isSelected ? color : "white",
    transform: isSelected ? "scale(1.1)" : "scale(1)",
  };
};

// pre-npr screen
export const PreNprScreen = () => {
  usePreventNavigation("/");
  useScrollToTop();
  const { setProgress } = useProgress();
  // Modified on Aug 7th - for user tracking
  const { assessmentData, updateAssessmentData } = useAssessment();
  let preNprScreenPayload = generatePayloadForScreen("nprs_symptoms", assessmentData);
  console.log("preNprScreenPayload data is : ", preNprScreenPayload);
  const history = useHistory();
  const [painLevel, setPainLevel] = useState(null);
  const [symptomDuration, setSymptomDuration] = useState("");
  const [isVoiceReady, setIsVoiceReady] = useState(false);
  const [myraTurnedOnCount, setMyraTurnedOnCount] = useState(0);

  useEffect(() => {
    setProgress(55);
    window.screenTracker.enterScreen("nprs_symptoms");
  }, []);

  useEffect(() => {
    let prevIsListening = VoiceService._isListening;
    const checkInterval = setInterval(() => {
      const currentIsListening = VoiceService._isListening;
      if (!prevIsListening && currentIsListening) {
        setMyraTurnedOnCount((prev) => prev + 1);
      }

      if (prevIsListening && !currentIsListening) {
        console.log("[Myra] Turned OFF");
        setIsVoiceReady(false);
      }
      prevIsListening = currentIsListening;
    }, 500);

    return () => clearInterval(checkInterval);
  }, []);

  useEffect(() => {
    window.initFromUserGesture();

    // Set up command handler immediately
    window.currentCommandsAudio = {
      ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent) => {
        if (intent === "continue_command") {
          if (!painLevel || !symptomDuration || painLevel === null || symptomDuration === "") {
            if (window.mayraCode) {
              window.mayraCode.doSay("Please make your selection before we can move to the next screen");
            }
          } else {
            handleContinue();
          }
        }
      },
      MOVE_ON: (value, speech, intent) => {
        if (!painLevel || !symptomDuration || painLevel === null || symptomDuration === "") {
          if (window.mayraCode) {
            window.mayraCode.doSay("Please make your selection before we can move to the next screen");
          }
        } else {
          handleContinue();
        }
      },
    };

    // Function to initialize voice when ready
    const initializeVoice = () => {
      if (window.mayraCode && typeof window.mayraCode.setIsVisible === "function") {
        VoiceService._currentFlow = "flow_gsa";
        window.currentFlow = "flow_gsa";
        window.mayraCode.setIsVisible(true);

        // Try to send data if WebSocket is ready
        if (VoiceService._ws?.readyState === WebSocket.OPEN) {
          VoiceService.sendMidJourneyData(preNprScreenPayload);
          setIsVoiceReady(true);
          console.log("Successfully sent midjourney data");
        }
      }
    };

    // Check immediately
    initializeVoice();

    // Set up interval to check WebSocket connection
    const checkConnectionInterval = setInterval(() => {
      if (VoiceService._ws?.readyState === WebSocket.OPEN && !isVoiceReady) {
        initializeVoice();
      }
    }, 1000);

    // Set up listener for WebSocket connection
    const originalOnConnected = VoiceService._callbacks?.onConnected;
    VoiceService._callbacks.onConnected = () => {
      console.log("VoiceService connected, sending midjourney data");
      initializeVoice();
      if (originalOnConnected) originalOnConnected();
    };

    // Cleanup
    return () => {
      clearInterval(checkConnectionInterval);
      // Restore original callback if it exists
      if (originalOnConnected) {
        VoiceService._callbacks.onConnected = originalOnConnected;
      }
    };
  }, [preNprScreenPayload, isVoiceReady, myraTurnedOnCount]);
  const handleContinue = () => {
    window.mayraCode.handleMicClick(true);
    VoiceService._currentFlow = null;
    window.currentFlow = null;
    if (window.initFromUserGesture) {
      window.initFromUserGesture();
    }
    // if (VoiceService._ws?.readyState === WebSocket.OPEN) {
    //   window.mayraCode.handleMicClick(true);
    //   VoiceService.stopAllVoiceActivity();
    //   VoiceService.forceStop();
    // }

    const nextTest = determineNextTest(assessmentData.probableSubtype, 1);
    const testName = nextTest?.name || "";

    window.screenTracker.exitScreen("nprs_symptoms", {
      exitReason: "npr_completed",
      completed: true,
    });
    const screenFlow = window.screenTracker.getScreenFlow();

    const updatedData = {
      ...assessmentData,
      painLevel,
      symptomDuration,
      floorCapability: testName === "Supine Double Knee to Chest" ? "" : "floor",
      completed_nprs: true,
      screenFlow: screenFlow,
      session_last_update: new Date().toISOString(),
    };

    updateAssessmentData(updatedData);
    localStorage.setItem("assessmentData", JSON.stringify(updatedData));

    // Modified on Aug 7th - for user tracking
    AnalyticsService.trackStep(updatedData);

    if (testName === "Supine Double Knee to Chest") {
      history.replace("/test-intro");
    } else {
      window.clickedOnceOpen = false;
      history.replace("/test-intro");
    }
  };
  const isFormComplete = painLevel !== null && symptomDuration !== "";
  const handleSymptomKeyDown = (e, value) => {
    if (e.key === "Enter") {
      setSymptomDuration(value);
    }
  };

  return (
    <div className={styles.ScreenWrapper}>
      <div className={styles.ScreenModal}>
        <Header />

        <div>
          <div id="screen-pre-nprs" className={styles.ScreenContainer}>
            <h3 className={styles.ScreenTitle}>Tell Us About Your Pain</h3>

            {/* Pain Level Section */}
            <div className={styles.PainSection}>
              <p className={styles.PainPrompt}>What is your pain level right now?</p>
              <p className={styles.PainSubtext}>(0 is no pain, 10 is the worst imaginable)</p>

              <div className={styles.PainGrid}>
                {Array.from({ length: 11 }, (_, i) => {
                  const isSelected = painLevel === i;

                  return (
                    <button key={i} type="button" tabIndex={0} onClick={() => setPainLevel(i)} onKeyDown={(e) => e.key === "Enter" && setPainLevel(i)} className={`${styles.PainCircle}`} style={getInlinePainStyle(i, isSelected)}>
                      {i}
                    </button>
                  );
                })}
              </div>

              <div className={styles.PainScaleLabels}>
                <span className={styles.NoPain}>No Pain</span>
                <span className={styles.WorstPain}>Worst Pain</span>
              </div>
            </div>

            {/* Symptom Duration Section */}
            <div className={styles.SymptomSection}>
              <p className={styles.PainPrompt}>How long have you been experiencing these symptoms?</p>
              <div id="symptom-duration-options" className={styles.OptionList}>
                {[
                  {
                    id: "duration-acute",
                    value: "ACUTE",
                    label: "Less than 6 weeks",
                  },
                  {
                    id: "duration-subacute",
                    value: "SUBACUTE",
                    label: "6 weeks to 3 months",
                  },
                  {
                    id: "duration-chronic",
                    value: "CHRONIC",
                    label: "More than 3 months",
                  },
                ].map(({ id, value, label }) => (
                  <div className={styles.OptionWrapper} key={id}>
                    <input type="radio" autoComplete="off" name="symptom-duration" id={id} value={value} className={styles.HiddenRadio} checked={symptomDuration === value} onChange={(e) => setSymptomDuration(e.target.value)} />
                    <label htmlFor={id} tabIndex={0} onKeyDown={(e) => handleSymptomKeyDown(e, value)} className={`${styles.OptionLabel} ${symptomDuration === value ? styles.OptionSelected : styles.OptionUnselected}`}>
                      <h4 className={styles.OptionLabelText}>{label}</h4>
                    </label>
                  </div>
                ))}
              </div>
            </div>

            {/* Continue Button */}
            <button id="pre-nprs-continue" onClick={handleContinue} className={styles.ContinueButton} disabled={!isFormComplete}>
              Continue
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

// floor capability screen floor-capability
export const FloorCapabilityScreen = () => {
  usePreventNavigation("/");
  const [selected, setSelected] = useState("");
  console.log("FloorCapabilityScreen Rendered : ", selected);
  const { assessmentData, updateAssessmentData } = useAssessment();
  console.log("painLevel : ", assessmentData.painLevel);

  const history = useHistory();
  const { setProgress } = useProgress();
  useEffect(() => {
    setProgress(60);
  }, []);

  const handleChange = (value) => {
    setSelected(value);
  };

  const handleKeyDown = (e, value) => {
    if (e.key === "Enter" || e.key === " ") {
      setSelected(value);
    }
  };

  const handleSubmit = () => {
    if (window.initFromUserGesture) {
      window.initFromUserGesture();
    }

    const updatedData = {
      ...assessmentData,
      floorCapability: selected,
    };

    updateAssessmentData(updatedData);
    localStorage.setItem("assessmentData", JSON.stringify(updatedData));

    window.clickedOnceOpen = false;

    // Modified on Aug 7th - for user tracking
    AnalyticsService.trackStep(updatedData);
    history.replace("/test-intro");
  };

  return (
    <div className={styles.ScreenWrapper}>
      <div className={styles.ScreenModal}>
        <Header />
        <h3 className={styles.capascrTitle}>Quick Check-In: What Works Best for You?</h3>
        <p className={styles.capascrDescription}>Your upcoming movement test is designed for the floor, but we want to make sure it’s comfortable for you. Let us know what works best for your current needs.</p>

        <div id="floor-capability-options-pre-test" className={styles.capascrOptions}>
          {[
            {
              id: "pre-capability-floor",
              value: "floor",
              label: "I’m comfortable getting on and off the floor",
            },
            {
              id: "pre-capability-bed",
              value: "bed",
              label: "I’d prefer to do it on my bed",
            },
            {
              id: "pre-capability-seated",
              value: "seated_standing",
              label: "I need a seated or standing option",
            },
          ].map((opt) => (
            <div key={opt.id} className={styles.capascrOption}>
              <input type="radio" name="floor-capability-pre-test" id={opt.id} value={opt.value} checked={selected === opt.value} onChange={() => handleChange(opt.value)} className={styles.capascrHiddenRadio} />
              <label htmlFor={opt.id} className={`${styles.capascrLabel} ${selected === opt.value ? styles.capascrSelected : ""}`} tabIndex={0} onKeyDown={(e) => handleKeyDown(e, opt.value)}>
                <h4 className={styles.capascrLabelText}>{opt.label}</h4>
              </label>
            </div>
          ))}
        </div>
        <CommonButton title={"Continue"} disabled={!selected} onClick={handleSubmit} />
      </div>
    </div>
  );
};

export function determineNextTest(probableSubtype, testNumber) {
  const selectedMap = testNumber === 1 ? testMap : negativeTestMap;
  return selectedMap[probableSubtype] || null;
}

// /intro-ar
export const IntroAR = () => {
  usePreventNavigation("/");
  const history = useHistory();
  const { setProgress } = useProgress();
  const { assessmentData } = useAssessment();
  console.log("IntroAR Rendered : ", assessmentData);
  let testName;
  if (assessmentData.floorCapability === "seated_standing") {
    testName = "Seated Single Knee to Chest";
  } else {
    const nextTest = determineNextTest(assessmentData.probableSubtype, 1);
    testName = nextTest?.name || "";
  }
  const introVideoUrl = testSpecificIntroVideos[testName] || DEFAULT_INTRO_VIDEO;
  console.log("IntroAR nextTest : ", testName);
  console.log("IntroAR video : ", introVideoUrl);
  useEffect(() => {
    setProgress(63);
  }, []);
  const onContinueHandler = () => {
    window.clickedOnceOpen = false;
    history.replace("/test-intro");
  };
  return (
    <div className={styles.ScreenWrapper}>
      <div className={styles.ScreenModal}>
        <Header />
        <h2 className={styles.introARHeading}>Get Ready for Your Test</h2>
        <p className={styles.introARSubtitle}>Follow these tips for the best results.</p>

        <div className={styles.introARVideoWrapper}>
          <video className={styles.introARVideo} controls autoPlay muted loop playsInline>
            <source src={introVideoUrl} type="video/mp4" />
          </video>
        </div>

        <button onClick={onContinueHandler} className={styles.introARButton}>
          Continue
        </button>
      </div>
    </div>
  );
};

// Usage example:
// const howChallengingPayload = generatePayloadForScreen('how_challenging', assessmentData);
// detect video command from value

const detectVideoCommand = (value) => {
  const text = value.toLowerCase().trim();

  if (text.includes("pause") || text.includes("paused")) {
    return "PAUSE";
  }

  if (text.includes("play") || text.includes("resume") || text.includes("playing")) {
    return "PLAY";
  }

  if (text.includes("skip") || text.includes("skipped")) {
    return "SKIP";
  }

  if (text.includes("replay") || text.includes("replaying") || text.includes("again")) {
    return "REPLAY";
  }

  if (text.includes("expand") || text.includes("fullscreen") || text.includes("full screen")) {
    return "EXPAND";
  }

  return null;
};
function useMyraVoiceAssistant(midjourneyData, options = {}) {
  const { maxRetries = 3, sendOnConnect = true } = options;

  const [state, setState] = useState({
    isConnected: false,
    isListening: false,
    isAgentSpeaking: false,
    isReady: false,
    lastDataSent: 0,
  });

  const prevStateRef = useRef(state);
  const midjourneyDataRef = useRef(midjourneyData);
  const isMountedRef = useRef(true);

  // Update ref when midjourneyData changes
  useEffect(() => {
    midjourneyDataRef.current = midjourneyData;
  }, [midjourneyData]);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  // Subscribe to VoiceService state changes
  useEffect(() => {
    if (!VoiceService._callbacks) return;

    // Save original callbacks
    const originalCallbacks = {
      onConnected: VoiceService._callbacks.onConnected,
      onAgentSpeechStart: VoiceService._callbacks.onAgentSpeechStart,
      onAgentSpeechEnd: VoiceService._callbacks.onAgentSpeechEnd,
      onListeningStart: VoiceService._callbacks.onListeningStart,
      onListeningStop: VoiceService._callbacks.onListeningStop,
    };

    // Override callbacks to update our state
    VoiceService._callbacks.onConnected = () => {
      console.log("[MyraHook] Connected callback");
      if (isMountedRef.current) {
        setState((prev) => ({ ...prev, isConnected: true }));

        // Send midjourney data on connection if option is enabled
        if (sendOnConnect && midjourneyDataRef.current) {
          setTimeout(() => sendMidJourneyDataWithRetry(), 500);
        }
      }
      originalCallbacks.onConnected();
    };

    VoiceService._callbacks.onAgentSpeechStart = () => {
      if (isMountedRef.current) {
        setState((prev) => ({ ...prev, isAgentSpeaking: true }));
      }
      originalCallbacks.onAgentSpeechStart();
    };

    VoiceService._callbacks.onAgentSpeechEnd = () => {
      if (isMountedRef.current) {
        setState((prev) => ({ ...prev, isAgentSpeaking: false }));
      }
      originalCallbacks.onAgentSpeechEnd();
    };

    VoiceService._callbacks.onListeningStart = () => {
      if (isMountedRef.current) {
        setState((prev) => ({ ...prev, isListening: true }));
      }
      originalCallbacks.onListeningStart();
    };

    VoiceService._callbacks.onListeningStop = () => {
      if (isMountedRef.current) {
        setState((prev) => ({ ...prev, isListening: false }));
      }
      originalCallbacks.onListeningStop();
    };

    // Restore original callbacks on cleanup
    return () => {
      if (VoiceService._callbacks && originalCallbacks) {
        VoiceService._callbacks.onConnected = originalCallbacks.onConnected;
        VoiceService._callbacks.onAgentSpeechStart = originalCallbacks.onAgentSpeechStart;
        VoiceService._callbacks.onAgentSpeechEnd = originalCallbacks.onAgentSpeechEnd;
        VoiceService._callbacks.onListeningStart = originalCallbacks.onListeningStart;
        VoiceService._callbacks.onListeningStop = originalCallbacks.onListeningStop;
      }
    };
  }, [sendOnConnect]);

  // Periodic state checking for redundancy
  useEffect(() => {
    const checkState = () => {
      if (!isMountedRef.current) return;

      const newState = {
        isConnected: VoiceService._ws?.readyState === WebSocket.OPEN,
        isListening: VoiceService._isListening,
        isAgentSpeaking: VoiceService._isAgentSpeaking,
        isReady: VoiceService._ws?.readyState === WebSocket.OPEN && VoiceService._isListening && !VoiceService._isAgentSpeaking,
        lastDataSent: state.lastDataSent,
      };

      const prevState = prevStateRef.current;

      // Detect state changes
      if (newState.isListening !== prevState.isListening) {
        console.log(`[MyraHook] Listening state changed: ${prevState.isListening} → ${newState.isListening}`);

        // Myra turned ON
        if (newState.isListening && !prevState.isListening) {
          console.log("[MyraHook] Myra turned ON - sending midjourney data");
          sendMidJourneyDataWithRetry();
        }

        // Myra turned OFF
        if (!newState.isListening && prevState.isListening) {
          console.log("[MyraHook] Myra turned OFF");
        }
      }

      // Detect connection changes
      if (newState.isConnected !== prevState.isConnected) {
        console.log(`[MyraHook] Connection state changed: ${prevState.isConnected} → ${newState.isConnected}`);

        // Reconnected while listening
        if (newState.isConnected && !prevState.isConnected && newState.isListening) {
          console.log("[MyraHook] Reconnected while listening - resending data");
          sendMidJourneyDataWithRetry();
        }
      }

      // Update refs and state
      if (JSON.stringify(newState) !== JSON.stringify(prevState)) {
        prevStateRef.current = newState;
        setState(newState);
      }
    };

    // Start checking state
    const interval = setInterval(checkState, 500);

    // Initial check
    setTimeout(checkState, 100);

    return () => clearInterval(interval);
  }, [state.lastDataSent]); // Only re-run when lastDataSent changes

  const sendMidJourneyDataWithRetry = useCallback(
    async (customData = null) => {
      const data = customData || midjourneyDataRef.current;
      if (!data) {
        console.warn("[MyraHook] No midjourney data to send");
        return false;
      }

      const sendAttempt = async (attempt = 1) => {
        try {
          if (!VoiceService._ws || VoiceService._ws.readyState !== WebSocket.OPEN) {
            throw new Error("WebSocket not connected");
          }

          console.log(`[MyraHook] Sending midjourney data (attempt ${attempt})`);
          const success = VoiceService.sendMidJourneyData(data);

          if (success) {
            console.log("[MyraHook] Midjourney data sent successfully");
            if (isMountedRef.current) {
              setState((prev) => ({
                ...prev,
                lastDataSent: Date.now(),
                isReady: true,
              }));
            }
            return true;
          } else {
            throw new Error("VoiceService.sendMidJourneyData returned false");
          }
        } catch (error) {
          console.warn(`[MyraHook] Failed to send midjourney data: ${error.message}`);

          if (attempt < maxRetries) {
            // Exponential backoff
            const delay = Math.min(5000, 1000 * Math.pow(2, attempt - 1));
            console.log(`[MyraHook] Retrying in ${delay}ms...`);

            await new Promise((resolve) => setTimeout(resolve, delay));
            return sendAttempt(attempt + 1);
          }

          console.error("[MyraHook] Max retries exceeded");
          return false;
        }
      };

      return sendAttempt();
    },
    [maxRetries],
  );

  // Manual send function
  const sendMidJourneyData = useCallback(
    (customData = null) => {
      return sendMidJourneyDataWithRetry(customData);
    },
    [sendMidJourneyDataWithRetry],
  );

  // Force send when Myra is turned on via bubble click
  const forceSendOnMyraToggle = useCallback(() => {
    console.log("[MyraHook] Force sending data on Myra toggle");
    return sendMidJourneyDataWithRetry();
  }, [sendMidJourneyDataWithRetry]);

  return {
    state,
    sendMidJourneyData,
    forceSendOnMyraToggle,
  };
}
export const TestIntroScreen = () => {
  usePreventNavigation("/");
  useScrollToTop();
  const { setProgress } = useProgress();
  // Modified on Aug 7th - for user tracking
  const { assessmentData, updateAssessmentData } = useAssessment();
  const floorCapability = assessmentData?.floorCapability || "floor";
  const probableSubtype = assessmentData?.probableSubtype || "NEUTRAL_SENSITIVE";
  const [videoUrl, setVideoUrl] = useState("");
  const currentTestPhase = 1;
  const testPool = currentTestPhase === 1 ? testMap : negativeTestMap;
  const [isVoiceAssistantReady, setIsVoiceAssistantReady] = useState(false);
  let test = testPool[probableSubtype];
  let currentTest = test.name;
  const testIntroPayload = generatePayloadForScreen("test1_demo", assessmentData, currentTest);
  let cameraPayload = generatePayloadForScreen("camera_permission", assessmentData,currentTest);
  window.cameraPayload = cameraPayload;
  let movementTestPayload = generatePayloadForScreen("movement_test_1", assessmentData, currentTest);
  window.movementTestPayload = movementTestPayload;
  const [isVoiceReady, setIsVoiceReady] = useState(false);
  const { state: voiceState, sendMidJourneyData, forceSendOnMyraToggle } = useMyraVoiceAssistant(testIntroPayload, { maxRetries: 3, sendOnConnect: true });

  useEffect(() => {
    setIsVoiceReady(voiceState.isReady);
    setIsVoiceAssistantReady(voiceState.isConnected && voiceState.isListening);
  }, [voiceState.isReady, voiceState.isConnected, voiceState.isListening]);

  useEffect(() => {
    let prevIsListening = VoiceService._isListening;
    const checkInterval = setInterval(() => {
      const currentIsListening = VoiceService._isListening;
      if (!prevIsListening && currentIsListening) {
        VoiceService.sendMidJourneyData(testIntroPayload);
      }

      if (prevIsListening && !currentIsListening) {
        console.log("[Myra] Turned OFF");
        setIsVoiceReady(false);
      }
      prevIsListening = currentIsListening;
    }, 500);

    return () => clearInterval(checkInterval);
  }, []);

  // console.log("Test is  : ", test);
  // console.log("testPool is  : ", testPool);
  const videoRef = useRef(null);
  const history = useHistory();
  window.doNextLocation = history;
  useEffect(() => {
    window.screenTracker.enterScreen("test1_demo");
    window.videoController = {
      pause: () => {
        if (videoRef.current) {
          videoRef.current.pause();
          console.log("Video paused via global controller");
        }
      },
      play: () => {
        if (videoRef.current) {
          videoRef.current.play().catch((err) => console.log("Video play failed:", err));
        }
      },
      expand: () => {
        if (videoRef.current) {
          document.body.classList.add("videoplay-expanded");
          if (document.getElementById("rom-test-video")) {
            document.getElementById("rom-test-video").onclick = function () {
              document.body.classList.remove("videoplay-expanded");
            };
          }
        }
      },
      replay: () => {
        if (videoRef.current) {
          videoRef.current.currentTime = 0;
          videoRef.current.play().catch((err) => console.log("Video replay failed:", err));
        }
      },
      isPaused: () => videoRef.current?.paused ?? true,
    };

    /*
    return () => {
      console.log("Cleaning up TestIntroScreen...");

      // Stop all audio before cleanup
      if (window.stopAudio) {
        try {
          window.stopAudio();
          console.log("Stopped all audio in cleanup");
        } catch (e) {
          console.warn("Failed to stop audio:", e);
        }
      }

      // Pause and release the main video
      if (videoRef.current) {
        try {
          videoRef.current.pause();
          videoRef.current.src = "";
          videoRef.current.load();
        } catch (e) {
          console.warn("Failed to stop main video:", e);
        }
      }

      // Remove the secondary intro video if it was created dynamically
      const secondVideo = document.getElementById("secondTestVideo");
      if (secondVideo) {
        try {
          secondVideo.pause();
          secondVideo.src = "";
          secondVideo.load();
          secondVideo.remove();
          console.log("Removed secondary video element");
        } catch (e) {
          console.warn("Failed to remove secondary video:", e);
        }
      }

      // Clear global handlers to avoid leaks
      window.videoController = null;
      window.unlockAllVideos = null;
      window.currentCommandsAudio = {};

      // Optional: pause Myra (voice) system if active
      if (window.mayraCode && typeof window.mayraCode.disableCallback === "function") {
        try {
          window.mayraCode.disableCallback();
        } catch (e) {
          console.warn("Failed to disable Mayra callback:", e);
        }
      }

      // Remove any 'videoplay-expanded' class just in case
      document.body.classList.remove("videoplay-expanded");
    };
	
	*/
  }, []);
  useEffect(() => {
    if (test) {
      let secondtest = "Seated Trunk Rotation";

      if (test.name === "Standing Lumbar Extension") {
        secondtest = "Toe Touch";
      } else if (test.name === "Standing Side Bend") {
        secondtest = "Seated Trunk Rotation";
      } else if (test.name === "Seated Single Knee to Chest") {
        secondtest = "Standing Lumbar Extension";
      }

      console.log("Second Test:", secondtest);

      // Create the video element
      const video = document.createElement("video");
      const videoUrl = testSpecificIntroVideos[secondtest];

      video.id = "secondTestVideo";
      video.src = videoUrl;
      video.muted = false;
      video.autoplay = false;
      video.setAttribute("playsinline", "true");
      video.setAttribute("webkit-playsinline", "true"); // iOS Safari prefix
      video.controls = true;

      video.style.position = "absolute";
      video.style.left = "0px";
      video.style.bottom = "0px";
      video.style.width = "1px";
      video.style.height = "1px";

      // Append to the body
      document.body.appendChild(video);

      if (secondtest === "Toe Touch") {
        const video2 = document.createElement("video");
        const videoUrl2 = testSpecificIntroVideos["Seated Trunk Rotation"];

        video2.id = "secondTestVideo2";
        video2.src = videoUrl2;
        video2.muted = false;
        video2.autoplay = false;
        video2.setAttribute("playsinline", "true");
        video2.setAttribute("webkit-playsinline", "true"); // iOS Safari prefix
        video2.controls = true;

        video2.style.position = "absolute";
        video2.style.left = "0px";
        video2.style.bottom = "0px";
        video2.style.width = "1px";
        video2.style.height = "1px";

        // Append to the body
        document.body.appendChild(video2);

        window.hasSecondVideoRotation = true;
      }

      if (secondtest === "Toe Touch") {
        const video2 = document.createElement("video");
        const videoUrl2 = testSpecificIntroVideos["Seated Trunk Rotation"];

        video2.id = "secondTestVideo2";
        video2.src = videoUrl2;
        video2.muted = false;
        video2.autoplay = false;
        video2.setAttribute("playsinline", "true");
        video2.setAttribute("webkit-playsinline", "true"); // iOS Safari prefix
        video2.controls = true;

        video2.style.position = "absolute";
        video2.style.left = "0px";
        video2.style.bottom = "0px";
        video2.style.width = "1px";
        video2.style.height = "1px";

        // Append to the body
        document.body.appendChild(video2);

        window.hasSecondVideoRotation = true;
      }

      window.unlockAllVideos = () => {
        if (document.getElementById("secondTestVideo")) {
          document
            .getElementById("secondTestVideo")
            .play()
            .then(() => {
              document.getElementById("secondTestVideo").pause();
            })
            .catch((err) => {
              console.log("Unlock failed 1:", err);
            });
        }

        if (document.getElementById("secondTestVideo2")) {
          document
            .getElementById("secondTestVideo2")
            .play()
            .then(() => {
              document.getElementById("secondTestVideo2").pause();
            })
            .catch((err) => {
              console.log("Unlock failed 2:", err);
            });
        }
      };
    }
  }, [test]);

  useEffect(() => {
    setProgress(65);
    if (window.mayraCode) {
      window.mayraForwardCode = {
        midjourneyData: testIntroPayload,
      };
      window.mayraCode.setOnMicEnabled(null);
      // window.mayraCode.setIsVisible(true);
      window.mayraCode.setOnMicEnabled((enabledBefore) => {
        console.log("Already enabled", enabledBefore);
        window.mayraCode.setOnMicEnabled(null);
        window.mayraCode.setIsVisible(true);
        if (window.preloadAllAudios) {
          window.preloadAllAudios();
        }
        if (window.videoUnlockPlay) {
          window.videoUnlockPlay();
        }

        const userName = localStorage.getItem("self_name") || "";

        // If enabled before and have name - listen for skip video only
        setTimeout(() => {
          if (userName) {
            window.mayraCode.startFlow("flow_demo_video", "first_test_have_name", () => {
              setTimeout(() => {
                doReplyVideo();
              }, 300);
            });
            // Enable skip or reply video
            window.currentCommandsAudio = {
              SKIP_VIDEO: () => {
                if (window.videoController) {
                  window.videoController.pause();
                }
                doPauseVideo();
                window.mayraCode.doSay("Got it! Skipping the video.", () => {
                  setTimeout(() => {
                    handleContinue();
                  }, 500);
                });
              },
              REPLAY_VIDEO: () => {
                if (window.videoController) {
                  window.videoController.pause();
                }
                doPauseVideo();
                window.mayraCode.doSay("Sure! I'll replay the video for you.", () => {
                  doReplyVideo();
                  if (window.videoController) {
                    window.videoController.replay();
                  }
                });
              },
              PAUSE_VIDEO: () => {
                if (window._lastPauseTime && Date.now() - window._lastPauseTime < 2000) return;
                if (window.videoController) {
                  const wasAlreadyPaused = window.videoController.isPaused();

                  if (wasAlreadyPaused) {
                    window.mayraCode.doSay("The video is already paused.");
                  } else {
                    // Not paused → pause it
                    if (window.audioPlayer && window.audioPlayer.pcm) {
                      if (typeof window.audioPlayer.ttsPcmAbort === "function") {
                        window.audioPlayer.ttsPcmAbort();
                      }
                      window.audioPlayer.pcm.active = false;
                      window.audioPlayer.pcm.queuedSamples = 0;
                    }
                    window.videoController.pause();
                    window.mayraCode.doSay("Sure! I’ll pause the video for you. When you’re ready to continue, just say Myra, resume the video.", () => {
                      window._lastPauseTime = Date.now();
                      doPauseVideo();
                    });
                  }
                }
              },

              RESUME_VIDEO: () => {
                if (window.videoController && window.videoController.isPaused()) {
                  window.mayraCode.doSay("Sure! I'll re-zume the video for you.", () => {
                    setTimeout(() => {
                      window.videoController.play();
                    }, 400);
                  });
                }
              },
              EXPAND_VIDEO: () => {
                if (window.videoController) {
                  window.videoController.pause();
                  window.mayraCode.doSay("Sure! I'll expand the video for you.", () => {
                    window.videoController.expand();
                    setTimeout(() => {
                      window.videoController.play();
                    }, 400);
                  });
                }
              },
              INVALID_COMMAND: () => {
                if (window.videoController) {
                  window.videoController.pause();
                  window.mayraCode.doSay("I didn’t catch that one. Here's what I can help with: Skip the video, Replay the video, pauze the video, and Expand the video", () => {
                    setTimeout(() => {
                      window.videoController.play();
                    }, 400);
                  });
                }
              },
              VALID_COMMAND: () => {
                if (window.videoController) {
                  window.videoController.pause();
                  window.mayraCode.doSay("On this screen I can help you with the following : Skip the video, Replay the video, pauze the video, and Expand the video", () => {
                    setTimeout(() => {
                      window.videoController.play();
                    }, 400);
                  });
                }
              },
            };
          } else {
            // If not enabled or don't have name - ask for name
            if (enabledBefore) {
              window.mayraCode.startFlow("flow_get_name", "first_test_no_name");
            } else {
              window.mayraCode.startFlow("flow_get_name", "first_test");
            }

            window.currentCommandsAudio = {
              GIVE_NAME: (nameGiven) => {
                console.log("Got name", nameGiven);
                localStorage.setItem("self_name", nameGiven);
                window.mayraCode.startFlow("flow_demo_video", "first_video_play_name", () => {
                  doReplyVideo();
                });

                // Enable skip or reply video
                window.currentCommandsAudio = {
                  SKIP_VIDEO: () => {
                    doPauseVideo();
                    window.mayraCode.doSay("Got it! Skipping the video.", () => {
                      setTimeout(() => {
                        handleContinue();
                      }, 500);
                    });
                  },
                  REPLAY_VIDEO: () => {
                    doPauseVideo();
                    window.mayraCode.doSay("Sure! I'll replay the video for you.", () => {
                      setTimeout(() => {
                        doReplyVideo();
                      }, 400);
                    });
                  },
                  PAUSE_VIDEO: () => {
                    if (window.videoController) {
                      if (window.videoController.isPaused()) {
                        // Already paused
                        window.mayraCode.doSay("The video is already paused.");
                      } else {
                        // Not paused → pause it
                        window.videoController.pause();
                        window.mayraCode.doSay("Sure! I’ll pause the video for you. When you’re ready to continue, just say Myra, resume the video.", () => {
                          doPauseVideo();
                        });
                      }
                    }
                  },

                  RESUME_VIDEO: () => {
                    if (window.videoController && window.videoController.isPaused()) {
                      window.mayraCode.doSay("Sure! I'll re-zume the video for you.", () => {
                        setTimeout(() => {
                          window.videoController.play();
                        }, 400);
                      });
                    }
                  },
                  EXPAND_VIDEO: () => {
                    if (window.videoController) {
                      window.videoController.pause();
                      window.mayraCode.doSay("Sure! I'll expand the video for you.", () => {
                        window.videoController.expand();
                        setTimeout(() => {
                          window.videoController.play();
                        }, 400);
                      });
                    }
                  },
                  INVALID_COMMAND: () => {
                    if (window.videoController) {
                      window.videoController.pause();
                      window.mayraCode.doSay("I didn’t catch that one. Here's what I can help with: Skip the video, Replay the video, pauze the video, and Expand the video", () => {
                        setTimeout(() => {
                          window.videoController.play();
                        }, 400);
                      });
                    }
                  },
                  VALID_COMMAND: () => {
                    if (window.videoController) {
                      window.videoController.pause();
                      window.mayraCode.doSay("On this screen I can help you with the following : Skip the video, Replay the video, pauze the video, and Expand the video", () => {
                        setTimeout(() => {
                          window.videoController.play();
                        }, 400);
                      });
                    }
                  },
                };
              },
              SKIP_NAME: () => {
                console.log("No name name");
                window.mayraCode.startFlow("flow_demo_video", "first_video_play_skip_name", () => {
                  doReplyVideo();
                });

                // Enable skip or reply video
                window.currentCommandsAudio = {
                  SKIP_VIDEO: () => {
                    doPauseVideo();
                    window.mayraCode.doSay("Got it! Skipping the video.", () => {
                      setTimeout(() => {
                        handleContinue();
                      }, 500);
                    });
                  },
                  REPLAY_VIDEO: () => {
                    doPauseVideo();
                    window.mayraCode.doSay("Sure! I'll replay the video for you.", () => {
                      setTimeout(() => {
                        doReplyVideo();
                      }, 400);
                    });
                  },
                  PAUSE_VIDEO: () => {
                    if (window.videoController) {
                      if (window.videoController.isPaused()) {
                        // Already paused
                        window.mayraCode.doSay("The video is already paused.");
                      } else {
                        // Not paused → pause it
                        window.videoController.pause();
                        window.mayraCode.doSay("Sure! I’ll pause the video for you. When you’re ready to continue, just say Myra, resume the video.", () => {
                          doPauseVideo();
                        });
                      }
                    }
                  },

                  RESUME_VIDEO: () => {
                    if (window.videoController && window.videoController.isPaused()) {
                      window.mayraCode.doSay("Sure! I'll re-zume the video for you.", () => {
                        setTimeout(() => {
                          window.videoController.play();
                        }, 400);
                      });
                    }
                  },
                  EXPAND_VIDEO: () => {
                    if (window.videoController) {
                      window.videoController.pause();
                      window.mayraCode.doSay("Sure! I'll expand the video for you.", () => {
                        window.videoController.expand();
                        setTimeout(() => {
                          window.videoController.play();
                        }, 400);
                      });
                    }
                  },
                  INVALID_COMMAND: () => {
                    if (window.videoController) {
                      window.videoController.pause();
                      window.mayraCode.doSay("I didn’t catch that one. Here's what I can help with: Skip the video, Replay the video, pauze the video, and Expand the video", () => {
                        setTimeout(() => {
                          window.videoController.play();
                        }, 400);
                      });
                    }
                  },
                  VALID_COMMAND: () => {
                    if (window.videoController) {
                      window.videoController.pause();
                      window.mayraCode.doSay("On this screen I can help you with the following : Skip the video, Replay the video, pauze the video, and Expand the video", () => {
                        setTimeout(() => {
                          window.videoController.play();
                        }, 400);
                      });
                    }
                  },
                };
              },
            };
          }
        }, 2000);
      });

      window.mayraCode.handleMicClick(true);
    }
  }, []);
  // window.mayraCode && window.mayraCode.doSay
  useEffect(() => {
    const videoElement = videoRef.current;
    if (!videoElement) return;

    const handleVideoEnd = () => {
      try {
        const videoWatchedFully = true;
        const videoDurationWatched = Math.round(videoElement.duration);
        assessmentData.test1VideoWatched = videoWatchedFully;
        assessmentData.test1VideoDuration = videoDurationWatched;
        assessmentData.watched_demo_1 = true;
        if (isVoiceAssistantReady) {
          window.mayraCode.doSay("Now, that you’ve seen how it works, let’s move to the next step.", () => {
            handleContinue();
          });
          console.log("Sent speech command to backend");
        } else {
          console.warn("WebSocket not connected - cannot send speech command");
        }
      } catch (error) {
        console.error("Error sending speech command:", error);
      }
    };
    // Add event listener for video end
    videoElement.addEventListener("ended", handleVideoEnd);

    // Cleanup function to remove event listener
    return () => {
      if (videoElement) {
        videoElement.removeEventListener("ended", handleVideoEnd);
      }
    };
  }, [isVoiceAssistantReady]);
  useEffect(() => {
    const checkVoiceAssistant = () => {
      const isReady = !!(window.mayraCode && window.mayraCode.doSay && window.mayraCode.isEnabled);
      setIsVoiceAssistantReady(isReady);
    };

    // Check initially
    checkVoiceAssistant();

    // Seting up periodic checking
    const interval = setInterval(checkVoiceAssistant, 1000);
    return () => clearInterval(interval);
  }, []);
  // useEffect(() => {
  //   const initializeVoice = () => {
  //     if (window.mayraCode && typeof window.mayraCode.setIsVisible === "function") {
  //       if (VoiceService._ws?.readyState === WebSocket.OPEN) {
  //         VoiceService.sendMidJourneyData(testIntroPayload);
  //         setIsVoiceReady(true);
  //       }
  //     }
  //   };
  //   initializeVoice();
  //   const checkConnectionInterval = setInterval(() => {
  //     if (VoiceService._ws?.readyState === WebSocket.OPEN && !isVoiceReady) {
  //       initializeVoice();
  //     }
  //   }, 1000);
  //   const originalOnConnected = VoiceService._callbacks?.onConnected;
  //   VoiceService._callbacks.onConnected = () => {
  //     initializeVoice();
  //     if (originalOnConnected) originalOnConnected();
  //   };
  //   return () => {
  //     clearInterval(checkConnectionInterval);
  //     if (originalOnConnected) {
  //       VoiceService._callbacks.onConnected = originalOnConnected;
  //     }
  //   };
  // }, [testIntroPayload, isVoiceReady]);

  // this useeffect will check if the video is manually played then stop agent speech
  useEffect(() => {
    const videoElement = videoRef.current;
    if (!videoElement) return;

    // Simple event listener for video play
    const handleVideoPlay = () => {
      console.log("[VIDEO] Manual play detected - stopping agent speech");

      // Stop agent speech immediately
      VoiceService.stopAgentSpeech();
    };

    // Add event listener
    videoElement.addEventListener("play", handleVideoPlay);

    // Cleanup
    return () => {
      if (videoElement) {
        videoElement.removeEventListener("play", handleVideoPlay);
      }
    };
  }, []);

  const doReplyVideo = () => {
    if (window.clickedOnceOpen) {
      return false;
    }
    const video = videoRef.current;
    if (!video) {
      console.error("Video element not found");
      return;
    }
    videoRef.current.currentTime = 0;
    videoRef.current.play().catch((err) => console.log("Replay autoplay prevented:", err));
  };

  const doPauseVideo = () => {
    videoRef.current.pause();
  };

  if (floorCapability === "seated_standing") {
    if (test?.name === "Supine Double Knee to Chest") {
      test = { ...testMap.SUBSTITUTE_TEST_1 };
      console.log("Test is  : ", test);
    }
    if (test?.name === "Prone Press Up") {
      test = { ...negativeTestMap.SUBSTITUTE_TEST_2 };
    }
  }
  if (test?.name === "Supine Double Knee to Chest") {
    test = { ...testMap.SUBSTITUTE_TEST_1 };
  }

  const handleContinue = () => {
    doPauseVideo();
    VoiceService._resetAllState();

    const demoVideo1 = document.getElementById("rom-test-video");
    if (demoVideo1) {
      try {
        // Calculate video watching metrics before removing
        let videoWatchedFully = false;
        let videoDurationWatched = 0;

        if (demoVideo1) {
          videoDurationWatched = Math.round(demoVideo1.currentTime);

          // Check if video was watched to at least 90% completion
          if (demoVideo1.duration > 0) {
            const completionPercentage = (demoVideo1.currentTime / demoVideo1.duration) * 100;
            videoWatchedFully = completionPercentage >= 90;
          }
        }
        demoVideo1.muted = true;

        demoVideo1.pause();
        demoVideo1.removeAttribute("src");
        demoVideo1.load();
        demoVideo1.remove();

        // Store video watching metrics
        assessmentData.watched_demo_1 = true;
        assessmentData.test1VideoWatched = videoWatchedFully;
        assessmentData.test1VideoDuration = videoDurationWatched;
      } catch (err) {
        console.warn("Failed removing demoVideo1:", err);
      }
    }
    window.cameraPayload = cameraPayload;
    window.movementTestPayload = movementTestPayload;

    const testonevideoContainer = document.getElementById("testonevideo");
    if (testonevideoContainer) testonevideoContainer.innerHTML = "";

    // Stop all audio including Myra TTS before starting movement test
    if (window.stopAudio) {
      window.stopAudio();
    }

    if (window.preloadAllAudios) {
      window.preloadAllAudios();
    }
    if (window.videoUnlockPlay) {
      window.videoUnlockPlay();
    }
    window.screenTracker.exitScreen("test1_demo", {
      exitReason: "started_test",
      completed: true,
      videoWatched: true,
      videoSkipped: false,
    });
    const screenFlow = window.screenTracker.getScreenFlow();

    const updatedData = {
      ...assessmentData,
      testName: test.name,
      // Video watching metrics
      test1VideoWatched: assessmentData.test1VideoWatched || false,
      test1VideoDuration: assessmentData.test1VideoDuration || 0,
      rom_test1_name: test.name,
      screenFlow: screenFlow,
      watched_demo_1: assessmentData.watched_demo_1 || false,
      rom_test1_started: true,
      session_last_update: new Date().toISOString(),
    };

    window.assessmentChangeExercise = false;
    if (test.name === "Standing Lumbar Extension" && probableSubtype === "ROTATIONAL_INTOLERANT") {
      updatedData.probableSubtype = "ROTATIONAL_INTOLERANT";
      updatedData.finalPainSubtype = "ROTATIONAL_INTOLERANT";
      window.assessmentChangeExercise = true;
    }

    if (window.clickedOnceOpen) {
      return false;
    }

    document.body.classList.remove("videoplay-expanded");

    if (window.mayraCode) {
      window.mayraCode.disableCallback();
    }
    window.currentCommandsAudio = {};

    updateAssessmentData(updatedData);
    localStorage.setItem("assessmentData", JSON.stringify(updatedData));
    localStorage.setItem("runStep", "1");
    localStorage.setItem("loadSelf", test.name);
    if (window.loadROMExercises) {
      window.loadROMExercises(true);
    }

    // Modified on Aug 7th - for user tracking
    AnalyticsService.trackStep(updatedData);

    if (document.querySelector("#assesmentDiv video")) {
      document.querySelector("#assesmentDiv video").pause();
      document.querySelector("#assesmentDiv video").removeAttribute("autoplay");
    }

    window.clickedOnceOpen = true;
    window.doNextLocation = history;

    if (document.querySelector(".rom-test-start-button")) {
      document.querySelector(".rom-test-start-button").innerHTML = "Loading Movement Test…";
    }

    console.log("Tried open");
    VoiceService.sendMidJourneyData(cameraPayload);

    if (window.doCameraScreenStart) {
      window.doCameraScreenStart();
      console.log("Tried open - ready");
    } else {
      let openIntervalCheck = setInterval(() => {
        if (window.doCameraScreenStart) {
          window.doCameraScreenStart();
          console.log("Tried open - ready");
          clearInterval(openIntervalCheck);
        } else {
          console.log("Tried open - not ready");
        }
      }, 1000);
    }
  };
  const key = test?.name?.trim();
  const videoUrlSafe = testSpecificIntroVideos[key] || DEFAULT_INTRO_VIDEO;

  useEffect(() => {
    if (!test) return;
    setVideoUrl(videoUrlSafe);
  }, [test]);

  if (!test) {
    return (
      <div className="text-center p-6">
        <p className="text-gray-500">Loading test instructions...</p>
      </div>
    );
  }
  // const videoUrl = testSpecificIntroVideos[key] ? testSpecificIntroVideos[key] : DEFAULT_INTRO_VIDEO;
  // console.log("Selected key:", `"${key}"`);
  // console.log("Video URL:", videoUrl);

  return (
    <div className={styles.ScreenWrapper}>
      <div className={styles.ScreenModal}>
        <Header />
        <div>
          <div id="screen-rom-intro" className={styles.ScreenContainer}>
            <Heading heading="Movement Test" />
            <SubHeading subheading="This helps us better understand your movement." />
            <div className={styles.VideoContainer} id="testonevideo">
              {videoUrl && (
                <video
                  id="rom-test-video"
                  preload="auto"
                  className={styles.Video}
                  controls
                  playsInline
                  ref={videoRef}
                  onError={(e) => {
                    console.error("Video failed:", videoUrl, e);
                  }}
                  onLoadedData={() => console.log("Video loaded:", videoUrl)}
                  onCanPlay={() => console.log("Video can play:", videoUrl)}
                >
                  <source src={videoUrl} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              )}
            </div>
            {test.name && (
              <div id="rom-test-instruction" className={styles.InstructionBox}>
                <h4 className={styles.InstructionTitle}>{test.name}</h4>
                <p className={styles.InstructionText}>
                  You will be performing 10 reps.
                  <br />{" "}
                  <span
                    style={{
                      textDecoration: "underline",
                      fontWeight: "bold",
                    }}
                  >
                    Important{" "}
                  </span>{" "}
                  : Stop & Press <strong>Skip Exercise</strong> if you feel a significant increase in pain.
                </p>
              </div>
            )}
            <CommonButton className="rom-test-start-button" title="Set Up Your Device" onClick={handleContinue} />
          </div>
        </div>
      </div>
    </div>
  );
};
// helper getRpeClass function
const getRpeClass = (i) => {
  if (i <= 3) return "RpeBlue";
  if (i <= 7) return "RpeIndigo";
  return "RpePurple";
};
const calculateStdDev = (values) => {
  if (!values.length) return 0;
  const mean = values.reduce((sum, v) => sum + v, 0) / values.length;
  const variance = values.reduce((sum, v) => sum + Math.pow(v - mean, 2), 0) / values.length;
  return Math.sqrt(variance).toFixed(2);
};

function getRpeResponseText(normalized) {
  let agentReply = "";
  if (normalized >= 0 && normalized <= 2) {
    agentReply = "Easy—great to hear! Let’s move on to the next step.";
  } else if (normalized >= 3 && normalized <= 4) {
    agentReply = "Kinda Easy—great to hear! Let’s move on to the next step.";
  } else if (normalized >= 5 && normalized <= 6) {
    agentReply = "Just right—great! Let’s move on to the next step.";
  } else if (normalized >= 7 && normalized <= 8) {
    agentReply = "Kinda Hard—thanks for letting me know. Let’s move on to the next step.";
  } else if (normalized >= 9 && normalized <= 10) {
    agentReply = "Hard—thanks for letting me know. Let’s move on to the next step.";
  }
  return agentReply;
}
function parseDataAfterInfo() {
  let dataString = localStorage.getItem("dataAfterInfo");
  let parsedData = [];

  try {
    parsedData = JSON.parse(dataString);
    if (typeof parsedData === "string") {
      parsedData = JSON.parse(parsedData);
    }
    if (!Array.isArray(parsedData)) {
      throw new Error("Data is not an array");
    }
    const rom = parsedData.map((item) => item[0] || item[4]);
    const dur = parsedData.map((item) => Math.round(item[3] / 1000));
    return { rom, dur };
  } catch (e) {
    console.error("Failed to parse dataAfterInfo:", e);
    return { rom: [], dur: [] };
  }
}
// AI Processing Loader Component
const AIProcessingLoader = ({ message, isVisible }) => {
  if (!isVisible) return null;

  return (
    <div className={styles.aiLoaderOverlay}>
      <div className={styles.aiLoaderContainer}>
        <p className={styles.aiLoaderText}>{message}</p>
        <div className={styles.aiLoaderSpinner}>
          <div className={styles.aiLoaderBounce1}></div>
          <div className={styles.aiLoaderBounce2}></div>
          <div className={styles.aiLoaderBounce3}></div>
        </div>
      </div>
    </div>
  );
};

// How challenging screen
export const HowChallengingScreen = () => {
  usePreventNavigation("/");
  useScrollToTop();
  const { setProgress } = useProgress();
  // Modified on Aug 7th - for user tracking
  const { updateAssessmentData, assessmentData } = useAssessment();
  const [romValues, setRomValues] = useState([]);
  const [durations, setDurations] = useState([]);
  const [romStdDev, setRomStdDev] = useState(0);
  const [repTimeStdDev, setRepTimeStdDev] = useState(0);
  const howChallengingPayload = generatePayloadForScreen("test1_rpe", assessmentData);
  window.movementTestPayload = null;
  const [isVoiceReady, setIsVoiceReady] = useState(false);

  console.log("rom values : ", romValues);
  console.log("dur values : ", durations);
  useEffect(() => {
    if (repTimeStdDev > 0 || romStdDev > 0) {
      const updatedData = {
        ...assessmentData,
        romStdDev: romStdDev,
        repTimeStdDev: repTimeStdDev,
      };
      updateAssessmentData(updatedData);
      localStorage.setItem("assessmentData", JSON.stringify(updatedData));
    }
  }, [repTimeStdDev, romStdDev]);

  const [selectedRPE, setSelectedRPE] = useState(null);
  const history = useHistory();
  useEffect(() => {
    let prevIsListening = VoiceService._isListening;
    const checkInterval = setInterval(() => {
      const currentIsListening = VoiceService._isListening;
      if (!prevIsListening && currentIsListening) {
        VoiceService.sendMidJourneyData(howChallengingPayload);
      }

      if (prevIsListening && !currentIsListening) {
        console.log("[Myra] Turned OFF");
        setIsVoiceReady(false);
      }
      prevIsListening = currentIsListening;
    }, 500);

    return () => clearInterval(checkInterval);
  }, []);

  useEffect(() => {
    if (selectedRPE !== null) {
      const updatedData = {
        ...assessmentData,
        rpe: selectedRPE,
      };
      updateAssessmentData(updatedData);
      localStorage.setItem("assessmentData", JSON.stringify(updatedData));
    }
  }, [selectedRPE]);
  useEffect(() => {
    window.initFromUserGesture();
    const initializeVoice = () => {
      if (window.mayraCode && typeof window.mayraCode.setIsVisible === "function") {
        if (VoiceService._ws?.readyState === WebSocket.OPEN) {
          VoiceService.sendMidJourneyData(howChallengingPayload);
          setIsVoiceReady(true);
        }
      }
    };
    initializeVoice();
    const checkConnectionInterval = setInterval(() => {
      if (VoiceService._ws?.readyState === WebSocket.OPEN && !isVoiceReady) {
        initializeVoice();
      }
    }, 1000);
    const originalOnConnected = VoiceService._callbacks?.onConnected;
    VoiceService._callbacks.onConnected = () => {
      initializeVoice();
      if (originalOnConnected) originalOnConnected();
    };
    return () => {
      clearInterval(checkConnectionInterval);
      if (originalOnConnected) {
        VoiceService._callbacks.onConnected = originalOnConnected;
      }
    };
  }, [howChallengingPayload, isVoiceReady]);

  useEffect(() => {
    window.screenTracker.enterScreen("test1_rpe");
    const { rom, dur } = parseDataAfterInfo();
    if (rom.length && dur.length) {
      setRomValues(rom);
      setDurations(dur);

      const romStd = calculateStdDev(rom);
      const durStd = calculateStdDev(dur);

      setRomStdDev(romStd);
      setRepTimeStdDev(durStd);
    }

    setProgress(75);

    // Stop all audio/video before navigating to symptoms screen
    if (window.stopAudio) {
      window.stopAudio();
    }

    // Stop all video elements
    const allVideos = document.querySelectorAll("video");
    allVideos.forEach((video) => {
      try {
        video.pause();
        video.currentTime = 0;
        console.log("Paused video element before symptoms screen:", video.id || video.src);
      } catch (err) {
        console.warn("Failed to pause video:", err);
      }
    });
  }, []);

  useEffect(() => {
    window.currentCommandsAudio = {
      SELECT_RPE: async (val) => {
        const numVal = parseInt(val);
        try {
          //  small delay to ensure loader is visible
          await new Promise((resolve) => setTimeout(resolve, 500));

          // Get AI response (this will trigger the backend AI processing)
          window.mayraCode.doSay(getRpeResponseText(numVal), () => {
            if (numVal >= 0 && numVal < 11) {
              setSelectedRPE(numVal);
              setTimeout(() => handleContinue(numVal), 500);
            }
          });
        } catch (error) {
          console.error("Error processing RPE response:", error);
        }
      },
      ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent) => {
        if (intent === "continue_command") {
          if (selectedRPE) {
            handleContinue();
          }
        }
      },
      MOVE_ON: (value, speech, intent) => {
        if (selectedRPE) {
          handleContinue();
        }
      },
    };

    window.initFromUserGesture();
    if (window.mayraCode && typeof window.mayraCode.setIsVisible === "function") {
      window.currentFlow = "flow_rpe";
      VoiceService._currentFlow = "flow_rpe";
      window.mayraForwardCode = {
        midjourneyData: howChallengingPayload,
      };
      window.mayraCode.setIsVisible(true);
      setTimeout(() => {
        window.mayraCode.startFlow("flow_rpe", "rpe");
      }, 500);
    }
  }, []);

  const handleContinue = (passResp) => {
    if (!selectedRPE && !passResp) return;
    const selectedRPEM = selectedRPE ?? passResp;

    const { rom, dur } = parseDataAfterInfo();
    window.screenTracker.exitScreen("test1_rpe", {
      exitReason: "rpe_submitted",
      completed: true,
    });
    const screenFlow = window.screenTracker.getScreenFlow();

    const updatedData = {
      ...assessmentData,
      rpe: selectedRPEM,
      rom: rom.length ? rom : romValues, // fallback to state
      duration: dur.length ? dur : durations, // fallback to state
      submitted_rpe_1: true,
      screenFlow: screenFlow,
      rom_test1_completed: true,
      session_last_update: new Date().toISOString(),
    };

    updateAssessmentData(updatedData);
    localStorage.setItem("assessmentData", JSON.stringify(updatedData));

    AnalyticsService.trackStep(updatedData);

    history.replace("/feel-affect");
  };

  return (
    <div className={styles.ScreenWrapperRpe}>
      <div className={styles.ScreenModalRpe}>
        <Header />
        <div className={styles.ScreenContainer}>
          <h3 className={styles.howChaHeading}>How challenging did that movement feel?</h3>

          <div id="rpe-widget" className={styles.RPEGrid}>
            <button type="button" onClick={() => setSelectedRPE(1)} className={`${styles.RPECircle} ${selectedRPE === 1 ? styles.Selected : ""}`}>
              Easy
            </button>
            <button type="button" onClick={() => setSelectedRPE(3)} className={`${styles.RPECircle} ${selectedRPE === 3 ? styles.Selected : ""}`}>
              Kinda Easy
            </button>
            <button type="button" onClick={() => setSelectedRPE(5)} className={`${styles.RPECircle} ${selectedRPE === 5 ? styles.Selected : ""}`}>
              Just Right
            </button>
            <button type="button" onClick={() => setSelectedRPE(7)} className={`${styles.RPECircle} ${selectedRPE === 7 ? styles.Selected : ""}`}>
              Kinda Hard
            </button>
            <button type="button" onClick={() => setSelectedRPE(9)} className={`${styles.RPECircle} ${selectedRPE === 9 ? styles.Selected : ""}`}>
              Hard
            </button>
          </div>

          <div className={styles.RPELabels}>
            <span className={styles.NoEffort}>No Effort</span>
            <span className={styles.MaxEffort}>Max Effort</span>
          </div>

          <button id="rpe-continue" onClick={handleContinue} className={`${styles.ContinueButton} ${selectedRPE === null ? styles.ButtonDisabled : ""}`} disabled={selectedRPE === null}>
            Continue
          </button>
        </div>
      </div>
    </div>
  );
};

// SYMPTOM_OPTIONS helper
const SYMPTOM_OPTIONS = [
  { id: "symptom-improved", value: "IMPROVED", label: "Felt Better" },
  {
    id: "symptom-tolerable",
    value: "TOLERABLE",
    label: "Felt Same",
  },
  { id: "symptom-worsened", value: "WORSENED", label: "Felt Worse" },
];

// feel affect screen

export const FeelAffectScreen = () => {
  usePreventNavigation("/");
  useScrollToTop();
  const { setProgress } = useProgress();
  // Modified on Aug 7th - for user tracking
  const { updateAssessmentData, assessmentData } = useAssessment();
  const [symptomResponse, setSymptomResponse] = useState(null);
  console.log("Symptom Response is : ", symptomResponse);

  //  NEW STATE: AI Processing Loader
  const [isAIProcessing, setIsAIProcessing] = useState(false);
  const [aiProcessingMessage, setAiProcessingMessage] = useState("");
  const [symptom1Speech, setSymptom1Speech] = useState("");
  const aiProcessingTimeoutRef = useRef(null);
  const testSysmptom1Payload = generatePayloadForScreen("test1_symptoms", assessmentData);
  const [isVoiceReady, setIsVoiceReady] = useState(false);

  const history = useHistory();

  console.log("assesment data is : ", assessmentData);
  const startAIProcessing = (message) => {
    setIsAIProcessing(true);
    setAiProcessingMessage(message);

    if (aiProcessingTimeoutRef.current) {
      clearTimeout(aiProcessingTimeoutRef.current);
      aiProcessingTimeoutRef.current = null;
    }

    const checkTimeout = () => {
      const isAgentSpeaking = window.mayraCode?.getState?.()?.isAgentSpeaking;

      // Agent is speaking → check again later
      if (isAgentSpeaking) {
        aiProcessingTimeoutRef.current = setTimeout(checkTimeout, 10_000);
        return;
      }

      // Agent not speaking → unlock UI
      console.error("AI processing timed out — forcing UI recovery");
      setIsAIProcessing(false);
      aiProcessingTimeoutRef.current = null;
    };

    // First check after 60 seconds
    aiProcessingTimeoutRef.current = setTimeout(checkTimeout, 60_000);
  };

  const stopAIProcessing = () => {
    setIsAIProcessing(false);

    if (aiProcessingTimeoutRef.current) {
      clearTimeout(aiProcessingTimeoutRef.current);
      aiProcessingTimeoutRef.current = null;
    }
  };
  useEffect(() => {
    let prevIsListening = VoiceService._isListening;
    const checkInterval = setInterval(() => {
      const currentIsListening = VoiceService._isListening;
      if (!prevIsListening && currentIsListening) {
        VoiceService.sendMidJourneyData(testSysmptom1Payload);
      }

      if (prevIsListening && !currentIsListening) {
        console.log("[Myra] Turned OFF");
        setIsVoiceReady(false);
      }
      prevIsListening = currentIsListening;
    }, 500);

    return () => clearInterval(checkInterval);
  }, []);
  useEffect(() => {
    return () => {
      if (aiProcessingTimeoutRef.current) {
        clearTimeout(aiProcessingTimeoutRef.current);
      }
    };
  }, []);

  useEffect(() => {
    setProgress(80);
    window.screenTracker.enterScreen("test1_symptoms");
  }, []);

  useEffect(() => {
    window.currentCommandsAudio = {
      SELECT_SYMPTOM: async (val, customSpeech) => {
        //  SHOW AI PROCESSING LOADER
        // setIsAIProcessing(true);
        // setAiProcessingMessage("Thanks for your effort. I'm working with AI; insights shortly");
        startAIProcessing("Thanks for your effort. I'm working with AI; insights shortly");
        if (customSpeech) {
          setSymptom1Speech(customSpeech);
        }

        console.log("Symptom NLU speech:", customSpeech);
        console.log("Symptom NLU received:", val);
        if (!customSpeech) {
          stopAIProcessing();
          return;
        }

        const fallbackSpeech = val === "WORSENED" ? "Great work so far! Just one more step to go!" : "Great work so far! Just a few more steps to go!";
        const speechToSay = customSpeech ? `${customSpeech} ${fallbackSpeech}` : fallbackSpeech;

        try {
          const match = SYMPTOM_OPTIONS.find((itm) => itm.value.toUpperCase() === String(val).toUpperCase());

          // Get AI response (this will trigger the backend AI processing)
          window.mayraCode.doSay(speechToSay, () => {
            stopAIProcessing();
            setTimeout(() => {
              if (match) {
                setSymptomResponse(match);
                // Call handleContinue WITH the match parameter
                // This tells handleContinue it's a backend response
                handleContinue(match);
              } else {
                console.warn("No match for symptom value:", val);
              }
            }, 500);
          });
        } catch (error) {
          //  HIDE LOADER on error too
          stopAIProcessing();
          console.error("Error processing symptom response:", error);
        }
      },
    };

    window.initFromUserGesture();
    console.log("🔍 [FRONTEND DEBUG] Data being sent:", {
      romStdDev: assessmentData.romStdDev,
      repTimeStdDev: assessmentData.repTimeStdDev,
      rpe: assessmentData.rpe,
      painLocations: assessmentData.selectedZones,
      symptomDuration: assessmentData.symptomDuration,
      preTestNPRS: assessmentData.painLevel,
    });
    if (window.mayraCode && typeof window.mayraCode.setIsVisible === "function") {
      window.mayraForwardCode = {
        romStdDev: assessmentData.romStdDev ?? null,
        repTimeStdDev: assessmentData.repTimeStdDev ?? null,
        rpe: assessmentData.rpe ?? null,
        painLocations: assessmentData.selectedZones || [],
        symptomDuration: assessmentData.symptomDuration || "",
        preTestNPRS: assessmentData.painLevel ?? null,
        midjourneyData: testSysmptom1Payload,
        symptomType: "initial",
      };
      window.mayraCode.setIsVisible(true);
      setTimeout(() => {
        window.mayraCode.startFlow("flow_symptom", "symptom1");
      }, 500);
    }
  }, []);
  useEffect(() => {
    const initializeVoice = () => {
      if (window.mayraCode && typeof window.mayraCode.setIsVisible === "function") {
        if (VoiceService._ws?.readyState === WebSocket.OPEN) {
          VoiceService.sendMidJourneyData(testSysmptom1Payload);
          setIsVoiceReady(true);
        }
      }
    };
    initializeVoice();
    const checkConnectionInterval = setInterval(() => {
      if (VoiceService._ws?.readyState === WebSocket.OPEN && !isVoiceReady) {
        initializeVoice();
      }
    }, 1000);
    const originalOnConnected = VoiceService._callbacks?.onConnected;
    VoiceService._callbacks.onConnected = () => {
      initializeVoice();
      if (originalOnConnected) originalOnConnected();
    };
    return () => {
      clearInterval(checkConnectionInterval);
      if (originalOnConnected) {
        VoiceService._callbacks.onConnected = originalOnConnected;
      }
    };
  }, [testSysmptom1Payload, isVoiceReady]);

  // Special case: override subtype if response worsened
  // if (symptomResponseM.value === "WORSENED") {
  //   updatedData.finalPainSubtype = "NEUTRAL_SENSITIVE";
  //   updateAssessmentData(updatedData);
  //   localStorage.setItem("assessmentData", JSON.stringify(updatedData));
  //   AnalyticsService.trackStep(updatedData);
  //   history.replace("/plan-recommendation");
  //   return;
  // }

  const proceedWithNavigation = (symptomResponseM) => {
    window.screenTracker.exitScreen("test1_symptoms", {
      exitReason: "symptom_response_submitted",
      completed: true,
    });
    const screenFlow = window.screenTracker.getScreenFlow();

    const updatedData = {
      ...assessmentData,
      symptomResponse: symptomResponseM,
      symptom1Speech: symptom1Speech,
      rom_test1_completed: true,
      submitted_symptoms_1: true,
      symptomResponse1: symptomResponseM.value,
      screenFlow: screenFlow,
      session_last_update: new Date().toISOString(),
    };
    const subtype = assessmentData.probableSubtype;
    let firstTest = assessmentData.testName;
    const SECOND_TEST_REQUIRED_SUBTYPES = ["FLEXION_INTOLERANT", "EXTENSION_INTOLERANT", "LIMITED_LUMBAR_MOBILITY", "ROTATIONAL_INTOLERANT"];
    let needsSecondTest = SECOND_TEST_REQUIRED_SUBTYPES.includes(subtype);
    // path 8
    if (subtype === "LIMITED_LUMBAR_MOBILITY" && symptomResponseM.value === "WORSENED") {
      updatedData.finalPainSubtype = "NEUTRAL_SENSITIVE";
      updatedData.probableSubtype = "NEUTRAL_SENSITIVE";
      needsSecondTest = false;
    }
    // path 9
    if (subtype === "FLEXION_INTOLERANT" && symptomResponseM.value === "WORSENED") {
      updatedData.finalPainSubtype = "NEUTRAL_SENSITIVE";
      updatedData.probableSubtype = "NEUTRAL_SENSITIVE";
      needsSecondTest = false;
    }
    // path 7
    if (subtype === "EXTENSION_INTOLERANT" && symptomResponseM.value === "WORSENED") {
      updatedData.finalPainSubtype = "NEUTRAL_SENSITIVE";
      updatedData.probableSubtype = "NEUTRAL_SENSITIVE";
      needsSecondTest = false;
    }
    // path 16
    if (firstTest === "Standing Lumbar Extension" && subtype === "ROTATIONAL_INTOLERANT" && symptomResponseM.value === "IMPROVED") {
      updatedData.probableSubtype = "FLEXION_INTOLERANT";
      updatedData.finalPainSubtype = "FLEXION_INTOLERANT";
      needsSecondTest = false;
    }

    updateAssessmentData(updatedData);
    localStorage.setItem("assessmentData", JSON.stringify(updatedData));
    AnalyticsService.trackStep(updatedData);

    if (needsSecondTest) {
      history.replace("/test-intro-2");
    } else {
      history.replace("/plan-recommendation");
    }
  };

  const handleContinue = (passResp) => {
    if (!symptomResponse && !passResp) return;

    const symptomResponseM = symptomResponse ? symptomResponse : passResp;

    // SIMPLE: If no passResp = button click, send to backend
    if (!passResp) {
      console.log("Button click - sending to backend:", symptomResponseM.value);

      // Show loader immediately when button is clicked
      startAIProcessing("Thanks for your effort. I'm working with AI; insights shortly");

      const symptomData = {
        type: "symptom_selection",
        data: { action: "SELECT_SYMPTOM", value: symptomResponseM.value },
      };

      if (window.mayraCode && VoiceService._ws && VoiceService._ws.readyState === WebSocket.OPEN) {
        VoiceService._ws.send(JSON.stringify(symptomData));
      } else {
        console.error("WebSocket not connected");
        stopAIProcessing();
        proceedWithNavigation(symptomResponseM);
      }
      return; // Stop here
    }

    // If passResp exists = backend response, navigate
    proceedWithNavigation(symptomResponseM);
  };

  const handleKeyDown = (e, option) => {
    if (e.key === "Enter") {
      setSymptomResponse(option);
    }
  };

  return (
    <div className={styles.ScreenWrapper}>
      <AIProcessingLoader message={aiProcessingMessage} isVisible={isAIProcessing} />
      <div className={styles.ScreenModal}>
        <Header />
        <div>
          <div id="screen-rom-symptom-response" className={styles.FeeLAffectScreenContainer}>
            <h3 className={styles.FeeLAffectHeading}>How did that movement affect your pain?</h3>

            <div id="symptom-response-options" className={styles.FeeLAffectOptionList}>
              {SYMPTOM_OPTIONS.map((option) => (
                <div className={styles.FeeLAffectOptionWrapper} key={option.id}>
                  <input type="radio" autoComplete="off" name="symptom-response" id={option.id} value={option.value} checked={symptomResponse?.value === option.value} onChange={() => setSymptomResponse(option)} className={styles.FeeLAffectHiddenRadio} />
                  <label htmlFor={option.id} tabIndex={0} onKeyDown={(e) => handleKeyDown(e, option)} className={`${styles.FeeLAffectOptionLabel} ${symptomResponse?.value === option.value ? styles.FeeLAffectOptionSelected : styles.FeeLAffectOptionUnselected}`}>
                    <h4 className={styles.FeeLAffectOptionText}>{option.label}</h4>
                  </label>
                </div>
              ))}
            </div>
            <CommonButton
              title={"Continue to Next Step"}
              disabled={!symptomResponse}
              onClick={() => handleContinue()} //  Call without parameter for button click
            />
          </div>
        </div>
      </div>
    </div>
  );
};

// helper function which make sure the video which is currently playing is removed from DOM
const stopAllVideos = () => {
  const ids = ["secondTestVideo", "secondTestVideo2", "rom-test-video-two"];

  ids.forEach((id) => {
    const el = document.getElementById(id);
    if (!el) return;

    try {
      el.pause();
      el.currentTime = 0;
      el.muted = true;
      el.src = "";
      el.load();
      el.remove();
    } catch (err) {
      console.warn(`Failed removing ${id}:`, err);
    }
  });
};

// test intro 2 screeen
export const TestIntroTwo = () => {
  usePreventNavigation("/");
  useScrollToTop();
  const { setProgress } = useProgress();
  // Modified on Aug 7th - for user tracking
  const { assessmentData, updateAssessmentData } = useAssessment();
  const [isBtnClicked, setIsBtnClicked] = useState(false);
  const probableSubtype = assessmentData?.probableSubtype || "NEUTRAL_SENSITIVE";
  const floorCapability = assessmentData?.floorCapability || "floor";
  let test = negativeTestMap[probableSubtype] || null;
  const [isVoiceReady, setIsVoiceReady] = useState(false);
  console.log("assesment data is : ", assessmentData);
  console.log("test is : ", test);
  console.log("subtype  is : ", probableSubtype);
  console.log("Substituted Prone Press Up with:", test.name);
  if (test?.name === "Prone Press Up" && floorCapability === "seated_standing") {
    test = negativeTestMap.SUBSTITUTE_TEST_2;
  }
  if (test?.name === "Prone Press Up") {
    test = { ...negativeTestMap.SUBSTITUTE_TEST_2 };
    console.log("Substituted Prone Press Up with:", test.name);
  }
  let currentTest = test.name;
  let movementTestPayload = generatePayloadForScreen("movement_test_2", assessmentData);
  window.movementTestPayload = movementTestPayload;
  const videoRef = useRef(null);
  let testIntro2Payload = generatePayloadForScreen("test2_demo", assessmentData, currentTest);

  var clickedOnTime = false;
  useEffect(() => {
    let prevIsListening = VoiceService._isListening;
    const checkInterval = setInterval(() => {
      const currentIsListening = VoiceService._isListening;
      if (!prevIsListening && currentIsListening) {
        VoiceService.sendMidJourneyData(testIntro2Payload);
      }

      if (prevIsListening && !currentIsListening) {
        console.log("[Myra] Turned OFF");
        setIsVoiceReady(false);
      }
      prevIsListening = currentIsListening;
    }, 500);

    return () => clearInterval(checkInterval);
  }, []);
  useEffect(() => {
    window.videoController = {
      pause: () => {
        if (videoRef.current) {
          videoRef.current.pause();
          console.log("Video paused via global controller");
        }
      },
      play: () => {
        if (videoRef.current) {
          videoRef.current.play().catch((err) => console.log("Video play failed:", err));
        }
      },
      expand: () => {
        if (videoRef.current) {
          document.body.classList.add("videoplay-expanded");
          // Check for both possible video element IDs
          const videoElement = document.getElementById("secondTestVideo") || document.getElementById("secondTestVideo2") || document.getElementById("rom-test-video-two");
          if (videoElement) {
            videoElement.onclick = function () {
              document.body.classList.remove("videoplay-expanded");
            };
          }
        }
      },
      replay: () => {
        if (videoRef.current) {
          videoRef.current.currentTime = 0;
          videoRef.current.play().catch((err) => console.log("Video replay failed:", err));
        }
      },
      isPaused: () => videoRef.current?.paused ?? true,
    };

    // Cleanup on unmount
    return () => {
      window.videoController = null;
    };
  }, []);
  useEffect(() => {
    const initializeVoice = () => {
      if (window.mayraCode && typeof window.mayraCode.setIsVisible === "function") {
        if (VoiceService._ws?.readyState === WebSocket.OPEN) {
          VoiceService.sendMidJourneyData(testIntro2Payload);
          setIsVoiceReady(true);
        }
      }
    };
    initializeVoice();
    const checkConnectionInterval = setInterval(() => {
      if (VoiceService._ws?.readyState === WebSocket.OPEN && !isVoiceReady) {
        initializeVoice();
      }
    }, 1000);
    const originalOnConnected = VoiceService._callbacks?.onConnected;
    VoiceService._callbacks.onConnected = () => {
      initializeVoice();
      if (originalOnConnected) originalOnConnected();
    };
    return () => {
      clearInterval(checkConnectionInterval);
      if (originalOnConnected) {
        VoiceService._callbacks.onConnected = originalOnConnected;
      }
    };
  }, [testIntro2Payload, isVoiceReady]);

  useEffect(() => {
    window.screenTracker.enterScreen("test2_demo");
    setProgress(85);
    window.initFromUserGesture();

    if (document.getElementById("testtwovideo") && document.getElementById("secondTestVideo")) {
      let videoSecondID = "secondTestVideo";
      if (test?.name === "Seated Trunk Rotation" && window.hasSecondVideoRotation) {
        videoSecondID = "secondTestVideo2";
        document.getElementById("secondTestVideo").parentNode.removeChild(document.getElementById("secondTestVideo"));
      }
      // Remove default video
      document.getElementById("testtwovideo").innerHTML = "";

      // Append unlocked video
      document.getElementById("testtwovideo").appendChild(document.getElementById(videoSecondID));
      videoRef.current = document.getElementById(videoSecondID);
      videoRef.current.style.display = "block";
      videoRef.current.style.position = "";
      videoRef.current.style.left = "";
      videoRef.current.style.bottom = "";
      videoRef.current.style.width = "";
      videoRef.current.style.height = "";

      videoRef.current.className = styles.Video;

      console.log("All set for video");
    }
    if (window.mayraCode) {
      window.mayraForwardCode = {
        midjourneyData: testIntro2Payload,
      };
      window.mayraCode.startFlow("flow_demo_video", "second_test", () => {
        doReplyVideo();
      });

      // Enable skip or reply video
      window.currentCommandsAudio = {
        SKIP_VIDEO: () => {
          doPauseVideo();
          if (window.videoController) {
            window.videoController.pause();
          }
          window.mayraCode.doSay("Got it! Skipping the video.", () => {
            handleContinue();
            window.mayraCode.disableCallback();
            //window.mayraCode.setIsVisible(false);
          });
        },
        ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent) => {
          if (intent === "continue_command") {
            handleContinue();
          }
        },
        MOVE_ON: (value, speech, intent) => {
          handleContinue();
        },
        REPLAY_VIDEO: () => {
          if (window.videoController) {
            window.videoController.pause();
          }
          doPauseVideo();
          window.mayraCode.doSay("Sure! I'll replay the video for you.", () => {
            doReplyVideo();
            if (window.videoController) {
              setTimeout(() => {
                window.videoController.replay();
              }, 400);
            }
          });
        },
        PAUSE_VIDEO: () => {
          if (window.videoController) {
            if (window.videoController.isPaused()) {
              // Already paused
              window.mayraCode.doSay("The video is already paused.");
            } else {
              // Not paused → pause it
              window.videoController.pause();
              window.mayraCode.doSay("Sure! I’ll pause the video for you. When you’re ready to continue, just say Myra, resume the video.", () => {
                doPauseVideo();
              });
            }
          }
        },

        RESUME_VIDEO: () => {
          if (window.videoController && window.videoController.isPaused()) {
            window.mayraCode.doSay("Sure! I'll resume the video for you.", () => {
              setTimeout(() => {
                window.videoController.play();
              }, 400);
            });
          } else {
          }
        },
        EXPAND_VIDEO: () => {
          doPauseVideo();
          if (window.videoController) {
            window.videoController.pause();
            window.mayraCode.doSay("Sure! I'll expand the video for you.", () => {
              window.videoController.expand();
              setTimeout(() => {
                window.videoController.play();
              }, 400);
            });
          }
        },
        INVALID_COMMAND: () => {
          if (window.videoController) {
            window.videoController.pause();
            window.mayraCode.doSay("I didn’t catch that one. Here's what I can help with: Skip the video, Replay the video, pauze the video, and Expand the video", () => {
              setTimeout(() => {
                window.videoController.play();
              }, 400);
            });
          }
        },
        VALID_COMMAND: () => {
          if (window.videoController) {
            window.videoController.pause();
            window.mayraCode.doSay("On this screen I can help you with the following : Skip the video, Replay the video, pauze the video, and Expand the video", () => {
              setTimeout(() => {
                window.videoController.play();
              }, 400);
            });
          }
        },
      };
    }
  }, []);

  // this useeffect will check if the video is manually played then stop agent speech
  useEffect(() => {
    const videoElement = videoRef.current;
    if (!videoElement) return;

    // Simple event listener for video play
    const handleVideoPlay = () => {
      console.log("[VIDEO] Manual play detected - stopping agent speech");

      // Stop agent speech immediately
      VoiceService.stopAgentSpeech();
    };

    // Add event listener
    videoElement.addEventListener("play", handleVideoPlay);

    // Cleanup
    return () => {
      if (videoElement) {
        videoElement.removeEventListener("play", handleVideoPlay);
      }
    };
  }, []);

  const doPauseVideo = () => {
    videoRef.current.pause();
  };

  const doReplyVideo = () => {
    videoRef.current.currentTime = 0;
    videoRef.current.play().catch((err) => {
      console.log("Replay autoplay prevented:", err);
    });
  };

  const handleContinue = async () => {
    window.screenTracker.exitScreen("test2_demo", {
      exitReason: "started_test",
      completed: true,
      videoWatched: true,
      videoSkipped: false,
    });
    const screenFlow = window.screenTracker.getScreenFlow();
    doPauseVideo();
    stopAllVideos();
    window.movementTestPayload = movementTestPayload;
    // Calculate video watching metrics before removing
    let videoWatchedFully = false;
    let videoDurationWatched = 0;
    if (videoRef.current) {
      videoDurationWatched = Math.round(videoRef.current.currentTime);

      // Check if video was watched to at least 90% completion
      if (videoRef.current.duration > 0) {
        const completionPercentage = (videoRef.current.currentTime / videoRef.current.duration) * 100;
        videoWatchedFully = completionPercentage >= 90;
      }
    }
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
      videoRef.current.muted = true;
      videoRef.current.src = "";
      videoRef.current.load();
      videoRef.current.remove();
    }

    const testTwoVideoContainer = document.getElementById("testtwovideo");
    if (testTwoVideoContainer) testTwoVideoContainer.innerHTML = "";

    if (clickedOnTime) {
      return;
    }
    clickedOnTime = true;

    setIsBtnClicked(true);
    const updatedData = {
      ...assessmentData,
      testName2: test.name,
      test2VideoWatched: videoWatchedFully,
      test2VideoDuration: videoDurationWatched,
      rom_test2_started: true,
      screenFlow: screenFlow,
      session_last_update: new Date().toISOString(),
    };

    updateAssessmentData(updatedData);
    localStorage.setItem("assessmentData", JSON.stringify(updatedData));
    localStorage.setItem("runStep", "2");
    localStorage.setItem("loadSelf", test.name);

    // Modified on Aug 7th - for user tracking
    AnalyticsService.trackStep(updatedData);

    document.body.classList.remove("videoplay-expanded");

    if (window.mayraCode && window.mayraCode.setIsVisible) {
      //window.mayraCode.setIsVisible(false);
    }

    if (window.mayraCode) {
      window.mayraCode.disableCallback();
    }
    window.currentCommandsAudio = {};

    /*
    setTimeout(() => {
      if (window.mayraCode && window.mayraCode.forceStop) {
        window.mayraCode.forceStop();
      }
    }, 2000); */
    if (movementTestPayload) {
      VoiceService.sendMidJourneyData(movementTestPayload);
    }

    console.log("Level 2 - 1");
    document.getElementById("OnDemandPlayingRoot").style.display = "block";
    document.querySelector("html").classList = [];
    document.getElementById("assesmentDiv").style.display = "none";

    if (document.querySelector("#assesmentDiv video")) {
      document.querySelector("#assesmentDiv video").play();
      setTimeout(() => {
        document.querySelector("#assesmentDiv video").pause();
      }, 50);
    }

    console.log("Level 2 - 2");
    setIsBtnClicked(false);

    window.blockNextSelfCall = true;
    setTimeout(() => {
      window.blockNextSelfCall = false;
    }, 5000);
    if (window.nextActivityStart) {
      window.nextActivityStart();
    }
  };

  useEffect(() => {
    const videoElement = videoRef.current;
    if (!videoElement) return;

    const handleVideoEnd = () => {
      try {
        const videoWatchedFully = true;
        const videoDurationWatched = Math.round(videoElement.duration);

        // Update assessment data with video completion
        assessmentData.test2VideoWatched = videoWatchedFully;
        assessmentData.test2VideoDuration = videoDurationWatched;
        assessmentData.rom_test2_started = true;
        window.mayraCode.doSay("Now, that you’ve seen how it works, let’s move to the next step.", () => {
          setTimeout(() => {
            handleContinue();
          }, 500);
        });
      } catch (err) {
        console.error("Error sending speech command:", err);
      }
      // try {
      //   if (window.mayraCode && window.mayraCode.doSay && window.mayraCode.isEnabled) {
      //     window.mayraCode.doSay("Now that you’ve seen how it works, let’s move to the next step.");
      //     console.log("Sent speech command to backend");
      //   } else {
      //     console.warn("WebSocket not connected - cannot send speech command");
      //   }
      // } catch (error) {
      //   console.error("Error sending speech command:", error);
      // }
    };
    // Add event listener for video end
    videoElement.addEventListener("ended", handleVideoEnd);

    // Cleanup function to remove event listener
    return () => {
      if (videoElement) {
        videoElement.removeEventListener("ended", handleVideoEnd);
      }
    };
  }, []);

  if (!test) {
    return (
      <div style={{ textAlign: "center", padding: 6 }}>
        <p className="text-gray-500">Loading test instructions...</p>
      </div>
    );
  }

  return (
    <div className={styles.ScreenWrapper}>
      <div className={styles.ScreenModal}>
        <Header />
        <div>
          <div id="screen-rom-intro" className={styles.ScreenContainer}>
            <Heading styles={{ textAlign: "center" }} heading="Great. Now for the Second Movement" />
            <SubHeading styles={{ textAlign: "center" }} subheading="This helps us confirm your movement pattern." />

            <div className={styles.VideoContainer} id="testtwovideo">
              <video id="rom-test-video-two" className={styles.Video} controls playsInline ref={videoRef}>
                <source src={test.video} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>

            {test.name && (
              <div id="rom-test-instruction" className={styles.InstructionBox}>
                <h4 className={styles.InstructionTitle}>{test.name}</h4>
                <p className={styles.InstructionText}>
                  Please perform 4 repetitions of {test.name}. <br />{" "}
                  <span
                    style={{
                      textDecoration: "underline",
                      fontWeight: "bold",
                    }}
                  >
                    Important{" "}
                  </span>{" "}
                  : Stop & Press <strong>Skip Exercise</strong> if you feel a significant increase in pain.
                </p>
              </div>
            )}

            <CommonButton className="rom-test-start-button" title={isBtnClicked ? "Loading Movement Test…" : "Start Movement Test"} onClick={handleContinue} />
          </div>
        </div>
      </div>
    </div>
  );
};

// feedback 2 screen
export const Feedback2 = () => {
  usePreventNavigation("/");
  useScrollToTop();
  const { setProgress } = useProgress();
  // Modified on Aug 7th - for user tracking
  const { assessmentData, updateAssessmentData } = useAssessment();
  const [response, setResponse] = useState("");
  console.log("responsy is : ", response); // -> WORSE , BETTER
  const test_symptom_2 = generatePayloadForScreen("symptom2", assessmentData);

  const [romValues, setRomValues] = useState([]);
  const [durations, setDurations] = useState([]);
  const [isVoiceReady, setIsVoiceReady] = useState(false);
  const history = useHistory();
  const data = localStorage.getItem("dataAfterInfo");
  console.log("data from feedback 2 : ", data);
  useEffect(() => {
    let prevIsListening = VoiceService._isListening;
    const checkInterval = setInterval(() => {
      const currentIsListening = VoiceService._isListening;
      if (!prevIsListening && currentIsListening) {
        VoiceService.sendMidJourneyData(test_symptom_2);
      }

      if (prevIsListening && !currentIsListening) {
        console.log("[Myra] Turned OFF");
        setIsVoiceReady(false);
      }
      prevIsListening = currentIsListening;
    }, 500);

    return () => clearInterval(checkInterval);
  }, []);

  document.body.style = "";

  useEffect(() => {
    const { rom, dur } = parseDataAfterInfo();
    setRomValues(rom);
    setDurations(dur);
    setProgress(95);
    window.screenTracker.enterScreen("symptom2");
  }, []);

  useEffect(() => {
    // VoiceService._ws = null;
    window.currentCommandsAudio = {
      SELECT_SYMPTOM: (val) => {
        // Normalize "WORSENED" → "WORSE"
        if (val === "WORSENED") {
          val = "WORSE";
        }
        if (val === "TOLERABLE" || val === "IMPROVED") {
          val = "BETTER";
        }
        console.log("Symptom NLU received:", val);
        setResponse(val);
        const symptomMsg = val.toLowerCase() === "worse" || val.toUpperCase() === "WORSENED" ? "Thanks for sharing—that’s what we’d expect from this test. It helps us better understand what’s going on and how to tailor your recovery plan. Let’s move on to the next step." : "Thanks for sharing that with me! That’s very helpful information, and we’ll take it into account as we refine your recovery plan. Let’s move on to the next step.";
        window.mayraCode.doSay(symptomMsg, () => {
          setTimeout(() => {
            console.log("Clicked next", val, response);
            handleContinue(val);
          }, 500);
        });
      },
    };
    window.initFromUserGesture();
    if (window.mayraCode && typeof window.mayraCode.setIsVisible === "function") {
      window.mayraCode.setIsVisible(true);
      window.mayraForwardCode = {
        midjourneyData: test_symptom_2,
      };
      window.mayraCode.startFlow("flow_symptom", "symptom2");
    }
  }, []);
  useEffect(() => {
    const initializeVoice = () => {
      if (window.mayraCode && typeof window.mayraCode.setIsVisible === "function") {
        if (VoiceService._ws?.readyState === WebSocket.OPEN) {
          VoiceService.sendMidJourneyData(test_symptom_2);
          setIsVoiceReady(true);
        }
      }
    };
    initializeVoice();
    const checkConnectionInterval = setInterval(() => {
      if (VoiceService._ws?.readyState === WebSocket.OPEN && !isVoiceReady) {
        initializeVoice();
      }
    }, 1000);
    const originalOnConnected = VoiceService._callbacks?.onConnected;
    VoiceService._callbacks.onConnected = () => {
      initializeVoice();
      if (originalOnConnected) originalOnConnected();
    };
    return () => {
      clearInterval(checkConnectionInterval);
      if (originalOnConnected) {
        VoiceService._callbacks.onConnected = originalOnConnected;
      }
    };
  }, [test_symptom_2, isVoiceReady]);

  const handleContinue = (passResp) => {
    if (!response && !passResp) return;
    const responseM = response || passResp;
    let testName2 = assessmentData?.testName2 === "Seated Trunk Rotation";
    window.screenTracker.exitScreen("symptom2", {
      exitReason: "symptom_response_submitted",
      completed: true,
    });
    const screenFlow = window.screenTracker.getScreenFlow();

    const { rom, dur } = parseDataAfterInfo();

    const updated = {
      ...assessmentData,
      symptomResponseConfirm: responseM === "WORSE" ? "WORSENED" : "TOLERABLE",
      rom2: rom.length ? rom : romValues,
      duration2: dur.length ? dur : durations,
      rom_test2_completed: true,
      screenFlow: screenFlow,
      session_last_update: new Date().toISOString(),
    };

    // Reclassify subtype to NEUTRAL_SENSITIVE if the confirmatory test didn't worsen symptoms
    const subtype = updated.probableSubtype;
    if (["FLEXION_INTOLERANT", "EXTENSION_INTOLERANT", "ROTATIONAL_INTOLERANT"].includes(subtype) && responseM !== "WORSE") {
      updated.finalPainSubtype = "NEUTRAL_SENSITIVE";
      updated.probableSubtype = "NEUTRAL_SENSITIVE";
    } else {
      updated.finalPainSubtype = subtype;
      updated.probableSubtype = subtype;
    }
    if (testName2 && responseM === "BETTER") {
      updated.probableSubtype = "NEUTRAL_SENSITIVE";
    }

    updateAssessmentData(updated);
    localStorage.setItem("assessmentData", JSON.stringify(updated));

    // Modified on Aug 7th - for user tracking
    AnalyticsService.trackStep(updated);

    history.replace("/plan-recommendation");
  };
  return (
    <div className={styles.ScreenWrapper}>
      <div className={styles.ScreenModal}>
        <Header />
        <div>
          <h2 id="symptom-response-title" className={styles.FeedbackkHeading}>
            How did the second movement test feel compared to the first movement test?
          </h2>

          <div id="symptom-response-options" className={styles.FeedbackkOptionList}>
            <label className={`${styles.FeedbackkOptionLabel} ${response === "WORSE" ? styles.FeedbackkSelected : styles.FeedbackkUnselected}`}>
              <input type="radio" autoComplete="off" name="symptom-response-simple" value="WORSE" checked={response === "WORSE"} onChange={() => setResponse("WORSE")} className={styles.FeedbackkHiddenInput} />
              <h4 className={styles.FeedbackkOptionText}>Felt Worse</h4>
            </label>
            <label className={`${styles.FeedbackkOptionLabel} ${response === "BETTER" ? styles.FeedbackkSelected : styles.FeedbackkUnselected}`}>
              <input type="radio" autoComplete="off" name="symptom-response-simple" value="BETTER" checked={response === "BETTER"} onChange={() => setResponse("BETTER")} className={styles.FeedbackkHiddenInput} />
              <h4 className={styles.FeedbackkOptionText}>Felt Better</h4>
            </label>
          </div>

          <CommonButton title={"Continue"} onClick={handleContinue} disabled={!response} />
        </div>
      </div>
    </div>
  );
};

// demographic modal
const SkipDemographicsModal = ({ onClose, onConfirm }) => {
  return (
    <div className={styles.SDMOverlay}>
      {/* Dark background overlay */}
      <div className={styles.SDMBackdrop}></div>

      {/* Modal content */}
      <div className={styles.SDMModal}>
        <h3 className={styles.SDMTitle}>Use a Standard Plan?</h3>
        <p className={styles.SDMText}>We understand if you’d prefer not to share personal details like your age, activity level, height, or weight. Without this information, your starting plan will be more conservative and your Recovery Compass Score may be less accurate.</p>
        <div className={styles.SDMButtonGroup}>
          <button onClick={onClose} className={styles.SDMBackButton}>
            Go Back & Personalize
          </button>
          <button onClick={onConfirm} className={styles.SDMConfirmButton}>
            Continue with Standard Plan
          </button>
        </div>
      </div>
    </div>
  );
};

// info modal
const InfoModal = ({ onClose, onConfirm }) => {
  return (
    <div className={styles.SDMOverlay}>
      {/* Dark background overlay */}
      <div className={styles.SDMBackdrop}></div>

      {/* Modal content */}
      <div className={styles.SDMModal}>
        <h3 className={styles.SDMTitle}>What is StartFreePT?</h3>
        <p className={styles.SDMText}>StartFreePT is a free, guided self-assessment tool that helps you understand your back pain. It uses AI to provide personalized educational guidance based on your input—it’s not medical advice or treatment.</p>
        <div className={styles.SDMButtonGroup}>
          <button onClick={onClose} className={styles.SDMBackButton}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

// demographic form
const DemographicsForm = React.forwardRef(({ onSubmit, onSkip, selectedGoals, setSelectedGoals, disabled, setForm, form }, ref) => {
  const [ageError, setAgeError] = useState("");

  // Helper to update form state
  const updateField = (key, value) => {
    setForm((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  useEffect(() => {
    if (window.destroyFlutterResources) {
      try {
        window.destroyFlutterResources();
        console.log("Flutter resources destroyed after performing 2nd exercise");
      } catch (error) {
        console.warn("something went wrong while destroying flutter resources");
      }
    }
  }, []);

  const fieldChecks = [
    { key: "age", value: form.age, label: "your age" },
    { key: "weight", value: form.weight, label: "your weight" },
    { key: "heightFt", value: form.heightFt, label: "your height in feet" },
    { key: "heightIn", value: form.heightIn, label: "your height in inches" },
    { key: "activity", value: form.activity, label: "your weekly activity level" },
    { key: "floorCapability", value: form.floorCapability, label: "your floor capability" },
    { key: "balance", value: form.balance, label: "your balance" },
    { key: "goal", value: selectedGoals.length > 0, label: "your primary goal" },
    { key: "scheduleDays", value: form.scheduleDays, label: "your available days for exercise" },
    { key: "scheduleTime", value: form.scheduleTime, label: "your preferred session time" },
    { key: "sessionPref", value: form.sessionPref, label: "your session preference" },
  ];

  const getFirstMissingField = () => {
    for (let check of fieldChecks) {
      if (!check.value) return check.label;
    }
    return null;
  };

  const getAllMissingFields = () => {
    const missing = fieldChecks.filter((check) => !check.value).map((check) => check.label);
    return missing.length > 0 ? missing.join(", ") : null;
  };

  if (window.closeStream) {
    window.closeStream();
  }

  const isValid = form.age && form.activity && form.heightFt && form.heightIn && form.weight && form.floorCapability && form.balance && selectedGoals.length > 0 && form.scheduleDays && form.sessionPref && form.scheduleTime;

  useEffect(() => {
    if (form.age === "") {
      setAgeError("");
    } else if (parseInt(form.age) < 18) {
      setAgeError("Participants must be 18 or older.");
    } else {
      setAgeError("");
    }
  }, [form.age]);

  const getFormData = () => ({
    ...form,
    goal: selectedGoals,
  });

  const handleSubmit = () => {
    if (parseInt(form.age) < 18) {
      setAgeError("Participants must be 18 or older.");
      return;
    }
    const missing = getFirstMissingField();
    if (missing) {
      window.mayraCode.doSay(`Please enter ${missing}.`, () => {});
      return;
    }
    if (!isValid) return;

    onSubmit(getFormData());
  };

  React.useImperativeHandle(ref, () => ({
    handleSubmit,
    getAllMissingFields,
  }));

  return (
    <div id="screen-demographics">
      <Heading heading={"Personalize Your Recovery Plan"} styles={{ textAlign: "center" }} />
      <SubHeading subheading={"This helps us accurately calculate your Recovery Compass Score and tailor your plan."} styles={{ textAlign: "center", color: "#6b7280", padding: "10px 0" }} />

      <form onSubmit={(e) => e.preventDefault()}>
        {/* Age & Biometrics */}
        <div>
          <label htmlFor="age" className={styles.dfLabel}>
            Age & Biometrics
          </label>
          <div className={styles.dfTwoColGrid}>
            <input type="number" id="age" placeholder="Age" value={form.age} className={styles.dfTextInput} tabIndex={1} onChange={(e) => updateField("age", e.target.value)} />
            <input type="number" id="weight_lbs" placeholder="Weight (lbs)" className={styles.dfTextInput} value={form.weight} tabIndex={2} onChange={(e) => updateField("weight", e.target.value)} />
          </div>
          {ageError && (
            <p style={{ color: "#ef4444", fontSize: "0.75rem" }} className={styles.DFError}>
              {ageError}
            </p>
          )}
          <div className={styles.dfTwoColGrid} style={{ marginTop: "0.5rem" }}>
            <input type="number" id="height_ft" placeholder="Height (ft)" className={styles.dfTextInput} tabIndex={3} value={form.heightFt} onChange={(e) => updateField("heightFt", e.target.value)} />
            <input type="number" id="height_in" placeholder="Height (in)" className={styles.dfTextInput} tabIndex={4} value={form.heightIn} onChange={(e) => updateField("heightIn", e.target.value)} />
          </div>
        </div>

        {/* Activity Levels */}
        <div style={{ padding: "1rem 0" }}>
          <label className={styles.dfLabel}>In a typical week, how many days do you get at least 20 minutes of exercise?</label>
          <div className={styles.dfOptionsGrid4}>
            {activityLevels.map(({ id, value, label, tabIndex }, index) => (
              <React.Fragment key={id}>
                <input type="radio" autoComplete="off" name="activity" id={id} value={value} checked={form.activity === value} onChange={(e) => updateField("activity", e.target.value)} className={styles.DFHiddenRadio} />
                <label htmlFor={id} tabIndex={tabIndex} onKeyDown={(e) => e.key === "Enter" && updateField("activity", value)} className={`${styles.DFOption} ${form.activity === value ? styles.DFOptionSelected : styles.DFOptionUnselected}`}>
                  <h4 className={styles.DFOptionText}>{label}</h4>
                </label>
              </React.Fragment>
            ))}
          </div>
        </div>

        <div className={`${styles.dfSectionBorder}`}>
          {/* <p className={styles.sectionIntro}></p> */}
          <SubHeading subheading={"Sharing this helps us select exercises that are safe and appropriate for your body."} styles={{ color: "#6b7280", padding: "10px 0" }} />
          {/* Floor Capability */}
          <div style={{ padding: "10px 0" }}>
            <label className={styles.dfLabel}>Are you comfortable doing exercises on the floor, or is that too difficult for you right now?</label>
            <div className={styles.dfTwoColGrid}>
              {floorOptions.map((option, index) => (
                <div key={option.id}>
                  <input type="radio" name="floor-capability" id={option.id} value={option.value} checked={form.floorCapability === option.value} onChange={(e) => updateField("floorCapability", e.target.value)} className={styles.dfHiddenRadio} />
                  <label
                    htmlFor={option.id}
                    className={`${styles.dfOptionLabel}`}
                    tabIndex={option.tabIndex}
                    style={{
                      border: form.floorCapability === option.value ? "3px solid #0d9488" : "2px solid #e5e7eb",
                    }}
                    onKeyDown={(e) => e.key === "Enter" && updateField("floorCapability", option.value)}
                  >
                    <h4 className={styles.DFOptionText}>{option.label}</h4>
                  </label>
                </div>
              ))}
            </div>
          </div>

          {/* Balance */}
          <div>
            <label className={styles.dfLabel}>How would you rate your balance while standing?</label>
            <div className={styles.dfTwoColGrid}>
              {balanceOptions.map((option, index) => (
                <div key={option.id}>
                  <input type="radio" name="balance" id={option.id} value={option.value} checked={form.balance === option.value} onChange={(e) => updateField("balance", e.target.value)} className={styles.dfHiddenRadio} />
                  <label
                    htmlFor={option.id}
                    className={`${styles.dfOptionLabel} ${styles.dfOptionLabel2}`}
                    tabIndex={option.tabIndex}
                    style={{
                      border: form.balance === option.value ? "3px solid #0d9488" : "2px solid #e5e7eb",
                    }}
                    onKeyDown={(e) => e.key === "Enter" && updateField("balance", option.value)}
                  >
                    <h4 className={styles.DFOptionText}>{option.label}</h4>
                  </label>
                </div>
              ))}
            </div>
          </div>
          {/* Optional Health Context */}
          <div style={{ padding: "10px 0" }}>
            <label className={` ${styles.dfLabel}`} style={{ marginBottom: "10px" }}>
              Do you have any pre-existing conditions?
              <span className={styles.optionalBadge}>(optional)</span>
            </label>
            <input type="text" id="pre_existing_conditions" className={styles.userConditionInput} placeholder="e.g., arthritis, prior surgery, osteoporosis, pregnancy, joint replacement" value={form.preExistingConditions} onChange={(e) => updateField("preExistingConditions", e.target.value)} />
          </div>

          <div style={{ padding: "10px 0" }}>
            <label className={`${styles.dfLabel}`} style={{ marginBottom: "10px" }}>
              Is there anything currently going on with your body?
              <span className={styles.optionalBadge}>(optional)</span>
            </label>
            <input type="text" id="current_conditions" className={styles.userConditionInput} placeholder="e.g., pulled muscle, recent flare-up, tweaked my back yesterday" value={form.currentConditions} onChange={(e) => updateField("currentConditions", e.target.value)} />
          </div>
        </div>

        <div className={`${styles.dfSectionBorder}`}>
          {/* Primary Goal */}
          <div>
            <label className={styles.dfLabel} style={{ margin: "10px 0" }}>
              What is your primary goal?
            </label>
            <GoalsMultiSelect selectedGoals={selectedGoals} onChange={setSelectedGoals} tabIndex={13} />
          </div>

          {/* Schedule Days */}
          <div style={{ padding: "1rem 0" }}>
            <label className={styles.dfLabel}>How many days a week does your schedule allow for exercise?</label>
            <div className={styles.dfOptionsGrid4}>
              {scheduleDaysOptions.map((option, index) => (
                <div key={option.id}>
                  <input type="radio" name="schedule-days" id={option.id} value={option.value} checked={form.scheduleDays === option.value} onChange={(e) => updateField("scheduleDays", e.target.value)} className={styles.dfHiddenRadio} />
                  <label
                    htmlFor={option.id}
                    className={`${styles.dfOptionLabel} ${form.scheduleDays === option.value ? styles.DFOptionSelected : ""}`}
                    style={{
                      border: form.scheduleDays === option.value ? "3px solid #0d9488" : "2px solid #e5e7eb",
                    }}
                    tabIndex={option.tabIndex}
                    onKeyDown={(e) => e.key === "Enter" && updateField("scheduleDays", option.value)}
                  >
                    <h4 className={styles.DFOptionText}>{option.label}</h4>
                  </label>
                </div>
              ))}
            </div>
          </div>

          {/* Session Preference */}
          <div>
            <label className={styles.dfLabel}>Would you prefer one session or two sessions per day?</label>
            <div className={styles.dfTwoColGrid}>
              {sessionOptions.map((option, index) => (
                <div key={option.id}>
                  <input
                    type="radio"
                    name="session-pref"
                    id={option.id}
                    value={option.value}
                    checked={form.sessionPref === option.value}
                    onChange={(e) => {
                      updateField("sessionPref", e.target.value);
                    }}
                    className={styles.dfHiddenRadio}
                  />
                  <label
                    htmlFor={option.id}
                    className={`${styles.dfOptionLabel} ${form.sessionPref === option.value ? styles.DFOptionSelected : ""}`}
                    style={{
                      border: form.sessionPref === option.value ? "3px solid #0d9488" : "2px solid #e5e7eb",
                    }}
                    tabIndex={option.tabIndex}
                    onKeyDown={(e) => e.key === "Enter" && updateField("sessionPref", option.value)}
                  >
                    <h4 className={styles.DFOptionText}>{option.label}</h4>
                  </label>
                </div>
              ))}
            </div>
          </div>

          {/* Session Time */}
          <div style={{ padding: "1rem 0" }}>
            <label className={styles.dfLabel}>How much time per session fits into your schedule?</label>
            <div className={styles.dfOptionsGrid3}>
              {scheduleTimeOptions.map((option, index) => (
                <div key={option.id}>
                  <input type="radio" name="schedule-time" id={option.id} value={option.value} checked={form.scheduleTime === option.value} onChange={(e) => updateField("scheduleTime", e.target.value)} className={styles.dfHiddenRadio} />
                  <label
                    htmlFor={option.id}
                    className={`${styles.dfOptionLabel} ${form.scheduleTime === option.value ? styles.DFOptionSelected : ""}`}
                    tabIndex={option.tabIndex}
                    style={{
                      border: form.scheduleTime === option.value ? "3px solid #0d9488" : "2px solid #e5e7eb",
                    }}
                    onKeyDown={(e) => e.key === "Enter" && updateField("scheduleTime", option.value)}
                  >
                    <h4 className={styles.DFOptionText}>{option.label}</h4>
                  </label>
                </div>
              ))}
            </div>
          </div>
        </div>
      </form>

      {/* Buttons */}
      <div>
        <button tabIndex={23} onClick={handleSubmit} className={`${styles.DFPrimaryButton} ${!isValid ? styles.DFDisabled : ""}`} disabled={disabled}>
          See My Recovery Compass Score
        </button>
        <button onClick={onSkip} className={styles.DFSecondaryButton} style={{ display: "none" }}>
          I Don't Want To See My Recovery Compass Score
        </button>
      </div>
    </div>
  );
});

// plan recommnedation screen
export const PlanRecommendation = () => {
  usePreventNavigation("/");
  useScrollToTop();
  const { setProgress } = useProgress();
  // Modified on Aug 7th - for user tracking
  const { assessmentData, updateAssessmentData } = useAssessment();
  console.log("data is : ", assessmentData);
  const [showSkipModal, setShowSkipModal] = useState(false);
  const formRef = useRef();
  const userCondition = JSON.parse(localStorage.getItem("userCondition") || "{}");
  const userConditions = userCondition?.usercondition || {};
  const [demographics, setDemographics] = useState({
    age: "",
    weight: "",
    heightFt: "",
    heightIn: "",
    activity: null,
    floorCapability: null,
    balance: null,
    preExistingConditions: userConditions.pre_existing || "",
    currentConditions: userConditions.current || "",
    scheduleDays: null,
    scheduleTime: null,
    sessionPref: "",
  });
  const [isVoiceReady, setIsVoiceReady] = useState(false);
  const [selectedGoals, setSelectedGoals] = useState([]);
  const checklistItems = [
    { id: "age", label: "Age", completed: !!demographics.age && demographics.age >= 18 },
    { id: "weight", label: "Weight", completed: !!demographics.weight },
    { id: "height", label: "Height", completed: !!demographics.heightFt && !!demographics.heightIn },
    { id: "activity", label: "Activity Level", completed: !!demographics.activity },
    { id: "floor", label: "Floor Capability", completed: !!demographics.floorCapability },
    { id: "balance_check", label: "Balance", completed: !!demographics.balance },
    { id: "goals", label: "Goals", completed: selectedGoals.length > 0 },
    { id: "schedule", label: "Avail. Schedule", completed: !!demographics.scheduleDays },
    { id: "duration", label: "How Long", completed: !!demographics.scheduleTime },
    { id: "session_pref", label: "Session Pref", completed: demographics.sessionPref === "one" || demographics.sessionPref === "multiple" },
  ];
  const isFormComplete = checklistItems.every((item) => item.completed);

  useEffect(() => {
    try {
      const storedData = JSON.parse(localStorage.getItem("assessmentData")) || {};
      if (storedData.symptomResponseConfirm === "WORSENED") {
        updateAssessmentData(storedData);
        console.log("Synced WORSENED symptomResponseConfirm to context");
      }
    } catch (err) {
      console.error("Error syncing WORSENED symptomResponseConfirm from localStorage", err);
    }
  }, []);

  const personalizePayload = generatePayloadForScreen("personalize", assessmentData);
  useEffect(() => {
    window.screenTracker.enterScreen("personalize");
    setProgress(100);
    if (window.closeStream) {
      window.closeStream();
    }
  }, []);
  useEffect(() => {
    let prevIsListening = VoiceService._isListening;
    const checkInterval = setInterval(() => {
      const currentIsListening = VoiceService._isListening;
      if (!prevIsListening && currentIsListening) {
        VoiceService.sendMidJourneyData(personalizePayload);
      }

      if (prevIsListening && !currentIsListening) {
        console.log("[Myra] Turned OFF");
        setIsVoiceReady(false);
      }
      prevIsListening = currentIsListening;
    }, 500);

    return () => clearInterval(checkInterval);
  }, []);
  const history = useHistory();
  const handleSkip = () => {
    setShowSkipModal(true);
  };
  useEffect(() => {
    window.currentCommandsAudio = {
      MOVE_ON: () => {
        // eslint-disable-next-line no-unused-expressions
        formRef.current?.handleSubmit();
      },
      FORM_QUESTION: () => {
        const missing = formRef.current?.getAllMissingFields();
        if (missing) {
          window.mayraCode.doSay(`Please enter ${missing}.`, () => {});
          return;
        }
      },
      ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent) => {
        if (intent === "continue_command") {
          formRef.current.handleSubmit();
        }
      },
      MOVE_ON: (value, speech, intent) => {
        formRef.current.handleSubmit();
      },
    };
    window.initFromUserGesture();
    if (window.mayraCode && typeof window.mayraCode.setIsVisible === "function") {
      window.mayraCode.setIsVisible(true);
      window.mayraForwardCode = {
        midjourneyData: personalizePayload,
      };
      window.mayraCode.startFlow("flow_personalized", "personalized");
    }
  }, []);
  useEffect(() => {
    window.initFromUserGesture();
    const initializeVoice = () => {
      if (window.mayraCode && typeof window.mayraCode.setIsVisible === "function") {
        if (VoiceService._ws?.readyState === WebSocket.OPEN) {
          VoiceService.sendMidJourneyData(personalizePayload);
          setIsVoiceReady(true);
        }
      }
    };
    initializeVoice();
    const checkConnectionInterval = setInterval(() => {
      if (VoiceService._ws?.readyState === WebSocket.OPEN && !isVoiceReady) {
        initializeVoice();
      }
    }, 1000);
    const originalOnConnected = VoiceService._callbacks?.onConnected;
    VoiceService._callbacks.onConnected = () => {
      initializeVoice();
      if (originalOnConnected) originalOnConnected();
    };
    return () => {
      clearInterval(checkConnectionInterval);
      if (originalOnConnected) {
        VoiceService._callbacks.onConnected = originalOnConnected;
      }
    };
  }, [personalizePayload, isVoiceReady]);

  const handleFormSubmit = () => {
    window.screenTracker.exitScreen("personalize", {
      exitReason: "demographics_completed",
      completed: true,
    });
    const screenFlow = window.screenTracker.getScreenFlow();
    const now = new Date();
    const formattedTime = new Date().toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
    const isMultipleSessions = demographics.sessionPref === "multiple";

    let daily_sessions = null;
    if (isMultipleSessions) {
      const hours = now.getHours();
      if (hours < 12) {
        daily_sessions = ["Morning", "Evening"]; // before noon
      } else {
        daily_sessions = ["Evening"]; // after noon
      }
    } else {
      daily_sessions = ["One"];
    }
    console.log("Form Data and goals : ", demographics, selectedGoals);
    const updatedData = {
      ...assessmentData,
      signature: true,
      biometrics: {
        skipped: false,
        age: Number(demographics.age),
        activityLevel: demographics.activity,
        heightFt: Number(demographics.heightFt),
        heightIn: Number(demographics.heightIn),
        weightLbs: Number(demographics.weight),
        floorCapability: demographics.floorCapability,
        balance: demographics.balance,
        preExistingConditions: demographics.preExistingConditions || null,
        currentConditions: demographics.currentConditions || null,
        goal: selectedGoals,
        sessionPref: demographics.sessionPref || "one",
        scheduleTime: demographics.scheduleTime,
        scheduleDays: demographics.scheduleDays,
        daily_sessions,
        ...(isMultipleSessions && { currentTime: formattedTime }),
      },
      scheduleDays: demographics.scheduleDays || null,
      scheduleTime: demographics.scheduleTime || null,
      useStandardPlan: false,
      demographics_provided: true,
      completed_demographics: true,
      screenFlow: screenFlow,
      session_last_update: new Date().toISOString(),
    };

    updateAssessmentData(updatedData);
    localStorage.setItem("assessmentData", JSON.stringify(updatedData));

    // Modified on Aug 7th - for user tracking
    AnalyticsService.trackStep(updatedData);

    history.replace("/recovery-score");
  };
  const confirmSkip = () => {
    const updatedData = {
      ...assessmentData,
      signature: false,
      biometrics: {
        skipped: true,
        age: "",
        activityLevel: "",
        heightFt: "",
        heightIn: "",
        weightLbs: "",
      },
      useStandardPlan: true,
    };

    updateAssessmentData(updatedData);
    localStorage.setItem("assessmentData", JSON.stringify(updatedData));

    // Modified on Aug 7th - for user tracking
    AnalyticsService.trackStep(updatedData);

    history.replace("/recovery-score");
  };

  return (
    <div className={styles.ScreenWrapper}>
      <div className={styles.ScreenModal}>
        <Header />
        <div>
          <DemographicsForm onSubmit={handleFormSubmit} onSkip={handleSkip} ref={formRef} selectedGoals={selectedGoals} setSelectedGoals={setSelectedGoals} disabled={!isFormComplete} form={demographics} setForm={setDemographics} />
          {showSkipModal && <SkipDemographicsModal onClose={() => setShowSkipModal(false)} onConfirm={confirmSkip} />}
          <ProgressChecklist items={checklistItems} />
        </div>
      </div>
    </div>
  );
};

// personalized recovery pplan small sub component of recovery plan
const PersonalizationInfoCard = () => {
  return (
    <div className={styles.infoCard}>
      <h3 className={styles.infoCardTitle}>How We've Personalized Your Plan</h3>
      <div className={styles.infoCardRow}>
        <div className={styles.infoItem}>
          <svg className={styles.infoIcon} fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
          </svg>
          <span className={styles.infoLabel}>Your Score</span>
        </div>
        <div className={styles.infoPlus}>+</div>
        <div className={styles.infoItem}>
          <svg className={styles.infoIcon} fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
          <span className={styles.infoLabel}>Your History</span>
        </div>
        <div className={styles.infoPlus}>+</div>
        <div className={styles.infoItem}>
          <svg className={styles.infoIcon} fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
          </svg>
          <span className={styles.infoLabel}>Your Info</span>
        </div>
      </div>
    </div>
  );
};

// recovery score component
const RecoveryScoreComp = ({ score = 0, subtype = null, complexityLevel = 1, scoreData = {}, onContinue }) => {
  const gaugeRef = useRef(null);

  useEffect(() => {
    const circle = gaugeRef.current;
    const full = 2 * Math.PI * 45;
    const offset = full - (score / 100) * full;
    if (circle) {
      circle.style.strokeDasharray = `${full}`;
      setTimeout(() => {
        circle.style.strokeDashoffset = offset;
      }, 100);
    }
  }, [score]);

  const resolvedSubtype = subtype || cpgToSubtype(scoreData?.cpgValue?.value);
  const diagnosisKey = complexityLevel === 5 ? "HIGH_FUNCTIONING" : resolvedSubtype || "NEUTRAL_SENSITIVE";

  const diagnosis = messaging.diagnosis[diagnosisKey] || {
    headline: "Your Back Diagnosis",
    clinicalTerm: "Unknown",
    implications: "No diagnosis details available.",
  };

  const readinessModifier = scoreData?.readinessModifier ?? 100;
  let readinessTier;
  if (readinessModifier >= 90) readinessTier = messaging.readinessTiers.READY_TO_GO;
  else if (readinessModifier >= 75) readinessTier = messaging.readinessTiers.CAUTIOUS_START;
  else if (readinessModifier >= 50) readinessTier = messaging.readinessTiers.GENTLE_APPROACH;
  else readinessTier = messaging.readinessTiers.STARTING_WITH_CARE;

  // const gaugeColor = score < 40 ? styles.RSCGaugeRed : score < 61 ? styles.RSCGaugeYellow : styles.RSCGaugeGreen;
  const gaugeColor = styles.RSCGaugeGreen;

  const textColor = score < 40 ? styles.RSCGaugeRed : score < 61 ? styles.RSCGaugeYellow : styles.RSCGaugeGreen;

  const factorsHTML = scoreData?.biometrics?.skipped ? ["Your health history (symptom duration).", "Providing details like activity level and BMI can help us personalize your plan even further in the future."] : ["The history of your condition.", "The personal information you provided."];

  return (
    <div id="screen-recovery-score" className={styles.RSCScreen}>
      <div style={{ textAlign: "center" }}>
        <h2
          style={{
            fontSize: "1.5rem",
            fontWeight: "700",
            color: "#1F2937",
          }}
        >
          Recovery Compass
        </h2>
        <p
          style={{
            color: "#64748B",
            marginTop: "0.25rem",
          }}
        >
          The Starting Point of Your Recovery Journey
        </p>
      </div>

      <div className={styles.RSCScoreWrapper}>
        <div>
          <p className={styles.RSCScoreTextLabel}>Your Score</p>
          <div className={styles.RSCGaugeContainer}>
            <svg className={styles.RSCGaugeSVG} viewBox="0 0 100 100">
              <circle strokeWidth="10" className={styles.RSCGaugeBase} r="45" cx="50" cy="50" />
              <circle ref={gaugeRef} strokeWidth="10" r="45" cx="50" cy="50" transform="rotate(-90 50 50)" className={`${styles.RSCGaugeValue} ${gaugeColor}`} />
              <text x="50" y="52" className={`${styles.RSCScoreNumber} `}>
                {score}
              </text>
            </svg>
          </div>
        </div>
      </div>

      <div className={styles.RSCInfoCard}>
        <h3 className={styles.RSCInfoTitle}>{diagnosis.headline}</h3>
        <p className={styles.RSCInfoText}>{diagnosis.relief}</p>
      </div>

      <PersonalizationInfoCard />

      <CommonButton title={"View My Week 1 Recovery Plan"} onClick={onContinue} />
    </div>
  );
};

// utils/fetchWithRetry.js (or inside the component file)
const sleep = (ms) => new Promise((res) => setTimeout(res, ms));

/**
 * fetchWithRetry
 * - url: API endpoint
 * - options: fetch options (headers, body, method)
 * - opts:
 *    - maxAttempts: number
 *    - initialDelay: ms
 *    - factor: exponential factor
 *    - jitter: true/false (adds small random)
 *    - timeout: per-request timeout in ms (optional)
 *    - signal: AbortSignal (optional)
 */
async function fetchWithRetry(url, options = {}, opts = {}) {
  const { maxAttempts = 4, initialDelay = 800, factor = 2, jitter = true, timeout = 20000, signal } = opts;

  let attempt = 0;

  while (attempt < maxAttempts) {
    attempt += 1;

    // per-attempt timeout
    const controller = new AbortController();
    const combinedSignal = signal
      ? new AbortController().signal // placeholder, we'll combine below
      : controller.signal;

    // Combine signals: prefer outer signal (if provided), but ensure we can timeout.
    // If a signal was passed, we listen to it and abort our controller when it fires.
    if (signal) {
      if (signal.aborted) {
        controller.abort();
      } else {
        const onAbort = () => controller.abort();
        signal.addEventListener("abort", onAbort, { once: true });
      }
    }

    let timeoutId;
    try {
      if (timeout) {
        timeoutId = setTimeout(() => controller.abort(), timeout);
      }

      const res = await fetch(url, {
        ...options,
        signal: controller.signal,
      });

      // if server error (5xx) treat as retryable; if 4xx treat as permanent failure
      if (res.ok) {
        clearTimeout(timeoutId);
        return { ok: true, response: await res.json(), attempt };
      } else if (res.status >= 500 && res.status < 600) {
        // retryable server error
        const errText = await res.text().catch(() => "");
        throw new Error(`Server error ${res.status}: ${errText}`);
      } else {
        // client error - do not retry
        const errText = await res.text().catch(() => "");
        return { ok: false, permanentError: true, status: res.status, body: errText };
      }
    } catch (err) {
      clearTimeout(timeoutId);

      // If aborted externally, rethrow so caller can handle immediate abort
      if (signal && signal.aborted) {
        throw new DOMException("Aborted", "AbortError");
      }

      // If this was the last attempt, return failure info
      if (attempt >= maxAttempts) {
        return { ok: false, error: err, attempt };
      }

      // compute backoff delay (exponential + jitter)
      let delay = initialDelay * Math.pow(factor, attempt - 1);
      if (jitter) {
        const jitterVal = Math.random() * (delay * 0.25); // up to 25% jitter
        delay = delay - jitterVal;
      }

      // wait and retry
      await sleep(delay);
      // then continue loop for next attempt
    } finally {
      if (timeoutId) clearTimeout(timeoutId);
    }
  }

  // fallback - should never reach here because loop returns
  return { ok: false, error: new Error("Retries exhausted") };
}

// recovery score screen
export const RecoveryScoreScreen = () => {
  usePreventNavigation("/");
  useScrollToTop();
  const { setProgress } = useProgress();
  // Modified on Aug 7th - for user tracking
  const { updateAssessmentData, assessmentData } = useAssessment();
  const [scoreData, setScoreData] = useState(null);
  const [loadingWait, setLoadingWait] = useState(true);
  const [error, setError] = useState(null);
  const [loadingDots, setLoadingDots] = useState(".");
  const [retryAttempt, setRetryAttempt] = useState(0);
  const history = useHistory();
  console.log("assesment data is : ", assessmentData);
  const [safetyHalt, setSafetyHalt] = useState(false);
  const recoveryScorePayload = generatePayloadForScreen("recovery_score", assessmentData);
  const userName = localStorage.getItem("self_name") || "";
  const userCondition = JSON.parse(localStorage.getItem("userCondition") || "{}");
  const userConditions = userCondition?.usercondition || {};
  const [isVoiceReady, setIsVoiceReady] = useState(false);
  useEffect(() => {
    let prevIsListening = VoiceService._isListening;
    const checkInterval = setInterval(() => {
      const currentIsListening = VoiceService._isListening;
      if (!prevIsListening && currentIsListening) {
        VoiceService.sendMidJourneyData(recoveryScorePayload);
      }

      if (prevIsListening && !currentIsListening) {
        console.log("[Myra] Turned OFF");
        setIsVoiceReady(false);
      }
      prevIsListening = currentIsListening;
    }, 500);

    return () => clearInterval(checkInterval);
  }, []);

  useEffect(() => {
    window.screenTracker.enterScreen("recovery_score");
    window.initFromUserGesture();
    if (window.mayraCode && typeof window.mayraCode.setIsVisible === "function") {
      window.mayraCode.setIsVisible(true);
      // window.mayraCode.startFlow("Compass_Score");
      window.mayraCode.doSay(`${userName ? userName : ""}. | We've got everything we need—thank you for your effort, especially while in pain. Now it's our turn to do the work! I am analyzing your information to calculate your Recovery Compass Score and create your personalized recovery plan. Hang tight—we'll be ready in just a moment.`, () => {
        setLoadingWait(false);
      });
    }
  }, []);
  const safetlyHaltSpeech = "Your Safety is Our Priority Based on how your body responds to movement and your preferences, we couldn't create a safe plan for you right now. Your well-being is what matters most, and we recommend consulting with a healthcare professional to explore the best next steps. If you have any questions, Myra is here to help.";
  useEffect(() => {
    if (safetyHalt) {
      if (window.mayraCode && safetyHalt) {
        // Small delay to ensure clean stop
        setTimeout(() => {
          window.mayraCode.doSay(safetlyHaltSpeech, () => {
            console.log("safetlyHaltSpeech speech finished.");
            // setTimeout(() => {
            //   history.replace("/hard-stop");
            // }, 2000);
          });
        }, 500);
      }
    }
  }, [safetyHalt]);
  useEffect(() => {
    const initializeVoice = () => {
      if (window.mayraCode && typeof window.mayraCode.setIsVisible === "function") {
        if (VoiceService._ws?.readyState === WebSocket.OPEN) {
          VoiceService.sendMidJourneyData(recoveryScorePayload);
          setIsVoiceReady(true);
        }
      }
    };
    initializeVoice();
    const checkConnectionInterval = setInterval(() => {
      if (VoiceService._ws?.readyState === WebSocket.OPEN && !isVoiceReady) {
        initializeVoice();
      }
    }, 1000);
    const originalOnConnected = VoiceService._callbacks?.onConnected;
    VoiceService._callbacks.onConnected = () => {
      initializeVoice();
      if (originalOnConnected) originalOnConnected();
    };
    return () => {
      clearInterval(checkConnectionInterval);
      if (originalOnConnected) {
        VoiceService._callbacks.onConnected = originalOnConnected;
      }
    };
  }, [recoveryScorePayload, isVoiceReady]);

  useEffect(() => {
    if (!safetyHalt) {
      window.initFromUserGesture();
      window.currentCommandsAudio = {
        READY_TO_PROCEED: (val) => {
          console.log("Symptom NLU received:", val);
          //  Check if the action matches and value is true
          if (val === true) {
            setTimeout(() => {
              console.log("Clicked next", val);
              handleContinue();
            }, 2000);
          }
        },
        ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent) => {
          if (intent === "continue_command") {
            setTimeout(() => {
              handleContinue();
            }, 2000);
          }
        },
        MOVE_ON: (value, speech, intent) => {
          setTimeout(() => {
            handleContinue();
          }, 2000);
        },
      };
      window.initFromUserGesture();
      if (!loadingWait) {
        if (window.mayraCode && typeof window.mayraCode.setIsVisible === "function") {
          window.mayraCode.setIsVisible(true);
          // window.mayraCode.startFlow("recovery_score");
          window.mayraForwardCode = {
            midjourneyData: recoveryScorePayload,
          };
          window.mayraCode.startFlow("flow_recovery_compass_score", "recovery_score");
        }
      }
    }
  }, [loadingWait]);

  useEffect(() => {
    const saved = localStorage.getItem("assessmentData");
    if (!saved) {
      console.warn("No assessment data found in localStorage.");
      setError("No assessment data found. Please restart the assessment.");
      setLoadingWait(false);
      return;
    }

    let isMounted = true;
    const parsed = JSON.parse(saved);

    const transformedRequest = {
      painLocations: parsed.selectedZones || [],
      cpgClassification: parsed.cpgValue?.value || "",
      ...(parsed.subtypeQuestions && parsed.selfAssessmentAnswer
        ? {
            subjectiveResponses: {
              q1: parsed.subtypeQuestions?.value || "",
              q2a: parsed.selfAssessmentAnswer || "",
            },
          }
        : {}),
      symptomDuration: parsed.symptomDuration || "",
      preTestNPRS: parsed.painLevel || 0,
      probableSubtype: parsed.probableSubtype || "",
      degradation: parsed.degradation ?? null,
      timing: parsed.timing ?? null,
      signature: parsed.signature || false,
      current_conditions: parsed?.biometrics?.currentConditions || userConditions.current || "",
      pre_existing_conditions: parsed?.biometrics?.preExistingConditions || userConditions.pre_existing || "",

      romTest1: {
        testName: parsed.testName || "",
        symptomaticResponse: parsed.symptomResponse?.value || "",
        rpe: parsed.rpe || 0,
        movementQuality: parsed.romQuality || "",
        cvData: {
          rom: parsed.rom || [],
          duration: parsed.duration || [],
        },
      },
      ...(parsed.testName2 && parsed.symptomResponseConfirm
        ? {
            romTest2: {
              testName: parsed.testName2,
              symptomaticResponse: parsed.symptomResponseConfirm,
            },
          }
        : {}),

      biometrics: parsed.biometrics?.skipped
        ? { skipped: true }
        : {
            skipped: false,
            age: parsed.biometrics.age,
            activityLevel: parsed.biometrics.activityLevel,
            heightFt: parsed.biometrics.heightFt,
            heightIn: parsed.biometrics.heightIn,
            weightLbs: parsed.biometrics.weightLbs,
            floorCapability: parsed.biometrics.floorCapability,
            balance: parsed.biometrics.balance,
            goal: parsed.biometrics.goal || "",
            sessionPref: parsed.biometrics.sessionPref || "one",
            scheduleTime: parsed.biometrics.scheduleTime || "",
            scheduleDays: parsed.biometrics.scheduleDays || "",
            current_conditions: parsed?.biometrics?.currentConditions || userConditions.current || "",
            pre_existing_conditions: parsed?.biometrics?.preExistingConditions || userConditions.pre_existing || "",
          },
    };
    console.log("Transformed request payload for recovery score API: ", transformedRequest);

    setProgress(100);

    const abortController = new AbortController();

    let didFinish = false;

    (async () => {
      setError(null);
      setRetryAttempt(0);
      try {
        const payload = JSON.stringify(transformedRequest);
        const apiStartTime = Date.now();

        // configure retry attempts and timeouts as desired
        const {
          ok,
          response,
          attempt,
          error: fetchErr,
          permanentError,
          status,
          body,
        } = await fetchWithRetry(
          URL,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: payload,
          },
          {
            maxAttempts: 4,
            initialDelay: 800,
            factor: 2,
            jitter: true,
            timeout: 20000, // per-attempt timeout
            signal: abortController.signal,
          },
        );

        const apiLatencyMs = Date.now() - apiStartTime;
        if (!isMounted) return;

        if (ok && response) {
          // success path
          const result = response;
          setSafetyHalt(result.recoveryPlan?.safetyHalt || false);
          console.log("API Response for recovery score is : ", result);

          const updatedData = {
            ...parsed,
            finalPainSubtype: result?.userProfile.finalPainSubtype || "",
            finalCpgClassification: result?.userProfile.finalCpgClassification || "",
            finalScore: result.userProfile?.recoveryScore,
            finalComplexityLevel: result?.userProfile?.level || 1,
            readinessModifier: result?.userProfile?.planDetails.readinessModifier ?? 100,
            recoveryPlan: result.recoveryPlan || { exercises: [] },
            planRationaleSpeech: result?.recoveryPlan?.rationale || "",
            totalAdjustment: result?.userProfile?.totalAdjustment ?? result?.totalAdjustment ?? 0,
            rcsCalculated: result?.userProfile?.rcsCalculated ?? result?.rcsCalculated ?? 0,
            adjustmentDetails: result?.userProfile?.adjustmentDetails || result?.adjustmentDetails || {},
            completed_assessment: true,
            planGeneratedAt: new Date().toISOString(),
            aiLatencyMs: apiLatencyMs,
            exerciseCandidatesCount: result.recoveryPlan?.exercises?.length || 0,
          };

          console.log("API Response updated this data as : ", updatedData);

          updateAssessmentData(updatedData);
          localStorage.setItem("assessmentData", JSON.stringify(updatedData));
          setScoreData(updatedData);

          const localStorageAssessmentDataOld = localStorage.getItem("assessmentData");
          const rationaleSpeech = updatedData.planRationaleSpeech || localStorageAssessmentDataOld.rationale;
          window.mayraCode.doSayPreload(rationaleSpeech);

          setTimeout(() => {
            if (isMounted) setLoadingWait(false);
          }, 19000);

          // Analytics: success
          if (AnalyticsService && typeof AnalyticsService.trackStep === "function") {
            AnalyticsService.trackStep(updatedData);
          }

          didFinish = true;
        } else {
          console.log("API fetch attempt:", attempt);
          console.log("API fetch error/permanent failure:", fetchErr || `${status} - ${body}`);
          // handle permanent errors or final failure
          if (permanentError) {
            const message = `Request failed (${status}). Please contact support.`;
            setError(message);
            console.error("Permanent API error:", status, body);
          } else {
            const message = fetchErr?.message ? `Failed to contact server: ${fetchErr.message}` : "Empty response from API.";
            setError(message);
            console.error("Final fetch error after retries:", fetchErr);
          }

          if (AnalyticsService && typeof AnalyticsService.trackFailure === "function") {
            AnalyticsService.trackFailure({ reason: fetchErr?.message || "no-response", attempts: attempt || 0 });
          }

          // stop waiting spinner and allow manual retry
          setLoadingWait(false);
        }
      } catch (err) {
        if (!isMounted) return;
        if (err.name === "AbortError") {
          console.log("Fetch was aborted");
          // Do not set error; the user navigated away
          return;
        }
        console.error("Unexpected error fetching recovery score:", err);
        setError(err.message || "Unexpected error occurred.");
        setLoadingWait(false);
      }
    })();

    return () => {
      isMounted = false;
      abortController.abort();
    };
  }, []);
  // const rationaleSpeech = scoreData?.planRationaleSpeech || assessmentData.planRationaleSpeech;
  // let userName = localStorage.getItem("self_name") || "";
  // let fullSpeech = userName ? `${userName} , ${rationaleSpeech}` : rationaleSpeech;
  const handleContinue = () => {
    window.screenTracker.exitScreen("recovery_score", {
      exitReason: "score_viewed",
      completed: true,
    });
    const screenFlow = window.screenTracker.getScreenFlow();

    // const recoveryScoreSpeech = {
    //   type: "recovery_score_speech",
    //   speech: fullSpeech,
    // };
    // if (window.mayraCode && VoiceService._ws && VoiceService._ws.readyState === WebSocket.OPEN) {
    //   VoiceService._ws.send(JSON.stringify(recoveryScoreSpeech));
    // }
    const updatedData = { ...scoreData, viewed_plan: true, recovery_score_viewed: true, screenFlow: screenFlow, session_last_update: new Date().toISOString() };
    updateAssessmentData(updatedData);
    // Modified on Aug 7th - for user tracking
    AnalyticsService.trackStep(updatedData);
    history.replace("/screen-plan", { state: { scoreData: updatedData } });
  };
  const SafetyHaltBlock = () => (
    <div style={{ padding: 20 }}>
      <p style={{ fontSize: 20, fontWeight: "bold", color: "red", textAlign: "center" }}>Your Safety is Our Priority</p>
      <p style={{ marginTop: 10, textAlign: "center" }}>Based on how your body responds to movement and your preferences, we couldn't create a safe plan for you right now. Your well-being is what matters most, and we recommend consulting with a healthcare professional to explore the best next steps. If you have any questions, Myra is here to help.</p>
    </div>
  );
  return (
    <div className={styles.ScreenWrapper}>
      <div className={styles.ScreenModal}>
        {/* <Header showProgress={!scoreData?.finalScore?.total}/> */}
        <Header showProgress={loadingWait === false && !!scoreData?.finalScore && !error} />
        <div>
          {safetyHalt && <SafetyHaltBlock />}
          {!safetyHalt && error && (
            <div
              style={{
                color: "#ef4444",
                textAlign: "center",
                marginBottom: "1rem",
              }}
            >
              {error}
            </div>
          )}
          {/* Loader while waiting */}
          {(loadingWait === true || (!scoreData?.finalScore && !error && !safetyHalt)) && (
            <div className={styles.RSC_loaderWrapper}>
              <div className={styles.RSC_loaderText}>
                Myra is working with our Advanced AI to create your personalized Recovery Plan, designed with expert guidance. This will just take a moment
                {loadingDots}
              </div>
              <div className={styles.RSC_spinner}></div>
            </div>
          )}

          {loadingWait === false && scoreData?.finalScore && !safetyHalt && <RecoveryScoreComp score={scoreData?.finalScore} subtype={scoreData?.finalPainSubtype} complexityLevel={scoreData?.finalComplexityLevel} scoreData={scoreData} onContinue={handleContinue} />}
        </div>
      </div>
    </div>
  );
};

// custom notification Modal
const CustomNotificationModal = ({ visible, message, onClose }) => {
  if (!visible) return null;
  return (
    <div className={styles.CNMContainer}>
      <div className={styles.CNMOverlay}></div>
      <div className={styles.CNMModalWrapper}>
        <div className={styles.CNMModalBox}>
          <p className={styles.CNMMessage}>{message}</p>
          <button onClick={onClose} className={styles.CNMButton}>
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

const SPPlanMissionCard = ({ planFocusText }) => {
  return (
    <div className={styles.SPPlanInfoCard2}>
      <h3 className={styles.SPPlanMissionTitle}>Your Week 1 Mission</h3>
      <div className={styles.SPPlanFlex2}>
        {/* Focus */}
        <div className={styles.SPPlanSection2}>
          <svg className={styles.SPPlanIcon2} fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 21v-4m0 0V5a2 2 0 012-2h6.5l1 1H21l-3 6 3 6H8.5l-1-1H5a2 2 0 00-2 2zm9-13.5V9" />
          </svg>
          <span className={styles.SPPlanLabel2}>Focus</span>
          <span className={styles.SPPlanValue2}>{planFocusText}</span>
        </div>

        {/* Plus Sign */}
        <div className={styles.SPPlanOperator}>+</div>

        {/* Goal */}
        <div className={styles.SPPlanSection}>
          <svg className={styles.SPPlanIcon} fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
          </svg>
          <span className={styles.SPPlanLabel}>Goal</span>
          <span className={styles.SPPlanValue}>Consistency</span>
        </div>

        {/* Equal Sign */}
        <div className={styles.SPPlanOperator2}>=</div>

        {/* Result */}
        <div className={styles.SPPlanSection}>
          <svg className={styles.SPPlanIcon} fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
          </svg>
          <span className={styles.SPPlanLabel}>Result</span>
          <span className={styles.SPPlanValue}>5-15 Point Increase</span>
          <span className={styles.SPPlanSubtext}>in your recovery compass score</span>
        </div>
      </div>
    </div>
  );
};

// screenplan screen
export const ScreenPlan = () => {
  usePreventNavigation("/");
  useScrollToTop();
  const location = useLocation();
  const { state } = location.state || {};
  // Modified on Aug 7th - for user tracking
  const { updateAssessmentData } = useAssessment();
  const { setProgress } = useProgress();
  const assessmentData = state?.scoreData;
  console.log("data is : ", assessmentData);
  const localStorageAssessmentData = localStorage.getItem("assessmentData");
  const [isVoiceReady, setIsVoiceReady] = useState(false);

  const [firstName, setFirstName] = useState("");
  const [email, setEmail] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [visibleRationaleIds, setVisibleRationaleIds] = useState([]);
  const [showEmailPart, setShowEmailPart] = useState(false);
  const [isDetailsOpen, setIsDetailsOpen] = useState(false);
  const [detailsOpen, setDetailsOpen] = useState(false);
  const [isAudioPlaying, setIsAudioPlaying] = useState(false);
  const [speechInProgress, setSpeechInProgress] = useState(false);
  const detailsRef = useRef(null);
  const inputRef = useRef(null);
  let userName = localStorage.getItem("self_name") || "";
  const rationaleSpeech = assessmentData?.planRationaleSpeech || localStorageAssessmentData.rationale;
  let fullSpeech = userName ? `${userName} | ${rationaleSpeech}` : rationaleSpeech;
  let sessionId = window.trSessionId || localStorage.getItem("trSessionId");
  let screenPlanPayload = generatePayloadForScreen("plan_screen", assessmentData);
  useEffect(() => {
    let prevIsListening = VoiceService._isListening;
    const checkInterval = setInterval(() => {
      const currentIsListening = VoiceService._isListening;
      if (!prevIsListening && currentIsListening) {
        VoiceService.sendMidJourneyData(screenPlanPayload);
      }

      if (prevIsListening && !currentIsListening) {
        console.log("[Myra] Turned OFF");
        setIsVoiceReady(false);
      }
      prevIsListening = currentIsListening;
    }, 500);

    return () => clearInterval(checkInterval);
  }, []);

  useEffect(() => {
    if (window.mayraCode) {
      setDetailsOpen(true);
    }
    // VoiceService.proceedToRecoveryPlan(fullSpeech);
  }, []);
  useEffect(() => {
    window.initFromUserGesture();
    const initializeVoice = () => {
      if (window.mayraCode && typeof window.mayraCode.setIsVisible === "function") {
        if (VoiceService._ws?.readyState === WebSocket.OPEN) {
          VoiceService.sendMidJourneyData(screenPlanPayload);
          setIsVoiceReady(true);
        }
      }
    };
    initializeVoice();
    const checkConnectionInterval = setInterval(() => {
      if (VoiceService._ws?.readyState === WebSocket.OPEN && !isVoiceReady) {
        initializeVoice();
      }
    }, 1000);
    const originalOnConnected = VoiceService._callbacks?.onConnected;
    VoiceService._callbacks.onConnected = () => {
      initializeVoice();
      if (originalOnConnected) originalOnConnected();
    };
    return () => {
      clearInterval(checkConnectionInterval);
      if (originalOnConnected) {
        VoiceService._callbacks.onConnected = originalOnConnected;
      }
    };
  }, [screenPlanPayload, isVoiceReady]);
  useEffect(() => {
    // Track when user enters the plan screen
    window.screenTracker.enterScreen("plan_screen");

    // ... existing code ...

    return () => {
      // Cleanup - track exit if component unmounts
      window.screenTracker.exitScreen("plan_screen");
    };
  }, []);

  useEffect(() => {
    if (!assessmentData) {
      const storedData = localStorage.getItem("assessmentData");
      if (storedData) {
        // Redirect to recovery-score to regenerate the plan
        window.location.href = "/recovery-score";
      } else {
        // No data found, go to beginning
        window.location.href = "/";
      }
    }
  }, [assessmentData]);

  useEffect(() => {
    const el = detailsRef.current;
    if (!el) return;

    const handleToggle = () => setDetailsOpen(el.open);
    el.addEventListener("toggle", handleToggle);
    return () => el.removeEventListener("toggle", handleToggle);
  }, []);

  // Handle audio button click
  // Alternative Play Handler using mayraCode but with proper stop
  const handlePlayAudio = () => {
    let fullSpeech = userName ? `${userName} , ${rationaleSpeech}` : rationaleSpeech;

    if (window.mayraCode && fullSpeech) {
      // Small delay to ensure clean stop
      setTimeout(() => {
        window.mayraCode.doSay(fullSpeech, () => {
          console.log("Rationale speech finished.");
          setIsAudioPlaying(false);
          setSpeechInProgress(false);
        });

        // Update UI state immediately
        setIsAudioPlaying(true);
        setSpeechInProgress(true);
      }, 150); // Slightly longer delay for cleanup
    }
  };

  // Stop Audio Handler
  const handleStopAudio = () => {
    if (speechInProgress) {
      VoiceService.stopAllVoiceActivity();
      // Clear any pending callbacks
      VoiceService._callbacks.onAgentSpeechEndCustom = () => {};

      console.log("Speech completely stopped by user");
    }

    // Reset UI state
    setIsAudioPlaying(false);
    setSpeechInProgress(false);
  };

  useEffect(() => {
    return () => {
      // Clean up any ongoing speech when component unmounts
      if (speechInProgress) {
        handleStopAudio();
      }
    };
  }, [speechInProgress]);
  const toggleRationale = (id) => {
    setVisibleRationaleIds((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));
  };
  useEffect(() => {
    window.initFromUserGesture();
    window.currentCommandsAudio = {
      ANSWER_QNA_QUESTION: (value, speech, intent) => {
        if (intent === "signup_request") {
          setTimeout(() => {
            handleClick();
          }, 3000);
        }
      },
      ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent) => {
        if (intent === "continue_command") {
          setTimeout(() => {
            handleClick();
          }, 3000);
        }
      },
      MOVE_ON: (value, speech, intent) => {
        setTimeout(() => {
          handleClick();
        }, 3000);
      },
    };
    if (window.mayraCode && typeof window.mayraCode.setIsVisible === "function") {
      // Extract data from localStorage
      const localStorageAssessmentData = JSON.parse(localStorage.getItem("assessmentData"));
      const recoveryPlan = localStorageAssessmentData?.recoveryPlan || {};

      // Build userProfile with all required fields
      const userProfile = {
        // Pain and assessment data
        painLocations: localStorageAssessmentData?.selectedZones || [],
        cpgClassification: localStorageAssessmentData?.finalCpgClassification || "",
        subjectiveResponses: localStorageAssessmentData?.subtypeQuestions || {},
        symptomDuration: localStorageAssessmentData?.symptomDuration || "",
        preTestNPRS: localStorageAssessmentData?.painLevel || 0,
        probableSubtype: localStorageAssessmentData?.probableSubtype || "",
        finalPainSubtype: localStorageAssessmentData?.finalPainSubtype || "",
        recoveryScore: localStorageAssessmentData?.finalScore || 0,
        level: localStorageAssessmentData?.finalComplexityLevel || 3,

        // ROM test data
        romTest1: {
          testName: localStorageAssessmentData?.testName || "",
          symptomaticResponse: localStorageAssessmentData?.symptomResponse?.value || "TOLERABLE",
          rpe: localStorageAssessmentData?.rpe || 0,
        },
        romTest2: {
          testName: localStorageAssessmentData?.testName2 || "",
          symptomaticResponse: localStorageAssessmentData?.symptomResponseConfirm || "TOLERABLE",
        },

        // Biometrics
        biometrics: localStorageAssessmentData?.biometrics || {},

        // Additional calculated fields
        pillar1: localStorageAssessmentData?.pillar1 || 0,
        pillar2: localStorageAssessmentData?.pillar2 || 0,
        pillar3: localStorageAssessmentData?.pillar3 || 0,
        pillar4: localStorageAssessmentData?.pillar4 || 0,
        rcsCalculated: localStorageAssessmentData?.rcsCalculated || 0,
        totalAdjustment: localStorageAssessmentData?.totalAdjustment || 0,
        adjustmentDetails: localStorageAssessmentData?.adjustmentDetails || {},
        planDetails: localStorageAssessmentData?.planDetails || {},
      };

      // Build currentPlan
      const currentPlan = {
        exercises: recoveryPlan.exercises || [],
        estimatedTime: recoveryPlan.estimatedTime || "",
        rationale: recoveryPlan.rationale || "",
      };

      const qnaData = {
        userProfile: userProfile,
        currentPlan: currentPlan,
        planRationale: rationaleSpeech,
        sessionId: sessionId,
      };

      console.log("Sending QnA data to backend:", qnaData);

      window.mayraCode.setIsVisible(true);
      // window.mayraCode.startFlow("MyraQnAService");
      // VoiceService.proceedToRecoveryPlan(fullSpeech, localStorage.getItem("help_ai_pick") ? localStorage.getItem("help_ai_pick") : "gemini", qnaData); // -> gemini or claude
      VoiceService.sendMidJourneyData(screenPlanPayload);
      VoiceService.proceedToRecoveryPlan(fullSpeech, "claude", qnaData); // -> gemini or claude
    }
  }, [rationaleSpeech]);
  useEffect(() => {
    const el = detailsRef.current;
    if (!el) return;

    const handleToggle = () => setIsDetailsOpen(el.open);
    el.addEventListener("toggle", handleToggle);

    return () => el.removeEventListener("toggle", handleToggle);
  }, []);
  useEffect(() => {
    if (!window.trSessionId) {
      AnalyticsService.startSession();
    }

    window.screenTracker.enterScreen("screen_plan");
    setProgress(100);
  }, []);
  let { finalPainSubtype, recoveryPlan } = assessmentData || {};
  finalPainSubtype = undefined ? localStorageAssessmentData.finalPainSubtype : finalPainSubtype;
  const exercises = recoveryPlan?.exercises || [];
  const focus = recoveryPlan?.focus || "This plan is designed to help you recover.";
  const planFocusText = messaging.planFocus[finalPainSubtype];
  const goal = recoveryPlan?.goal || `The goal for this first week is to complete your sessions consistently and learn how your body responds to the movements. The key is consistency, not intensity. Many people in a similar situation see their score improve by <strong>5-15 points</strong> in the first one to two weeks.*<br><p class='text-xs italic mt-2'>*Your results may vary. The most important metric is feeling more confident and in control.</p>`;
  const estimatedTime = recoveryPlan?.estimatedTime || "15-20";
  const readinessModifier = assessmentData?.readinessModifier ?? 100;
  let readinessTier;
  if (readinessModifier >= 90) readinessTier = messaging.readinessTiers.READY_TO_GO;
  else if (readinessModifier >= 75) readinessTier = messaging.readinessTiers.CAUTIOUS_START;
  else if (readinessModifier >= 50) readinessTier = messaging.readinessTiers.GENTLE_APPROACH;
  else readinessTier = messaging.readinessTiers.STARTING_WITH_CARE;

  // Returns " — Left Leg" / " — Right Leg" / "" based on exercise definition
  const getPerformanceSideLabel = (ex) => {
    if (!ex.performance_side) return "";

    // For now assume lower back plan → legs
    // If you want arm/leg logic later, we extend here safely.
    return ` — ${ex.performance_side} Leg`;
  };

  useEffect(() => {
    if (!assessmentData) return; // wait for data

    const updatedAssessmentData = {
      ...assessmentData,
      exercises,
      final_conversion_type: "signup",
    };

    updatedAssessmentData.analyticsId = window.trSessionId;

    // Encode full data
    const encoded = btoa(unescape(encodeURIComponent(JSON.stringify(updatedAssessmentData))));
    // Track analytics immediately when screen opens
    try {
      AnalyticsService.saveFullData(encoded);
    } catch (err) {
      console.error("Error tracking analytics on screen open:", err);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assessmentData]);

  const handlePlan = (e) => {
    e.preventDefault();
    const updatedAssessmentData = { ...assessmentData, exercises, final_conversion_type: "email_plan" };
    updateAssessmentData(updatedAssessmentData);

    // Modified on Aug 7th - for user tracking
    AnalyticsService.trackStep(updatedAssessmentData);
    // await AnalyticsService.saveFullData(encoded)
    console.log("updated assesment data : ", updatedAssessmentData);

    showCustomNotification("Your recovery plan has been sent to the provided email address.");

    fetch(URLPlan, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ name: firstName, email: email, assessment: updatedAssessmentData }),
    })
      .then(async (res) => {
        if (!res.ok) {
          throw new Error("Failed to fetch analysis");
        }
        console.log("response from api plan is : ", res);
        return res.json();
      })
      .then((result) => {
        if (!result) {
          console.error("Empty response from API.");
          return;
        }
      })
      .catch((err) => {
        console.error("Failed to analyze assessment:", err);
      });
  };
  const showCustomNotification = (msg) => {
    setModalMessage(msg);
    setModalVisible(true);
  };
  const handleClick = async () => {
    window.screenTracker.exitScreen("plan_screen", {
      exitReason: "signup_initiated",
      completed: true,
    });
    const screenFlow = window.screenTracker.getScreenFlow();

    const finalGSADuration = window.timeTracker.getGSADuration();
    const updatedAssessmentData = { ...assessmentData, exercises, final_conversion_type: "signup", gsaDurationSec: finalGSADuration, viewed_plan: true, completed_assessment: true, screenFlow: screenFlow, session_last_update: new Date().toISOString() };
    updateAssessmentData(updatedAssessmentData);
    AnalyticsService.trackStep(updatedAssessmentData);

    try {
      if (window.closePoseAll) {
        window.closePoseAll();
      }
    } catch (e) {
      console.log(e);
    }

    try {
      if (window.destroyOwnedResources) {
        window.destroyOwnedResources();
      }
    } catch (e) {
      console.log(e);
    }

    if (window.mayraCode) {
      if (window.mayraCode.setOnMicEnabled) {
        window.mayraCode.setOnMicEnabled(null);
      }
      if (window.mayraCode.setIsVisible) {
        window.mayraCode.setIsVisible(false);
      }

      if (window.VoiceService && window.VoiceService.destroyMyraCompletely) {
        window.VoiceService.destroyMyraCompletely();
      }

      window.mayraCode = null;
      window.startFlow = null;
      window.currentCommandsAudio = {};
    }
    sessionStorage.removeItem("voiceService_wasListening");
    sessionStorage.removeItem("voiceService_currentFlow");
    var subDomain = "live";
    if (window.location.host !== "www.startfreept.com" && window.location.host !== "startfreept.com") {
      subDomain = "uat";
    }
    window.timeTracker.reset(); // resets timer
    console.log("sending data");

    window.location.replace("https://" + subDomain + ".virdiohealth.com/register?self-assessment=true&fromsite=" + window.location.host + "&data=" + window.trSessionId);
  };

  console.log("assesment data : ", assessmentData);
  const history = useHistory();

  if (!assessmentData) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "black",
        }}
      >
        Redirecting to your recovery plan...
      </div>
    );
  }
  return (
    <div className={styles.ScreenWrapper}>
      <div className={styles.ScreenModal}>
        <Header showProgress={false} />
        <div>
          <div className={styles.recoveryHeaderWrapper} style={{ position: "relative" }}>
            <button
              onClick={() => history.replace("/recovery-score")}
              style={{
                position: "absolute",
                top: "-20",
                left: "-10",
                color: "#6B7280", // text-gray-500
                transition: "color 0.2s",
                backgroundColor: "transparent",
                border: "none",
                outline: "none",
                cursor: "pointer",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.color = "#374151")} // hover:text-gray-700
              onMouseLeave={(e) => (e.currentTarget.style.color = "#6B7280")}
            >
              <svg style={{ width: "1.5rem", height: "1.5rem" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
              </svg>
            </button>
            <h2 className={styles.recoveryHeaderTitle}>Your Week 1 Recovery Plan</h2>
            <svg className={styles.recoveryHeaderLine} viewBox="0 0 104 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M103.39 10.211C103.39 10.211 72.841 2.35103 51.644 2.35103C30.447 2.35103 0.609985 10.211 0.609985 10.211" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </div>
          <SPPlanMissionCard planFocusText={planFocusText} />
          {/* Exercise Summary */}
          <details className={styles.exerciseDetails} ref={detailsRef} open={detailsOpen}>
            <summary className={styles.SPsummary}>
              <div className={styles.SPsummaryHeader}>
                <div className={styles.SPsummaryHeaderText}>
                  <span>This Week's Program</span>
                  {/* Audio Button */}
                  {/* Audio Buttons - Separate Play/Pause */}
                  {isAudioPlaying ? (
                    <button className={`${styles.SPaudioButton} ${styles.isPlaying}`} onClick={handleStopAudio} type="button" aria-label="Stop my analysis">
                      {/* Pause Icon - Two Bars */}
                      <svg className={styles.iconPause} fill="currentColor" viewBox="0 0 24 24">
                        <path d="M8 5h3v14H8V5zm5 0h3v14h-3V5z" />
                      </svg>
                    </button>
                  ) : (
                    <button className={styles.SPaudioButton} onClick={handlePlayAudio} type="button" aria-label="Play my analysis">
                      {/* Play Icon - Talking Head */}
                      <svg className={styles.iconPlay} fill="currentColor" viewBox="0 0 24 24">
                        {/* Path for a standard right-pointing triangle */}
                        <path d="M8 5v14l11-7z" />
                      </svg>
                    </button>
                  )}
                </div>
                <svg className={styles.SPsummaryIcon} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d={
                      isDetailsOpen
                        ? "M19 15l-7-7-7 7" // Up arrow
                        : "M19 9l-7 7-7-7" // Down arrow
                    }
                  />
                </svg>
              </div>
              <p className={styles.SPsummaryText}>
                Your 1st week consists of <strong>{recoveryPlan?.exercises.length} exercises</strong>. This session should take <strong>{estimatedTime} minutes</strong> and is recommended <strong>3 times this week</strong>.
              </p>
            </summary>

            <div className={styles.exerciseList}>
              {recoveryPlan?.exercises.map((ex, i) => {
                const rationaleId = `rationale-${i}`;
                const isVisible = visibleRationaleIds.includes(rationaleId);
                const hasValidImage = typeof ex.image === "string" && ex.image.trim().length > 0;

                return (
                  <div key={rationaleId} className={styles.exerciseCard}>
                    <div className={styles.exerciseCardContent}>
                      {/* Exercise name in circle */}
                      <div className={styles.exerciseThumbnail} style={{ backgroundColor: hasValidImage ? "transparent" : "#e2e8f0" }}>
                        {hasValidImage ? <img src={ex.image} alt={ex.name} className={styles.exerciseThumbnailImage} /> : <span className={styles.exerciseThumbnailLabel}>{ex.name?.replace("*", "")}</span>}
                      </div>

                      {/* Text content */}
                      <div className={styles.exerciseTextBlock}>
                        <h4 className={styles.exerciseCardTitle}>
                          {ex.name}
                          {getPerformanceSideLabel(ex)}
                          {ex.rationale && (
                            <button onClick={() => toggleRationale(rationaleId)} className={styles.rationaleToggle}>
                              <svg className={styles.rationaleIcon} fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" clipRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" />
                              </svg>
                            </button>
                          )}
                        </h4>
                        <p className={styles.exerciseDescription}>
                          {ex.sets} Sets of {ex.reps} Reps
                          {ex.hold ? ` | ${ex.hold}s hold` : ""}
                        </p>
                      </div>
                    </div>

                    {ex.rationale && isVisible && (
                      <div className={styles.exerciseRationale}>
                        <p className={styles.rationaleText}>
                          <span className={styles.rationaleLabel}>Why it helps:</span> {ex.rationale}
                        </p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </details>

          <div className={styles.startRecInfoCard}>
            <h3 className={styles.startRecHeading}>Sign Up to Continue Your Recovery Journey with Virdio Health</h3>
            <p className={styles.startRecSubheading}>You took the first step, and it felt amazing! Now, let us help you build on your progress:</p>
            <ul className={styles.startRecList}>
              <li className={styles.startRecItem}>
                <svg className={styles.startRecIcon} fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"></path>
                </svg>
                <span>AI-powered guidance & Augmented Reality exercises</span>
              </li>
              <li className={styles.startRecItem}>
                <svg className={styles.startRecIcon} fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"></path>
                </svg>
                <span>Weekly Recovery Compass updates</span>
              </li>
              <li className={styles.startRecItem}>
                <svg className={styles.startRecIcon} fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"></path>
                </svg>
                <span>Reminders, Progress reports, and so much more</span>
              </li>
            </ul>
            <button onClick={handleClick} className={styles.SPctaButton} style={{ padding: "15px 0" }}>
              Sign Up to Start Your Recovery Today
            </button>
          </div>
          <CustomNotificationModal visible={modalVisible} message={modalMessage} onClose={() => setModalVisible(false)} />

          {/* Email Option */}
          <summary
            className={styles.sendPlanSummary}
            onClick={() => {
              setShowEmailPart(true);

              setTimeout(() => {
                if (inputRef.current) {
                  inputRef.current.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                    inline: "nearest",
                  });
                  inputRef.current.focus({ preventScroll: true });
                }
              }, 50);
            }}
          >
            Send me the plan
          </summary>

          {showEmailPart && (
            <div className={styles.SPemailContainer}>
              <form onSubmit={handlePlan} className={styles.SPemailForm}>
                <input type="text" autoComplete="off" value={firstName} onChange={(e) => setFirstName(e.target.value)} placeholder="Your first name" required className={styles.SPemailInput} ref={inputRef} />
                <input type="email" autoComplete="off" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Enter your email" required className={styles.SPemailInput} />
                <button type="submit" className={styles.SPemailButton}>
                  Send Plan
                </button>
              </form>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
